webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(0);

var _vue2 = _interopRequireDefault(_vue);

var _vueI18n = __webpack_require__(13);

var _vueI18n2 = _interopRequireDefault(_vueI18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueI18n2.default);
var i18n = new _vueI18n2.default({
  messages: {
    ch: __webpack_require__(109),
    en: __webpack_require__(110)
  }

});

exports.default = i18n;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(49)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(21),
  /* template */
  __webpack_require__(98),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(53)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(22),
  /* template */
  __webpack_require__(102),
  /* scopeId */
  "data-v-c0f9eed6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(48)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(16),
  /* template */
  __webpack_require__(97),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIgAAACICAMAAAALZFNgAAAAtFBMVEX///////////////8AAAD///////////8zP1zn6OxbZX2rsLxOWXKfpbL+/v76+vvk5eo1QV7AxM7Y2uGRl6dHUmy2usVRW3RNWHE+SWU4RGD29vju7/HV195gaoFfaIDz9PXy8vTr7O/M0NfIzNSorrqkqbdjbYTm6Ovf4eXQ09q9wcumq7iVnKt2fpJvd4xWYXnFydG5vcixtsGMk6OKkaOFjJ5ocYhCTWius7+hprRLVnCO+gqyAAAAB3RSTlOt8SbvAPMoZ28DBAAAAm9JREFUeNrt3Elzm0AQhmEsO/5acgRi0y7ZkrXvXuMk//9/BTQXqREeDu4ylernQnGAemuaggs1zk3FucI3u3IqN07lGiVwXXEclILz/XMxfpRkQQAN0RAN0RAN0RBGQzgN4TSE0xBOQzgN4TSE0xBOQzgN4TQka7JH1n6CT0mEeO0ncE9tDxYCo2keXJxzD01YSIS4tRcAvUFzWp82Bz0ALzUXNgIhmPxdzOY+Gf58tognsBEJGcd0Lh7DRiDEnXaI60wtsxEI6e3okl0P+SRCHoZ02f0D8kiEeHPK88tDDomQN0rU+mHn9AEJ+zVKRMghEDKg1Ba4Px0KsKWEP8AlIiFmMHGw8U9C/E0Qm+HgEomQkD4XIksk5M0SEiFLJKRtCakhSyJkRBZ+D5xIyIBsluBEQsKaTQjua0O856i+QDGNevTsISEQ8nBPRN0A4582Y6y75rsjEvJOqU6/SjbVUYdS7xAJ+aCjZoGQpjl+QCSEjLsCIXdkQEM0REM0REM0REM05CtD2nQUFAgJzLENkZCZublXIMRrUWoGkRD31SdqLVEgBMsDkf/qQiAkVQ1WLgqFwF0FVRgCIUaREE4kpE82fXAiIWhZOlrIEglZW0LWyBIJQdCifK0AFvaQ4kaNRkRGI0VG1GiMkEcg5KhOxunrv265RkM4kZA/ZQm505Cyhvymoy5SXXOygYVESEhHQ6SG5mQFC4kQ7CjhPyL16FNiDxuREG8bd4dJhykZduPIg9V//JOChpzTEE5DOA3hNITTEE5DOA3hNITTEE5DOA3hNITTEE5DOA0RV56NUEqyJI5zW47Ncm5Ls33QP/VVE8UhmfdiAAAAAElFTkSuQmCC"

/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIgAAACICAMAAAALZFNgAAAAvVBMVEX///////////////8AAAD///////////8zP1xATGeFjJ6gpbPz8/U8SGT+/v7u7/Hk5ena3OKkqrdET2qLkqPV2N7Q09qrsLz8/Py8wMq1ucSUmqmBiZt7hJdud41cZn5RXHVIU203Q2A0QF35+frh4ubd3+TKztbBxc6wtMCcorCPlqZ3fpJze5Bha4JZY3vo6ey5vceZn612gJNqc4lmcIdmb4VVX3hMV3DHy9OnrbnGytKiqLZQWnNtdox3rC8XAAAAB3RSTlPwrfMnACglsLAVVgAAAxxJREFUeNrt3OlOIkEUhmFQZz5AoVlkF5RFRHZREbe5/8saB+c4mQ+w2s6pQMx5/5l0ise2+3QBibGjn/EYdlws/vModrhzxp/eGHHsRfHYXpwQ4GBPHIBBDGIQgxjEIJRBOINwBuEMwhmEMwhnEM4gnEE4g3AG4XYISSeilNaHXESCXOhD7iNB7vUhjUiQhj5kGAky1IfkI0Hy+pCbSJAbfUgpEqSkD8lGgmT1Id1IkK4+BMmPaZl09TGFk/AAeZDVq3BVlUMffEDuwt+S13LonQ/Imaxeh6tjOfTMB6QefvU6mXUhZVm9CVcpOfRJFcJX4Dlc3dJ1rQspyuotvDdPbWtJg1UXMpPV23jvPOFs5gNS6cjygdzPrjoVHxAUZP1e2K1SAfABmcr6V1h16oRM4QXSpE3G3AlpAj4gKZrxxeMtndPo04bMw87LsRw4hxdIOewvOpEDy4APSF/W/4XPe5UD+4APSJFmvPvdaRFeIAHNePemMgB8QDJtmfEnm+vSNrudAXxA0Ep8Xn3D09EDxP2UO5aLmq4ldcjYASnTjnUMSQ1CD5fT7KoUQWpYNZCfU5CUIYMPyOb35X3yDiCpQeicj7CqRpAr2iheQ1KGPNPnQFcEKdJnS8+QlCE5+mSsR5BLekuYg6QMCWjnlcm93Mk4T46feryTCyApQ9CWl6hA6j4Op+nmSzHDe1vZZHuBLAUShDlvS0h6EN5o5MJcSRNI6pCRvMYjtvdIN7kqhEfrJN/LYFOZXH5CY88H5Djxr0LjOruGGCfXn4E+IDxKl2c3wV9E72lU2Pjo0YbIKOU6D6f9XPlWEOsT3wvkMuGOB60XyMmXICeQ1CFI639nxBD9b49eIXmALL4AWUDyACkNp51Qis50WIKkA+GCasr1B7pIVQNQOhBuVmu0tiBajdoMjnQg0uX6FCuMyo7ZoQfhh0szLTdrM5/LwJ0ahKuUBovkYlCqIHzf5Cv5/zMIZxDOIJxBOINwBuEMwhmEMwhnEM4gnEE4g3AG4QzCGYT7xpA9kRzsz7+G+bEXp+SNcXQYP8COO4gfHv0G6rIdN9lwQaIAAAAASUVORK5CYII="

/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(0);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _vue2.default();

/***/ }),
/* 10 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon_Window@2x.b3a0462.png";

/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 13 */,
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(0);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(105);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _technology = __webpack_require__(84);

var _technology2 = _interopRequireDefault(_technology);

var _index = __webpack_require__(74);

var _index2 = _interopRequireDefault(_index);

var _about = __webpack_require__(71);

var _about2 = _interopRequireDefault(_about);

var _devolop = __webpack_require__(72);

var _devolop2 = _interopRequireDefault(_devolop);

var _join = __webpack_require__(75);

var _join2 = _interopRequireDefault(_join);

var _solution = __webpack_require__(81);

var _solution2 = _interopRequireDefault(_solution);

var _product = __webpack_require__(76);

var _product2 = _interopRequireDefault(_product);

var _product3 = __webpack_require__(77);

var _product4 = _interopRequireDefault(_product3);

var _product5 = __webpack_require__(78);

var _product6 = _interopRequireDefault(_product5);

var _product7 = __webpack_require__(79);

var _product8 = _interopRequireDefault(_product7);

var _solution3 = __webpack_require__(82);

var _solution4 = _interopRequireDefault(_solution3);

var _solution5 = __webpack_require__(83);

var _solution6 = _interopRequireDefault(_solution5);

var _download = __webpack_require__(73);

var _download2 = _interopRequireDefault(_download);

var _software = __webpack_require__(80);

var _software2 = _interopRequireDefault(_software);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);
var router = new _vueRouter2.default({
  routes: [{
    path: '/',
    name: 'index',
    component: _index2.default,
    meta: {
      title: "威尔云VRVIU - 全球领先的高清视频云服务",
      description: "威尔云是全球领先的VR高清直播云服务，支持高清4K/6K/8K的低带宽、低延迟，多终端、多场景的推流播放，并能为您节省70%带宽成本。",
      title_en: "VRVIU - The Highway to Ultra HD",
      description_en: "VRVIU Cloud provides the world’s leading high-definition VR live service, and helps you save 70% bandwidth cost."
    }
  }, {
    path: '/technology',
    name: 'technology',
    component: _technology2.default,
    meta: {
      title: "核心技术 - 威尔云 VRVIU",
      description: "威尔云 · 创建VR高速公路；挑战高清极限：4K，6K，8K；上行带宽节省70%，下行带宽节省70%；超低视角切换延迟；智能编解码；专利音频编解码…",
      title_en: "Technology - VRVIU",
      description_en: "Higher resolution 4K/6K/8K at 70% less upload/download bandwidth cost. Supports stable 24/7 high concurrent streaming, intelligent codec and 3D sound in VR."
    }
  }, {
    path: '/about',
    name: 'about',
    component: _about2.default,
    meta: {
      title: "关于我们 - 威尔云 VRVIU",
      description: "我们致力于“VR高速公路”的建设，让用户在现有的带宽和技术条件下享受到身临其境的VR体验。",
      title_en: 'About Us - VRVIU',
      description_en: "VRVIU brings bandwidth-hungry video to the global mass market while overcoming current internet infrastructure constraints."

    }
  }, {
    path: '/devolop',
    name: 'devolop',
    component: _devolop2.default,
    meta: {
      title: "SDK - 威尔云 VRVIU",
      description: "7x24小时稳定直播；高性能，低消耗；秒开，流畅切换；多开发环境…",
      title_en: "SDK - VRVIU",
      description_en: "Providing instant start-up, smooth playback, and cross-platform SDK."
    }
  }, {
    path: '/software',
    name: 'software',
    component: _software2.default,
    meta: {
      title: "Software - 威尔云 VRVIU",
      description: "7x24小时稳定直播；高性能，低消耗；秒开，流畅切换；多开发环境…",
      title_en: "Software - VRVIU",
      description_en: "Providing instant start-up, smooth playback, and cross-platform SDK."
    }
  }, {
    path: '/join',
    name: 'join',
    component: _join2.default,
    meta: {
      title: "加入我们 - 威尔云 VRVIU",
      description: "我们致力于“VR高速公路”的建设，让用户在现有的带宽和技术条件下享受到身临其境的VR体验。",
      title_en: "Join Us - VRVIU",
      description_en: "VRVIU brings bandwidth-hungry video to the global mass market while overcoming current internet infrastructure constraints."
    }
  }, {
    path: '/product',
    name: 'product',
    component: _product2.default,
    meta: {
      title: "产品 - 威尔云 VRVIU",
      description: "我们致力于“VR高速公路”的建设，让用户在现有的带宽和技术条件下享受到身临其境的VR体验。",
      title_en: "Product - VRVIU",
      description_en: "VRVIU brings bandwidth-hungry video to the global mass market while overcoming current internet infrastructure constraints."
    }
  }, {
    path: '/product1',
    name: 'product1',
    component: _product4.default,
    meta: {
      title: "产品 - 威尔云 VRVIU",
      description: "我们致力于“VR高速公路”的建设，让用户在现有的带宽和技术条件下享受到身临其境的VR体验。",
      title_en: "Product - VRVIU",
      description_en: "VRVIU brings bandwidth-hungry video to the global mass market while overcoming current internet infrastructure constraints."
    }
  }, {
    path: '/product2',
    name: 'product2',
    component: _product6.default,
    meta: {
      title: "产品 - 威尔云 VRVIU",
      description: "我们致力于“VR高速公路”的建设，让用户在现有的带宽和技术条件下享受到身临其境的VR体验。",
      title_en: "Product - VRVIU",
      description_en: "VRVIU brings bandwidth-hungry video to the global mass market while overcoming current internet infrastructure constraints."
    }
  }, {
    path: '/product3',
    name: 'product3',
    component: _product8.default,
    meta: {
      title: "产品 - 威尔云 VRVIU",
      description: "我们致力于“VR高速公路”的建设，让用户在现有的带宽和技术条件下享受到身临其境的VR体验。",
      title_en: "Product - VRVIU",
      description_en: "VRVIU brings bandwidth-hungry video to the global mass market while overcoming current internet infrastructure constraints."
    }
  }, {
    path: '/solution',
    name: 'solution',
    component: _solution2.default,
    meta: {
      title: "解决方案 - 威尔云 VRVIU",
      description: "180° 3D：2M带宽看4K，360°全景：视角切换延迟零延迟，威尔云6大特性，多平台适配。",
      title_en: "Solutions - VRVIU",
      description_en: "180° 3D: 4K quality at 2Mbps, 360° VR: zero-perceived view switching latency."
    }
  }, {
    path: '/solution1',
    name: 'solution1',
    component: _solution4.default,
    meta: {
      title: "解决方案 - 威尔云 VRVIU",
      description: "180° 3D：2M带宽看4K，360°全景：视角切换延迟零延迟，威尔云6大特性，多平台适配。",
      title_en: "Solutions - VRVIU",
      description_en: "180° 3D: 4K quality at 2Mbps, 360° VR: zero-perceived view switching latency."
    }
  }, {
    path: '/solution2',
    name: 'solution2',
    component: _solution6.default,
    meta: {
      title: "解决方案 - 威尔云 VRVIU",
      description: "180° 3D：2M带宽看4K，360°全景：视角切换延迟零延迟，威尔云6大特性，多平台适配。",
      title_en: "Solutions - VRVIU",
      description_en: "180° 3D: 4K quality at 2Mbps, 360° VR: zero-perceived view switching latency."
    }
  }, {
    path: '/download',
    name: 'download',
    component: _download2.default,
    meta: {
      title: "下载Demo - 威尔云 VRVIU",
      description: "下载即可体验威尔云技术处理后，多种VR场景下(包括秀场、游戏、体育）适用的视频。",
      title_en: "Download - VRVIU",
      description_en: "Experience our quality 4K streaming in sporting concerts, and eSports through our demo."
    }
  }]
});

function setTitle(t) {
  document.title = t;
  var i = document.createElement('iframe');
  i.src = '//m.baidu.com/favicon.ico';
  i.style.display = 'none';
  i.onload = function () {
    setTimeout(function () {
      i.remove();
    }, 9);
  };
  document.body.appendChild(i);
}
router.beforeEach(function (to, from, next) {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
  if (localStorage.locale) {
    if (localStorage.locale == "en") {
      setTitle(to.meta.title_en);
    } else {
      setTitle(to.meta.title);
    }
  } else {
    var language = navigator.language;
    if (language.indexOf('zh') > -1) {
      setTitle(to.meta.title);
    } else if (language.indexOf('en') > -1) {
      setTitle(to.meta.title_en);
    }
  }

  next();
});
exports.default = router;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(44)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(17),
  /* template */
  __webpack_require__(93),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});


var getMousePosition = function getMousePosition(e) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'x';

    if (type === 'x') {
        return e.pageX;
    }
    return e.pageY;
};
var pad = function pad(val) {
    val = Math.floor(val);
    if (val < 10) {
        return '0' + val;
    }
    return val + '';
};
var timeParse = function timeParse(sec) {
    var min = 0;
    min = Math.floor(sec / 60);
    sec = sec - min * 60;
    return pad(min) + ':' + pad(sec);
};
exports.default = {
    props: {
        sources: Array,
        options: {
            type: Object,
            default: function _default() {
                return {
                    autoplay: false,
                    volume: 0.9,
                    poster: ''
                };
            }
        }
    },
    data: function data() {
        return {
            $video: null,
            video: {
                $videoSlider: null,
                len: 0,
                current: 0,
                loaded: 0,
                moving: false,
                displayTime: '00:00',
                pos: {
                    start: 0,
                    width: 0,
                    innerWidth: 0,
                    current: 0
                }
            },
            volume: {
                $volBox: null,
                muted: false,
                percent: 60,
                moving: false,
                pos: {
                    start: 0,
                    width: 0,
                    innerWidth: 0,
                    current: 0
                }
            },
            player: {
                $player: null,
                pos: null
            },
            tmp: {
                contrlHideTimer: null
            },
            state: {
                contrlShow: true,
                vol: 0.5,
                currentTime: 0,
                fullScreen: false,
                playing: false
            }
        };
    },
    ready: function ready() {
        this.init();
    },
    mounted: function mounted() {
        this.init();
    },
    beforeDestroy: function beforeDestroy() {
        document.body.removeEventListener('mousemove', this.mouseMoveAction);
        document.body.removeEventListener('mouseup', this.mouseUpAction);
    },

    methods: {
        init: function init() {
            this.$video = this.$el.getElementsByTagName('video')[0];
            this.initCore();
            if (this.options.autoplay) {
                this.play();
            }
            document.body.addEventListener('mousemove', this.mouseMoveAction, false);
            document.body.addEventListener('mouseup', this.mouseUpAction, false);
        },
        initCore: function initCore() {
            this.initVol();
            this.initVideo();
            this.initPlayer();
            var vol = this.options.volume || 0.9;
            this.setVol(vol);
        },
        initPlayer: function initPlayer() {
            var $player = this.$el.getElementsByClassName('__cov-video-container')[0];
            this.player.pos = $player.getBoundingClientRect();
            this.player.$player = $player;
        },
        initVol: function initVol() {
            var $volBox = this.$el.getElementsByClassName('__cov-contrl-vol-slider')[0];
            var $volInner = $volBox.getElementsByClassName('__cov-contrl-vol-inner')[0];
            this.volume.$volBox = $volBox;
            this.volume.pos.innerWidth = $volInner.getBoundingClientRect().width;
            this.volume.pos.start = $volBox.getBoundingClientRect().left;
            this.volume.pos.width = $volBox.getBoundingClientRect().width - this.volume.pos.innerWidth;
        },
        initVideo: function initVideo() {
            var $videoSlider = this.$el.getElementsByClassName('__cov-contrl-video-slider')[0];
            var $videoInner = $videoSlider.getElementsByClassName('__cov-contrl-video-inner')[0];
            this.$videoSlider = $videoSlider;
            this.video.pos.start = $videoSlider.getBoundingClientRect().left;
            this.video.pos.innerWidth = $videoInner.getBoundingClientRect().width;
            this.video.pos.width = $videoSlider.getBoundingClientRect().width - this.video.pos.innerWidth;
            this.getTime();
        },
        mouseEnterVideo: function mouseEnterVideo() {
            if (this.tmp.contrlHideTimer) {
                clearTimeout(this.tmp.contrlHideTimer);
                this.tmp.contrlHideTimer = null;
            }
            this.state.contrlShow = true;
        },
        mouseLeaveVideo: function mouseLeaveVideo(e) {
            var _this = this;

            if (this.tmp.contrlHideTimer) {
                clearTimeout(this.tmp.contrlHideTimer);
            }
            this.tmp.contrlHideTimer = setTimeout(function () {
                _this.state.contrlShow = false;
                _this.tmp.contrlHideTimer = null;
            }, 2000);
        },
        toggleContrlShow: function toggleContrlShow() {
            this.state.contrlShow = !this.state.contrlShow;
        },
        getTime: function getTime() {
            var _this2 = this;

            this.$video.addEventListener('durationchange', function (e) {
                console.log(e);
            });
            this.$video.addEventListener('progress', function (e) {
                _this2.video.loaded = (-1 + _this2.$video.buffered.end(0) / _this2.$video.duration) * 100;
            });
            this.video.len = this.$video.duration;
        },
        setVideoByTime: function setVideoByTime(percent) {
            this.$video.currentTime = Math.floor(percent * this.video.len);
        },
        play: function play() {
            var _this3 = this;

            this.state.playing = !this.state.playing;
            if (this.$video) {
                if (this.state.playing) {
                    this.$video.play();
                    this.mouseLeaveVideo();
                    this.$video.addEventListener('timeupdate', this.timeline);
                    this.$video.addEventListener('ended', function (e) {
                        _this3.state.playing = false;
                        _this3.video.pos.current = 0;
                        _this3.$video.currentTime = 0;
                    });
                } else {
                    this.$video.pause();
                }
            }
        },
        timeline: function timeline() {
            var percent = this.$video.currentTime / this.$video.duration;
            this.video.pos.current = (this.video.pos.width * percent).toFixed(3);
            this.video.displayTime = timeParse(this.$video.duration - this.$video.currentTime);
        },
        volMove: function volMove(e) {
            this.initVol();
            this.volume.moving = true;
        },
        videoMove: function videoMove(e) {
            this.initVideo();
            this.video.moving = true;
        },
        slideClick: function slideClick(e) {
            this.videoSlideMove(e);
        },
        volSlideClick: function volSlideClick(e) {
            this.volSlideMove(e);
        },
        volMuted: function volMuted() {
            this.$video.muted = !this.$video.muted;
            this.volume.muted = this.$video.muted;
        },
        setVol: function setVol(val) {
            if (this.$video) {
                this.volume.pos.current = val * this.volume.pos.width;
                this.volume.percent = val * 100;
                this.$video.volume = val;
            }
        },
        fullScreen: function fullScreen() {
            if (!this.state.fullScreen) {
                this.state.fullScreen = true;
                this.$video.webkitRequestFullScreen();
            } else {
                this.state.fullScreen = false;
                document.webkitCancelFullScreen();
            }
            setTimeout(this.initVideo, 200);
        },
        mouseMoveAction: function mouseMoveAction(e) {
            if (this.volume.moving) {
                this.volSlideMove(e);
            }
            if (this.video.moving) {
                this.videoSlideMove(e);
            }
            this.contrlHider(e);
        },
        contrlHider: function contrlHider(e) {
            var x = getMousePosition(e, 'x');
            var y = getMousePosition(e, 'y');
            if (!this.player.pos) return;
            if (x > this.player.pos.left && x < this.player.pos.left + this.player.pos.width) {
                if (y > this.player.pos.top + this.player.pos.height * 0.6 && y < this.player.pos.top + this.player.pos.height) {
                    return this.mouseEnterVideo();
                }
            }
            return this.mouseLeaveVideo();
        },
        volSlideMove: function volSlideMove(e) {
            var x = getMousePosition(e) - this.volume.pos.start;
            if (x > 0 && x < this.volume.pos.width) {
                this.setVol(x / this.volume.pos.width);
            }
        },
        videoSlideMove: function videoSlideMove(e) {
            var x = getMousePosition(e) - this.video.pos.start;
            if (x > 0 && x < this.video.pos.width) {
                this.video.pos.current = x;
                this.setVideoByTime(x / this.video.pos.width);
            }
        },
        mouseUpAction: function mouseUpAction(e) {
            this.volume.moving = false;
            this.video.moving = false;
        }
    }
};

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(0);

var _vue2 = _interopRequireDefault(_vue);

__webpack_require__(35);

var _vueResource = __webpack_require__(104);

var _vueResource2 = _interopRequireDefault(_vueResource);

var _vueLazyload = __webpack_require__(70);

var _vueLazyload2 = _interopRequireDefault(_vueLazyload);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueResource2.default);
_vue2.default.use(_vueLazyload2.default, {
  preLoad: 1.3,
  attempt: 1
});
exports.default = {
  name: 'app',
  created: function created() {
    var docEl = document.documentElement,
        resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
        recalc = function recalc() {
      var clientWidth = docEl.clientWidth;
      if (!clientWidth) return;
      docEl.style.fontSize = 100 * (clientWidth / 750) + 'px';
      self.isEmputy = true;
    };

    if (!document.addEventListener) return;
    window.addEventListener(resizeEvt, recalc, false);
    document.addEventListener('DOMContentLoaded', recalc, false);
  },

  watch: {}

};

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _header = __webpack_require__(4);

var _header2 = _interopRequireDefault(_header);

var _footer = __webpack_require__(3);

var _footer2 = _interopRequireDefault(_footer);

var _vue = __webpack_require__(0);

var _vue2 = _interopRequireDefault(_vue);

var _i18n = __webpack_require__(2);

var _i18n2 = _interopRequireDefault(_i18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  i18n: _i18n2.default,
  data: function data() {
    return {
      imglist: ["/static/images/about/T.png", "/static/images/about/Crusoe.png", "/static/images/about/Frederick.png", "/static/images/about/Brian.png", "/static/images/about/Tim.png", "/static/images/about/Joyce.png", "/static/images/about/Alen.png", "/static/images/about/bg.png"],
      showmenu_bar: true
    };
  },
  created: function created() {
    var language = navigator.language;
    var initLanguage = "";
    if (localStorage.locale) {
      this.$i18n.locale = localStorage.locale;
    } else {
      if (language.indexOf('zh') > -1) {
        initLanguage = "ch";
      } else if (language.indexOf('en') > -1) {
        initLanguage = "en";
      }
      this.$i18n.locale = initLanguage;
    }
    var self = this;
  },

  components: {
    headLine: _header2.default,
    footerLine: _footer2.default
  },
  methods: {
    swipeup: function swipeup() {
      this.showmenu_bar = false;
    },
    swipedown: function swipedown() {
      this.showmenu_bar = true;
    },

    onLocaleChange: function onLocaleChange(val) {
      this.$i18n.locale = val;
    }
  }
};

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _header = __webpack_require__(4);

var _header2 = _interopRequireDefault(_header);

var _footer = __webpack_require__(3);

var _footer2 = _interopRequireDefault(_footer);

__webpack_require__(10);

var _vue = __webpack_require__(0);

var _vue2 = _interopRequireDefault(_vue);

var _i18n = __webpack_require__(2);

var _i18n2 = _interopRequireDefault(_i18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'about',
  i18n: _i18n2.default,
  data: function data() {
    return {
      imglist: ["/static/images/devolop/banner.png", "/static/images/devolop/01.png", "/static/images/devolop/02.png", "/static/images/about/Brian.png", "/static/images/about/Tim.png", "/static/images/about/Joyce.png", "/static/images/about/Alen.png", "/static/images/about/bg.png"]
    };
  },
  watch: {},
  mounted: function mounted() {
    var language = navigator.language;
    var initLanguage = "";
    if (localStorage.locale) {
      this.$i18n.locale = localStorage.locale;
    } else {
      if (language.indexOf('zh') > -1) {
        initLanguage = "ch";
      } else if (language.indexOf('en') > -1) {
        initLanguage = "en";
      }
      this.$i18n.locale = initLanguage;
    }
  },

  computed: {},
  components: {
    HeaderLine: _header2.default,
    Footerline: _footer2.default
  },
  methods: {
    onLocaleChange: function onLocaleChange(val) {
      this.$i18n.locale = val;
    }
  }
};

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _header = __webpack_require__(4);

var _header2 = _interopRequireDefault(_header);

var _footer = __webpack_require__(3);

var _footer2 = _interopRequireDefault(_footer);

var _vue = __webpack_require__(0);

var _vue2 = _interopRequireDefault(_vue);

var _vueI18n = __webpack_require__(13);

var _vueI18n2 = _interopRequireDefault(_vueI18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueI18n2.default);
var i18n = new _vueI18n2.default({
  messages: {
    ch: {
      title: "下载Demo",
      title2: "威尔VR Demo",
      text: "下载即可体验威尔云技术处理后，多种VR场景下<br>(包括秀场、游戏、体育）适用的视频。",
      button2: "威尔VR Demo iOS版"
    },
    en: {
      title: "Download",
      title2: "VRVIU Demo",
      text: "Experience our quality 4K streaming through our demo.",
      button2: "VRVIU Demo for iOS"
    }
  }
});
exports.default = {
  i18n: i18n,
  data: function data() {
    return {
      imglist: ["../../static/images/download/BG.png", "../../static/images/download/main.png"],
      showmenu_bar: true
    };
  },
  created: function created() {
    var language = navigator.language;
    var initLanguage = "";
    if (localStorage.locale) {
      this.$i18n.locale = localStorage.locale;
    } else {
      if (language.indexOf('zh') > -1) {
        initLanguage = "ch";
      } else if (language.indexOf('en') > -1) {
        initLanguage = "en";
      }
      this.$i18n.locale = initLanguage;
    }
  },

  components: {
    headLine: _header2.default,
    footerLine: _footer2.default
  },
  methods: {
    onLocaleChange: function onLocaleChange(val) {
      this.$i18n.locale = val;
    }
  }
};

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(0);

var _vue2 = _interopRequireDefault(_vue);

var _bus = __webpack_require__(9);

var _bus2 = _interopRequireDefault(_bus);

var _i18n = __webpack_require__(2);

var _i18n2 = _interopRequireDefault(_i18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  i18n: _i18n2.default,
  created: function created() {
    var language = navigator.language;
    var initLanguage = "";
    if (localStorage.locale) {
      this.$i18n.locale = localStorage.locale;
    } else {
      if (language.indexOf('zh') > -1) {
        initLanguage = "ch";
      } else if (language.indexOf('en') > -1) {
        initLanguage = "en";
      }
      this.$i18n.locale = initLanguage;
    }
    self = this;
    _bus2.default.$on('on-locale-change', function (target) {
      self.$i18n.locale = target;
    });
  }
};

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(0);

var _vue2 = _interopRequireDefault(_vue);

var _vue2TouchEvents = __webpack_require__(107);

var _vue2TouchEvents2 = _interopRequireDefault(_vue2TouchEvents);

var _bus = __webpack_require__(9);

var _bus2 = _interopRequireDefault(_bus);

var _i18n = __webpack_require__(2);

var _i18n2 = _interopRequireDefault(_i18n);

var _vueMultiselect = __webpack_require__(103);

var _vueMultiselect2 = _interopRequireDefault(_vueMultiselect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2TouchEvents2.default.config = {
  maxSingleTapTimeInterval: 200
};

_vue2.default.use(_vue2TouchEvents2.default);

exports.default = {
  props: ['index', 'showbar'],
  name: 'index',
  i18n: _i18n2.default,
  data: function data() {
    return {
      showMenu: false,
      showMenu1: false,
      showMenu2: false,
      showMenu3: false,
      showMenu4: false,
      showDialog: false,
      options: ['申请使用威尔云', '威尔云服务咨询', '技术疑问', '其他'],
      options1: ['Get VRVIU Cloud Trial', 'VRVIU Cloud service questions', 'Technical questions', 'Others'],
      showweixin: false,
      showNext: false,
      name: "",
      company: "",
      telephone: "",
      email: "",
      content_type2: "申请使用威尔云",
      content_type: 1,
      check_ok1: "",
      check_ok2: "",
      check_ok3: "",
      check_ok4: "",
      showError: false,
      errorText: "cdfdfdf",
      color: false
    };
  },

  watch: {
    showMenu: function showMenu(val) {
      if (val) {
        if (document.querySelector("video")) {
          document.querySelector("video").style.display = "none";
        }
      } else {
        if (document.querySelector("video")) {
          document.querySelector("video").style.display = "block";
        }
      }
    },
    showDialog: function showDialog(val) {
      if (val) {
        document.body.style.position = 'fixed';
      } else {
        document.body.style.position = 'relative';
      }
    }
  },

  mounted: function mounted() {
    var self = this;
    window.addEventListener("scroll", function () {
      if (document.body.scrollTop > 0 || document.documentElement.scrollTop > 0) {
        self.color = true;
      } else {
        self.color = false;
      }
    }, false);
    var language = navigator.language;
    var initLanguage = "";
    if (localStorage.locale) {
      this.$i18n.locale = localStorage.locale;
    } else {
      if (language.indexOf('zh') > -1) {
        initLanguage = "ch";
      } else if (language.indexOf('en') > -1) {
        initLanguage = "en";
      }
      this.$i18n.locale = initLanguage;
    }
  },

  methods: {
    changeLanguage: function changeLanguage(ch) {
      this.showMenu = false;
      this.$i18n.locale = ch;
      localStorage.locale = ch;
      this.$emit("on-locale-change", ch);
      _bus2.default.$emit('on-locale-change', this.$i18n.locale);
      if (this.$i18n.locale == "en") {
        if (this.index == 1) {
          this.setTitile("VRVIU - The Highway to Ultra HD");
        }
        if (this.index == 2) {
          this.setTitile("Solutions - VRVIU");
        }
        if (this.index == 3) {
          this.setTitile("Technology - VRVIU");
        }
        if (this.index == 7) {
          this.setTitile("SDK - VRVIU");
        }

        if (this.index == 5) {
          this.setTitile("About Us - VRVIU");
        }
        if (this.index == 6) {
          this.setTitile("Join Us - VRVIU");
        }
      } else {
        if (this.index == 1) {
          this.setTitile("威尔云VRVIU - 全球领先的高清视频云服务");
        }
        if (this.index == 2) {
          this.setTitile("解决方案 - 威尔云 VRVIU");
        }
        if (this.index == 3) {
          this.setTitile("核心技术 - 威尔云 VRVIU");
        }
        if (this.index == 4) {
          this.setTitile("SDK - 威尔云 VRVIU");
        }

        if (this.index == 5) {
          this.setTitile("关于我们 - 威尔云 VRVIU");
        }
        if (this.index == 6) {
          this.setTitile("加入我们 - 威尔云 VRVIU");
        }
      }
    },
    setTitile: function setTitile(t) {
      document.title = t;
      var i = document.createElement('iframe');
      i.src = 'https://www.vrviu.com/favicon.ico';
      i.style.display = 'none';
      i.onload = function () {
        setTimeout(function () {
          i.remove();
        }, 9);
      };
      document.body.appendChild(i);
    },

    check_success: function check_success(e, type) {
      var el = e.target;
      var value = el.value;
      if (type == "required") {
        if (value == "") {
          this.check_ok2 = "false";
        } else {
          this.check_ok2 = "true";
        }
      } else if (type == "phone" && this.$i18n.locale == 'ch') {
        if (value == "") {
          this.check_ok3 = "false";
        } else {
          var re = /^1[3|5|8]\d{9}$|^0\d{2,3}-?\d{7,8}$/;
          if (re.test(value)) {

            this.check_ok3 = "true";
          } else {
            this.check_ok3 = "false";
          }
        }
      } else if (type == "email") {
        if (value == "") {
          this.check_ok4 = "false";
        } else {
          var _re = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
          if (_re.test(value)) {
            this.check_ok4 = "true";
          } else {
            this.check_ok4 = "false";
          }
        }
      }
    },
    send_email: function send_email() {
      if (this.name == "") {
        this.check_ok2 = "false";
      }
      if (this.telephone == "" && this.$i18n.locale == "ch") {
        this.check_ok3 = "false";
      }
      if (this.email == "") {
        this.check_ok4 = "false";
      }
      if (this.check_ok2 != "false" && this.check_ok3 != "false" && this.check_ok4 != "false") {
        this.showLoding = true;
        var self = this;
        if (this.content_type2 == "申请使用威尔云" || this.content_type2 == "Get VRVIU Cloud Trial") {
          this.content_type = 1;
        }
        if (this.content_type2 == "威尔云服务咨询" || this.content_type2 == "VRVIU Cloud service questions") {
          this.content_type = 2;
        }
        if (this.content_type2 == "技术疑问" || this.content_type2 == "Technical question") {
          this.content_type = 3;
        }
        if (this.content_type2 == "其他" || this.content_type2 == "Others") {
          this.content_type = 4;
        }

        this.$http.post("https://oth-api.vrviu.com/feedback/", { name: this.name, company: this.company, telephone: this.telephone, email: this.email, content_type: this.content_type, comment: "" }).then(function (res) {
          if (res.body.ret_code == 0) {
            this.showError = false;
            this.showNext = true;
          } else {
            this.showError = true;
            this.errorText = res.body.ret_msg;
          }
        }, function (res) {
          if (res.status == 503) {
            this.errorText = this.$t("error503");
          } else if (res.status == 409) {
            this.errorText = this.$t("error409");
          } else {
            this.errorText = this.$t("error");
          }
          this.showError = true;
        });
      }
    },
    free_use: function free_use() {
      if (this.$i18n.locale == "en") {
        this.content_type2 = "Get VRVIU Cloud Trial";
      } else {
        this.content_type2 = "申请使用威尔云";
      }
      this.showDialog = true;
      this.showNext = false;
      this.name = "";
      this.company = "";
      this.email = "";
      this.telephone = "";
      this.check_ok1 = "";
      this.check_ok2 = "";
      this.check_ok3 = "";
      this.check_ok4 = "";
      this.showError = false;
    }
  },
  components: {
    Multiselect: _vueMultiselect2.default
  },
  beforeDestroy: function beforeDestroy() {
    document.body.style.position = 'relative';
  }
};

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _header = __webpack_require__(4);

var _header2 = _interopRequireDefault(_header);

var _footer = __webpack_require__(3);

var _footer2 = _interopRequireDefault(_footer);

var _vueVideo = __webpack_require__(5);

var _vueVideo2 = _interopRequireDefault(_vueVideo);

var _vue = __webpack_require__(0);

var _vue2 = _interopRequireDefault(_vue);

var _i18n = __webpack_require__(2);

var _i18n2 = _interopRequireDefault(_i18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'index',
    i18n: _i18n2.default,
    data: function data() {
        return {
            show_game_dialog: true,
            imglist: ["/static/images/banner/banner.png", "/static/images/img1.png", "/static/images/img2.png", "/static/images/img3.png", "/static/images/img4.png", "/static/images/img5.png", "/static/images/img6.png", "/static/images/img8.png", "/static/images/img9.png", "/static/images/img7.png", "/static/images/image11.png", "/static/images/img2d1 (1).png", "/static/images/img2d1 (2).png", "/static/images/img2d1 (3).png", "/static/images/logo11.png", "/static/images/logo12.png", "/static/images/logo13.png", "/static/images/logo14.png", "/static/images/logo15.png", "/static/images/logo16.png", "/static/images/logo17.png", "/static/images/dialog.jpg", "/static/images/dialog_en.jpg"],
            showTab: 1,
            show_play_btn: true,
            video: {
                sources: [{
                    src: '/static/media/BG_loop.mp4',
                    type: 'video/mp4'
                }],
                options: {
                    autoplay: false,
                    volume: 0.6,
                    poster: '/static/images/img7.png'
                }
            }
        };
    },

    watch: {},

    created: function created() {
        var language = navigator.language;
        var initLanguage = "";
        if (localStorage.locale) {
            this.$i18n.locale = localStorage.locale;
        } else {
            if (language.indexOf('zh') > -1) {
                initLanguage = "ch";
            } else if (language.indexOf('en') > -1) {
                initLanguage = "en";
            }
            this.$i18n.locale = initLanguage;
        }
        if (this.$i18n.locale == "ch") {
            this.video.options.poster = "/static/media/bg.jpg";
        } else {
            this.video.options.poster = "/static/static/media/VRVIU4Mbps2.png";
        }
    },

    methods: {
        play_video: function play_video() {
            var _this = this;

            setTimeout(function () {
                _this.$refs.video.fullScreen();
            });
            this.$refs.video.$video.addEventListener('ended', function (e) {
                _this.show_play_btn = true;
            }, false);
            this.$refs.video.play();
            this.show_play_btn = false;
        },
        showDialog: function showDialog() {
            this.$refs.dialog.showDialog = true;
            this.$refs.dialog.showNext = false;
            if (this.$i18n.locale == "en") {
                this.$refs.dialog.content_type2 = "Get VRVIU Cloud Trial";
            } else {
                this.$refs.dialog.content_type2 = "申请使用威尔云";
            }
        },

        onLocaleChange: function onLocaleChange(val) {
            this.$i18n.locale = val;
            if (this.$i18n.locale == "ch") {
                this.video.options.poster = "/static/media/bg.jpg";
            } else {
                this.video.options.poster = "/static/media/VRVIU4Mbps2.png";
            }
        }
    },
    components: {
        headLine: _header2.default,
        myVideo: _vueVideo2.default,
        footerLine: _footer2.default
    }
};

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _header = __webpack_require__(4);

var _header2 = _interopRequireDefault(_header);

var _footer = __webpack_require__(3);

var _footer2 = _interopRequireDefault(_footer);

var _vue = __webpack_require__(0);

var _vue2 = _interopRequireDefault(_vue);

var _i18n = __webpack_require__(2);

var _i18n2 = _interopRequireDefault(_i18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  i18n: _i18n2.default,
  data: function data() {
    return {
      imglist: ["/static/images/about/T.png", "/static/images/join/image.png", "/static/images/join/image2.png", "/static/images/about/bg.png", "/static/images/about/bg11.png", "/static/images/about/bg12.png"],
      showmenu_bar: true
    };
  },
  created: function created() {
    var self = this;
    var language = navigator.language;
    var initLanguage = "";
    if (localStorage.locale) {
      this.$i18n.locale = localStorage.locale;
    } else {
      if (language.indexOf('zh') > -1) {
        initLanguage = "ch";
      } else if (language.indexOf('en') > -1) {
        initLanguage = "en";
      }
      this.$i18n.locale = initLanguage;
    }
  },

  components: {
    headLine: _header2.default,
    footerLine: _footer2.default
  },
  methods: {
    swipeup: function swipeup() {
      this.showmenu_bar = false;
    },
    swipedown: function swipedown() {
      this.showmenu_bar = true;
    },

    onLocaleChange: function onLocaleChange(val) {
      this.$i18n.locale = val;
    }
  }
};

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _header = __webpack_require__(4);

var _header2 = _interopRequireDefault(_header);

var _footer = __webpack_require__(3);

var _footer2 = _interopRequireDefault(_footer);

var _vueVideo = __webpack_require__(5);

var _vueVideo2 = _interopRequireDefault(_vueVideo);

var _vue = __webpack_require__(0);

var _vue2 = _interopRequireDefault(_vue);

var _i18n = __webpack_require__(2);

var _i18n2 = _interopRequireDefault(_i18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'index',
  i18n: _i18n2.default,
  data: function data() {
    return {
      imglist: ["/static/images/Banner-BG@2x.png", "/static/images/img12.png", "/static/images/img2.png", "/static/images/img3.png", "/static/images/img4.png", "/static/images/img5.png", "/static/images/img6.png", "/static/images/img8.png", "/static/images/img9.png", "/static/images/img7.png", "/static/images/img11.png", "/static/images/img2d1 (1).png", "/static/images/img2d1 (2).png", "/static/images/img2d1 (3).png", "/static/images/logo11.png", "/static/images/logo12.png", "/static/images/logo13.png", "/static/images/logo14.png", "/static/images/logo15.png", "/static/images/logo16.png", "/static/images/logo17.png"],
      showTab: 1,
      show_play_btn: true,
      video: {
        sources: [{
          src: 'https://img.vrviu.com/static/media/BG_loop.mp4',
          type: 'video/mp4'
        }],
        options: {
          autoplay: false,
          volume: 0.6,
          poster: 'https://img.vrviu.com/static/images/img7.png'
        }
      }
    };
  },

  watch: {},

  created: function created() {
    var language = navigator.language;
    var initLanguage = "";
    if (localStorage.locale) {
      this.$i18n.locale = localStorage.locale;
    } else {
      if (language.indexOf('zh') > -1) {
        initLanguage = "ch";
      } else if (language.indexOf('en') > -1) {
        initLanguage = "en";
      }
      this.$i18n.locale = initLanguage;
    }
    if (this.$i18n.locale == "ch") {
      this.video.options.poster = "https://img.vrviu.com/static/media/bg.jpg";
    } else {
      this.video.options.poster = "https://img.vrviu.com/static/media/VRVIU4Mbps2.png";
    }
  },

  methods: {
    play_video: function play_video() {
      var _this = this;

      setTimeout(function () {
        _this.$refs.video.fullScreen();
      });
      this.$refs.video.$video.addEventListener('ended', function (e) {
        _this.show_play_btn = true;
      }, false);
      this.$refs.video.play();
      this.show_play_btn = false;
    },
    showDialog: function showDialog() {
      this.$refs.dialog.showDialog = true;
      this.$refs.dialog.showNext = false;
      if (this.$i18n.locale == "en") {
        this.$refs.dialog.content_type2 = "Get VRVIU Cloud Trial";
      } else {
        this.$refs.dialog.content_type2 = "申请使用威尔云";
      }
    },

    onLocaleChange: function onLocaleChange(val) {
      this.$i18n.locale = val;
      if (this.$i18n.locale == "ch") {
        this.video.options.poster = "https://img.vrviu.com/static/media/bg.jpg";
      } else {
        this.video.options.poster = "https://img.vrviu.com/static/media/VRVIU4Mbps2.png";
      }
    }
  },
  components: {
    headLine: _header2.default,
    myVideo: _vueVideo2.default,
    footerLine: _footer2.default
  }
};

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _header = __webpack_require__(4);

var _header2 = _interopRequireDefault(_header);

var _footer = __webpack_require__(3);

var _footer2 = _interopRequireDefault(_footer);

var _vueVideo = __webpack_require__(5);

var _vueVideo2 = _interopRequireDefault(_vueVideo);

var _vue = __webpack_require__(0);

var _vue2 = _interopRequireDefault(_vue);

var _i18n = __webpack_require__(2);

var _i18n2 = _interopRequireDefault(_i18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'index',
  i18n: _i18n2.default,
  data: function data() {
    return {
      imglist: ["/static/images/Banner-BG@2x.png", "/static/images/img1.png", "/static/images/product/Lording@2x.png", "/static/images/product/change@2x.png", "/static/images/product/IMAX@2x.png", "/static/images/product/app mock-up@2x.png"],
      showTab: 1,
      show_play_btn: true,
      video: {
        sources: [{
          src: 'https://img.vrviu.com/static/media/BG_loop.mp4',
          type: 'video/mp4'
        }],
        options: {
          autoplay: false,
          volume: 0.6,
          poster: 'https://img.vrviu.com/static/images/img7.png'
        }
      }
    };
  },

  watch: {},

  created: function created() {
    var language = navigator.language;
    var initLanguage = "";
    if (localStorage.locale) {
      this.$i18n.locale = localStorage.locale;
    } else {
      if (language.indexOf('zh') > -1) {
        initLanguage = "ch";
      } else if (language.indexOf('en') > -1) {
        initLanguage = "en";
      }
      this.$i18n.locale = initLanguage;
    }
    if (this.$i18n.locale == "ch") {
      this.video.options.poster = "https://img.vrviu.com/static/media/bg.jpg";
    } else {
      this.video.options.poster = "https://img.vrviu.com/static/media/VRVIU4Mbps2.png";
    }
  },

  methods: {
    play_video: function play_video() {
      var _this = this;

      setTimeout(function () {
        _this.$refs.video.fullScreen();
      });
      this.$refs.video.$video.addEventListener('ended', function (e) {
        _this.show_play_btn = true;
      }, false);
      this.$refs.video.play();
      this.show_play_btn = false;
    },
    showDialog: function showDialog() {
      this.$refs.dialog.showDialog = true;
      this.$refs.dialog.showNext = false;
      if (this.$i18n.locale == "en") {
        this.$refs.dialog.content_type2 = "Get VRVIU Cloud Trial";
      } else {
        this.$refs.dialog.content_type2 = "申请使用威尔云";
      }
    },

    onLocaleChange: function onLocaleChange(val) {
      this.$i18n.locale = val;
      if (this.$i18n.locale == "ch") {
        this.video.options.poster = "https://img.vrviu.com/static/media/bg.jpg";
      } else {
        this.video.options.poster = "https://img.vrviu.com/static/media/VRVIU4Mbps2.png";
      }
    }
  },
  components: {
    headLine: _header2.default,
    myVideo: _vueVideo2.default,
    footerLine: _footer2.default
  }
};

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _header = __webpack_require__(4);

var _header2 = _interopRequireDefault(_header);

var _footer = __webpack_require__(3);

var _footer2 = _interopRequireDefault(_footer);

var _vueVideo = __webpack_require__(5);

var _vueVideo2 = _interopRequireDefault(_vueVideo);

var _vue = __webpack_require__(0);

var _vue2 = _interopRequireDefault(_vue);

var _i18n = __webpack_require__(2);

var _i18n2 = _interopRequireDefault(_i18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'index',
  i18n: _i18n2.default,
  data: function data() {
    return {
      imglist: ["/static/images/Banner-BG@2x.png", "/static/images/product/Main-1@2x.png", "/static/images/img2.png", "/static/images/img3.png", "/static/images/img4.png", "/static/images/img5.png", "/static/images/img6.png", "/static/images/img8.png", "/static/images/img9.png", "/static/images/img7.png", "/static/images/img11.png", "/static/images/img2d1 (1).png", "/static/images/img2d1 (2).png", "/static/images/img2d1 (3).png", "/static/images/logo11.png", "/static/images/logo12.png", "/static/images/logo13.png", "/static/images/logo14.png", "/static/images/logo15.png", "/static/images/logo16.png", "/static/images/logo17.png"],
      showTab: 1,
      show_play_btn: true,
      video: {
        sources: [{
          src: 'https://img.vrviu.com/static/media/BG_loop.mp4',
          type: 'video/mp4'
        }],
        options: {
          autoplay: false,
          volume: 0.6,
          poster: 'https://img.vrviu.com/static/images/img7.png'
        }
      }
    };
  },

  watch: {},

  created: function created() {
    var language = navigator.language;
    var initLanguage = "";
    if (localStorage.locale) {
      this.$i18n.locale = localStorage.locale;
    } else {
      if (language.indexOf('zh') > -1) {
        initLanguage = "ch";
      } else if (language.indexOf('en') > -1) {
        initLanguage = "en";
      }
      this.$i18n.locale = initLanguage;
    }
    if (this.$i18n.locale == "ch") {
      this.video.options.poster = "https://img.vrviu.com/static/media/bg.jpg";
    } else {
      this.video.options.poster = "https://img.vrviu.com/static/media/VRVIU4Mbps2.png";
    }
  },

  methods: {
    play_video: function play_video() {
      var _this = this;

      setTimeout(function () {
        _this.$refs.video.fullScreen();
      });
      this.$refs.video.$video.addEventListener('ended', function (e) {
        _this.show_play_btn = true;
      }, false);
      this.$refs.video.play();
      this.show_play_btn = false;
    },
    showDialog: function showDialog() {
      this.$refs.dialog.showDialog = true;
      this.$refs.dialog.showNext = false;
      if (this.$i18n.locale == "en") {
        this.$refs.dialog.content_type2 = "Get VRVIU Cloud Trial";
      } else {
        this.$refs.dialog.content_type2 = "申请使用威尔云";
      }
    },

    onLocaleChange: function onLocaleChange(val) {
      this.$i18n.locale = val;
      if (this.$i18n.locale == "ch") {
        this.video.options.poster = "https://img.vrviu.com/static/media/bg.jpg";
      } else {
        this.video.options.poster = "https://img.vrviu.com/static/media/VRVIU4Mbps2.png";
      }
    }
  },
  components: {
    headLine: _header2.default,
    myVideo: _vueVideo2.default,
    footerLine: _footer2.default
  }
};

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _header = __webpack_require__(4);

var _header2 = _interopRequireDefault(_header);

var _footer = __webpack_require__(3);

var _footer2 = _interopRequireDefault(_footer);

var _vueVideo = __webpack_require__(5);

var _vueVideo2 = _interopRequireDefault(_vueVideo);

var _vue = __webpack_require__(0);

var _vue2 = _interopRequireDefault(_vue);

var _i18n = __webpack_require__(2);

var _i18n2 = _interopRequireDefault(_i18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'index',
  i18n: _i18n2.default,
  data: function data() {
    return {
      imglist: ["/static/images/Banner-BG@2x.png", "/static/images/img1.png", "/static/images/product/Lording@2x.png", "/static/images/product/change@2x.png", "/static/images/product/IMAX@2x.png", "/static/images/product/app mock-up@2x.png"],
      showTab: 1,
      show_play_btn: true,
      video: {
        sources: [{
          src: 'https://img.vrviu.com/static/media/BG_loop.mp4',
          type: 'video/mp4'
        }],
        options: {
          autoplay: false,
          volume: 0.6,
          poster: 'https://img.vrviu.com/static/images/img7.png'
        }
      }
    };
  },

  watch: {},

  created: function created() {
    var language = navigator.language;
    var initLanguage = "";
    if (localStorage.locale) {
      this.$i18n.locale = localStorage.locale;
    } else {
      if (language.indexOf('zh') > -1) {
        initLanguage = "ch";
      } else if (language.indexOf('en') > -1) {
        initLanguage = "en";
      }
      this.$i18n.locale = initLanguage;
    }
    if (this.$i18n.locale == "ch") {
      this.video.options.poster = "https://img.vrviu.com/static/media/bg.jpg";
    } else {
      this.video.options.poster = "https://img.vrviu.com/static/media/VRVIU4Mbps2.png";
    }
  },

  methods: {
    play_video: function play_video() {
      var _this = this;

      setTimeout(function () {
        _this.$refs.video.fullScreen();
      });
      this.$refs.video.$video.addEventListener('ended', function (e) {
        _this.show_play_btn = true;
      }, false);
      this.$refs.video.play();
      this.show_play_btn = false;
    },
    showDialog: function showDialog() {
      this.$refs.dialog.showDialog = true;
      this.$refs.dialog.showNext = false;
      if (this.$i18n.locale == "en") {
        this.$refs.dialog.content_type2 = "Get VRVIU Cloud Trial";
      } else {
        this.$refs.dialog.content_type2 = "申请使用威尔云";
      }
    },

    onLocaleChange: function onLocaleChange(val) {
      this.$i18n.locale = val;
      if (this.$i18n.locale == "ch") {
        this.video.options.poster = "https://img.vrviu.com/static/media/bg.jpg";
      } else {
        this.video.options.poster = "https://img.vrviu.com/static/media/VRVIU4Mbps2.png";
      }
    }
  },
  components: {
    headLine: _header2.default,
    myVideo: _vueVideo2.default,
    footerLine: _footer2.default
  }
};

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _header = __webpack_require__(4);

var _header2 = _interopRequireDefault(_header);

var _footer = __webpack_require__(3);

var _footer2 = _interopRequireDefault(_footer);

__webpack_require__(10);

var _vue = __webpack_require__(0);

var _vue2 = _interopRequireDefault(_vue);

var _i18n = __webpack_require__(2);

var _i18n2 = _interopRequireDefault(_i18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'solution',
  data: function data() {
    return {
      imglist: ["/static/images/devolop/banner.png", "/static/images/devolop/01.png", "/static/images/devolop/02.png", "/static/images/about/Brian.png", "/static/images/about/Tim.png", "/static/images/about/Joyce.png", "/static/images/about/Alen.png", "/static/images/about/bg.png"]

    };
  },
  i18n: _i18n2.default,
  watch: {},
  mounted: function mounted() {
    var language = navigator.language;
    var initLanguage = "";
    if (localStorage.locale) {
      this.$i18n.locale = localStorage.locale;
    } else {
      if (language.indexOf('zh') > -1) {
        initLanguage = "ch";
      } else if (language.indexOf('en') > -1) {
        initLanguage = "en";
      }
      this.$i18n.locale = initLanguage;
    }
  },

  computed: {},
  components: {
    HeaderLine: _header2.default,
    Footerline: _footer2.default
  },
  methods: {
    changeIndex: function changeIndex(dsd, sdsds) {
      this.loopName = this.loopList[dsd].name;
    },
    showDialog2: function showDialog2() {
      this.$refs.dialog.showDialog = true;
      this.$refs.dialog.showNext = false;
      if (this.$i18n.locale == "en") {
        this.$refs.dialog.content_type2 = "Others";
      } else {
        this.$refs.dialog.content_type2 = "其他";
      }
    },
    showDialog3: function showDialog3() {
      this.$refs.dialog.showDialog = true;
      this.$refs.dialog.showNext = false;
      if (this.$i18n.locale == "en") {
        this.$refs.dialog.content_type2 = "VRVIU Cloud service questions";
      } else {
        this.$refs.dialog.content_type2 = "威尔云服务咨询";
      }
    },
    showDialog: function showDialog() {
      this.$refs.dialog.showDialog = true;
      this.$refs.dialog.showNext = false;
      if (this.$i18n.locale == "en") {
        this.$refs.dialog.content_type2 = "Get VRVIU Cloud Trial";
      } else {
        this.$refs.dialog.content_type2 = "威尔云服务咨询";
      }
    },

    onLocaleChange: function onLocaleChange(val) {
      this.$i18n.locale = val;
    }
  }
};

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(0);

var _vue2 = _interopRequireDefault(_vue);

var _header = __webpack_require__(4);

var _header2 = _interopRequireDefault(_header);

var _footer = __webpack_require__(3);

var _footer2 = _interopRequireDefault(_footer);

var _i18n = __webpack_require__(2);

var _i18n2 = _interopRequireDefault(_i18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  i18n: _i18n2.default,
  data: function data() {
    return {
      imglist: ["/static/images/solution/banner.png", "/static/images/solution/180.png", "/static/images/solution/img1.png", "/static/images/solution/img2.png", "/static/images/solution/img3.png", "/static/images/solution/360.png", "/static/images/solution/img4.png", "/static/images/about/bg.png", "/static/images/solution/img5.png", "/static/images/solution/img6.png", "/static/images/solution/360.png", "/static/images/solution/3601.png"],
      show1: false,
      show2: false,
      show3: false,
      show4: false,
      showmenu_bar: true
    };
  },
  created: function created() {
    var language = navigator.language;
    var initLanguage = "";
    if (localStorage.locale) {
      this.$i18n.locale = localStorage.locale;
    } else {
      if (language.indexOf('zh') > -1) {
        initLanguage = "ch";
      } else if (language.indexOf('en') > -1) {
        initLanguage = "en";
      }
      this.$i18n.locale = initLanguage;
    }

    var self = this;
    document.addEventListener("scroll", function () {
      var scrollTop = document.body.scrollTop;
      if (scrollTop > 10) {
        if (scrollTop >= self.scrollTop) {} else {}
        setTimeout(function () {
          self.scrollTop = scrollTop;
        }, 100);
      }
    }, false);
  },

  methods: {
    showDialog2: function showDialog2() {
      this.$refs.dialog.showNext = false;
      this.$refs.dialog.showDialog = true;
      if (this.$i18n.locale == "en") {
        this.$refs.dialog.content_type2 = "Get VRVIU Cloud Trial";
      } else {
        this.$refs.dialog.content_type2 = "申请使用威尔云";
      }
    },

    onLocaleChange: function onLocaleChange(val) {
      this.$i18n.locale = val;
    },
    showDialog: function showDialog() {
      this.$refs.dialog.showDialog = true;
      this.$refs.dialog.showNext = false;
      if (this.$i18n.locale == "en") {
        this.$refs.dialog.content_type2 = "Get VRVIU Cloud Trial";
      } else {
        this.$refs.dialog.content_type2 = "申请使用威尔云";
      }
    },
    swipeup: function swipeup() {},
    swipedown: function swipedown() {}
  },
  components: {
    headLine: _header2.default,
    footerLine: _footer2.default,
    show1: false,
    show2: false
  }
};

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(0);

var _vue2 = _interopRequireDefault(_vue);

var _header = __webpack_require__(4);

var _header2 = _interopRequireDefault(_header);

var _footer = __webpack_require__(3);

var _footer2 = _interopRequireDefault(_footer);

var _i18n = __webpack_require__(2);

var _i18n2 = _interopRequireDefault(_i18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  i18n: _i18n2.default,
  data: function data() {
    return {
      imglist: ["/static/images/solution/banner.png", "/static/images/solution/1801.png", "/static/images/solution/img1.png", "/static/images/solution/img2.png", "/static/images/solution/img3.png", "/static/images/solution/360.png", "/static/images/solution/img4.png", "/static/images/about/bg.png", "/static/images/solution/img5.png", "/static/images/solution/img6.png", "/static/images/solution/3602.png", "/static/images/solution/3601.png"],
      show1: false,
      show2: false,
      show3: false,
      show4: false,
      showmenu_bar: true
    };
  },
  created: function created() {
    var language = navigator.language;
    var initLanguage = "";
    if (localStorage.locale) {
      this.$i18n.locale = localStorage.locale;
    } else {
      if (language.indexOf('zh') > -1) {
        initLanguage = "ch";
      } else if (language.indexOf('en') > -1) {
        initLanguage = "en";
      }
      this.$i18n.locale = initLanguage;
    }
    var self = this;
    document.addEventListener("scroll", function () {
      var scrollTop = document.body.scrollTop;
      if (scrollTop > 10) {
        if (scrollTop >= self.scrollTop) {} else {}
        setTimeout(function () {
          self.scrollTop = scrollTop;
        }, 100);
      }
    }, false);
  },

  methods: {
    showDialog2: function showDialog2() {
      this.$refs.dialog.showNext = false;
      this.$refs.dialog.showDialog = true;
      if (this.$i18n.locale == "en") {
        this.$refs.dialog.content_type2 = "Get VRVIU Cloud Trial";
      } else {
        this.$refs.dialog.content_type2 = "申请使用威尔云";
      }
    },

    onLocaleChange: function onLocaleChange(val) {
      this.$i18n.locale = val;
    },
    showDialog: function showDialog() {
      this.$refs.dialog.showDialog = true;
      this.$refs.dialog.showNext = false;
      if (this.$i18n.locale == "en") {
        this.$refs.dialog.content_type2 = "Get VRVIU Cloud Trial";
      } else {
        this.$refs.dialog.content_type2 = "申请使用威尔云";
      }
    },
    swipeup: function swipeup() {},
    swipedown: function swipedown() {}
  },
  components: {
    headLine: _header2.default,
    footerLine: _footer2.default,
    show1: false,
    show2: false
  }
};

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(0);

var _vue2 = _interopRequireDefault(_vue);

var _header = __webpack_require__(4);

var _header2 = _interopRequireDefault(_header);

var _footer = __webpack_require__(3);

var _footer2 = _interopRequireDefault(_footer);

var _i18n = __webpack_require__(2);

var _i18n2 = _interopRequireDefault(_i18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  i18n: _i18n2.default,
  data: function data() {
    return {
      imglist: ["/static/images/solution/banner.png", "/static/images/solution/1803.png", "/static/images/solution/img4.png", "/static/images/solution/img5.png", "/static/images/solution/img6.png", "/static/images/solution/360.png", "/static/images/solution/img4.png", "/static/images/about/bg.png", "/static/images/solution/img5.png", "/static/images/solution/img6.png", "/static/images/solution/3603.png", "/static/images/solution/3601.png"],
      show1: false,
      show2: false,
      show3: false,
      show4: false,
      show5: false,
      showmenu_bar: true
    };
  },
  created: function created() {
    var language = navigator.language;
    var initLanguage = "";
    if (localStorage.locale) {
      this.$i18n.locale = localStorage.locale;
    } else {
      if (language.indexOf('zh') > -1) {
        initLanguage = "ch";
      } else if (language.indexOf('en') > -1) {
        initLanguage = "en";
      }
      this.$i18n.locale = initLanguage;
    }
    var self = this;
    document.addEventListener("scroll", function () {
      var scrollTop = document.body.scrollTop;
      if (scrollTop > 10) {
        if (scrollTop >= self.scrollTop) {} else {}
        setTimeout(function () {
          self.scrollTop = scrollTop;
        }, 100);
      }
    }, false);
  },

  methods: {
    showDialog2: function showDialog2() {
      this.$refs.dialog.showNext = false;
      this.$refs.dialog.showDialog = true;
      if (this.$i18n.locale == "en") {
        this.$refs.dialog.content_type2 = "Get VRVIU Cloud Trial";
      } else {
        this.$refs.dialog.content_type2 = "申请使用威尔云";
      }
    },

    onLocaleChange: function onLocaleChange(val) {
      this.$i18n.locale = val;
    },
    swipeup: function swipeup() {},
    swipedown: function swipedown() {},
    showDialog: function showDialog() {
      this.$refs.dialog.showDialog = true;
      this.$refs.dialog.showNext = false;
      if (this.$i18n.locale == "en") {
        this.$refs.dialog.content_type2 = "Get VRVIU Cloud Trial";
      } else {
        this.$refs.dialog.content_type2 = "申请使用威尔云";
      }
    }
  },
  components: {
    headLine: _header2.default,
    footerLine: _footer2.default,
    show1: false,
    show2: false
  }
};

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _footer = __webpack_require__(3);

var _footer2 = _interopRequireDefault(_footer);

var _header = __webpack_require__(4);

var _header2 = _interopRequireDefault(_header);

var _vue = __webpack_require__(0);

var _vue2 = _interopRequireDefault(_vue);

var _i18n = __webpack_require__(2);

var _i18n2 = _interopRequireDefault(_i18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'index',
  i18n: _i18n2.default,
  data: function data() {
    return {
      imglist: ["/static/images/technology/T.png", "/static/images/technology/4K_main.png", "/static/images/technology/Upload_main.png", "/static/images/technology/Download_main.png", "/static/images/technology/Bg-1.png", "/static/images/technology/Low.png", "/static/images/technology/BG-2.png", "/static/images/technology/sound_main.png", "/static/images/technology/bg-3.png", "/static/images/technology/4K_main_en.png"]
    };
  },

  watch: {},

  created: function created() {
    var language = navigator.language;
    var initLanguage = "";
    if (localStorage.locale) {
      this.$i18n.locale = localStorage.locale;
    } else {
      if (language.indexOf('zh') > -1) {
        initLanguage = "ch";
      } else if (language.indexOf('en') > -1) {
        initLanguage = "en";
      }
      this.$i18n.locale = initLanguage;
    }
  },

  methods: {
    showDialog: function showDialog() {
      this.$refs.dialog.showDialog = true;
      this.$refs.dialog.showNext = false;
      if (this.$i18n.locale == "en") {
        this.$refs.dialog.content_type2 = "Get VRVIU Cloud Trial";
      } else {
        this.$refs.dialog.content_type2 = "申请使用威尔云";
      }
    },

    onLocaleChange: function onLocaleChange(val) {
      this.$i18n.locale = val;
    }
  },
  components: {
    headerLine: _header2.default,
    footerLine: _footer2.default
  }
};

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(0);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(15);

var _App2 = _interopRequireDefault(_App);

var _router = __webpack_require__(14);

var _router2 = _interopRequireDefault(_router);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.config.productionTip = false;

new _vue2.default({
  el: '#app',
  router: _router2.default,
  template: '<App/>',
  components: { App: _App2.default }
});

/***/ }),
/* 35 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 36 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 37 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 38 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 39 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 40 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 41 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 42 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 43 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 44 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 45 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 46 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 47 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 48 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 49 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 50 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 51 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 52 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 53 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 55 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 56 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALwAAAAhCAYAAABjscE2AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA4ZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo4MDI2ODc0My0xMWQyLTRhODItYjRhMC1hOGVkNjNhYTNiODciIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NUI5NjNCMDhGOTc1MTFFNzgyRTVENTYyQUQwOEQyRUMiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NUI5NjNCMDdGOTc1MTFFNzgyRTVENTYyQUQwOEQyRUMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpjNTJhMDk0Yy02YmM4LTQyNTctYjZjMy04ZDJmYWJmMzRhN2UiIHN0UmVmOmRvY3VtZW50SUQ9ImFkb2JlOmRvY2lkOnBob3Rvc2hvcDo4ZWVmOGJkMC0xNTEyLTExN2ItYTMzYy1iOTI3NGZjNWEyOTciLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5dmdkDAAAOw0lEQVR42uxcCXgV1RU+87IRtgRDSBTCEqBqRQof0LrvokZBUUFEQUQRF6oiW5Wv7opUQVELgoBKtaigWGhAseJCrRtaURDKFssStqwkkP1N/zNzXnJzMy9vTfIsOd93MnPfzNyZe+c/5/7n3DsxTNOkZmmWY0WijUz/AG8YRvU+G4la9iZmAtHiz5fQyMzxRCkDlMq0e5qG/vvvLDWNXth2x+8nYdsGWgLdCt0C/R7HP8WxjXVvbNh1mQ7P+Pb7zW/9WAZ8xDyJYabi7/XQ4dDf1jIAD4Bt0HdA+SyrbIN6BbYv4ffVza+zWXyJKwKegUH8IHQHdFY12D3eWffSNeD3GMpg/F0FXQrt1vxKmyWSPfzN0CfFu9cGs771HDO8UrBroVdAb4C+21gNGDNmTENUy214EZoYYj1Hod9Cl0EXSDlS5DppI8tdTDa146PkeBZ0EHSXUyWLFi3y9X46Y7MS2pXv01QevgN0OT8vNNXRk9elPP7U2wL6Ds6dEgYg3wjdD/0K2j3M7e8lsUg+dKTD8efDAHaWltCzobOhP0J7O5zDNPIAdAP0xDC382SJtwqgN2nH5kPbi851uHa2jP69xSCClbukjrZcZ+MD3jDPlc69qg6gjRAyRrUNZgb09RCflEGXIhTr5XD2gNTXU0D9jMM5xzVAz6dDP4H20H5/QRxQbwFhONu5UIwoATpTO97WR3sTNdobCmWuvk8wlCYOmizKjdorHsK3hzYNtvJXw9Sh2eK1tkH3of5CAT46yt2VDOMq/PaIdPThIOrPhbaT/fPh5a/G8BkOqsR05TSl7KvvtkPXBnEfHu0GiJf1CLfnL9AzuKfktxxokuyfAx0q8VCowiPH6QG0M+I4PJ/LQ3tKDBmnVhJ1kd93Q8uhMWIAXF7jwBfHA4AvhPi8XHcmQI0g1b0aoK50DGRtGQsdCI0N8l4PQd9Qys8A9JkAfVmIFOMp7bcHfVzzNXRcCF52vNADzxDIxnaueHtPO99UrvmTcN7SENs5PcB2RkaWBuC2cu6maTLAL4EOrjToYhmqmH91FB4eE21j7lQGx3Fu8zFc3OdwHEYU8+gYGTqDlR8B6lugPCzfAbDzC6n047o1ePAc4sk1j/ovS6BfKGXOAE0Isb//IP3lEfbc7zXg+zWl3/WA8GJln4+tU8oc3E0K8b6ToZ2V8idWbBURgI83KN5k9QoG5naZAP128RQToVcy8CXLMhX6sFgwd+QBgP3D3FhjH1XQ2G75WUsoKmlhLZ7tlGp0lv02wK1nWOQnyMMi8OTcIXcrQz/LA/DyqUFW2VkDUhX03kZqzgqt3EUzivugbuW3qZphBiJp0ClaOydQhIhr6IFdVIKQoaSFizq464DegDfvIVH2QrHS7zUQVAcZOHfQ8VXmvNx443VqTa3XrZhelPHZzOGUfErtTItOP9RyDfgXYJ8p1EtN1TkA/XpsFmsB0PQgq2OqEK+UX5YYpDFEp3VHtPJ6LbZqDX0iyHs9JZTGI68IZiID8G+/MYReW/ca7Nukg+3BcGIMSqwBPpiM+a4EWreSnevuqwx736mVAeyU3dbgsLZl5vuzZ5z1xYyp1DaNTFeU77RjzfICDhYvQ3ksRUbe+AFosVIeBS/fP8A6zoIOU8oFjcxpb9DKTgCcpgX3o8gzCei/nCbBqkcOS70RIy4yomnUijvo6OIh9Ph3H1ihTQEDP5Zpjh2Jqpg0GbvRtAs604ylfmYcXWLG01oTNp2djBNKq2jD0imU8RFG6+S+5G7RBhiuqj/lWBN0fgrldTMRs+AFXj5b8+oc9zwH0Bt+9zHRs0rQyPIY9FAjPD6PKM9BL1J+K/OShWH6+KQW8M7WnttXgDzboZ0HIwnw0WZL8JlW51H8ga00bclwuv2kDJrX9yaa1vU8KkmMtcmLJ7RlBl1hbxMrqijNXUbxbveaTuUFa4qjXL/qUrx/7cyPZnRsk7UaDHAgPLuLXAx2Z3BjNwqcqRR+HA6vsvQl4ev2/fiy6DioJJIMmB7Op5gY+wRevGYYjdVPs2SE8yxdOJPsmcI3/biWPaU6ImwNMYD3JTzbfCfVTNq0daAcOV6uZeO4jeycvcdjj9CyVd5kpDYibGvgdgaXtjKHDZTIBc6e45b8/8JL51FFpwG0qP/N9E1yOvXO20ftSwuoW/5OSj6SS3EVR6lleQm1qigiF+hPbBlGLtM9gg7nPk9RriQzMQ0Vu7U4qLa4MbK4SsBeKsopP/XEMUVxCa+QgWfglZi4rgp/25QewT2KcS5i67IinAvnVI57lRViX1hGbAKMANqiFVFUrG0UfF+PMajBOO8v/TCojoJHv1bzjDzVfbIP2tVaXrwa6PI0+d/9yK545K8OlKQ+rp6vcWhVlgrlqKqnDp4QXK6U90hGzlc7t2iB7hAfGSjTYYTwdnyuGLHTCOzrvc2pdqSk5OEZaNYt23WzgviYwr00buUkGheLURHApqoSe4TkchQ8ryvGBhhRBrZPY/trSuhgHTPM+pMplbguOmcHDCtn3zPXLlw/udegE61MvqfZ0tSkKjelVZZxeEEdAfA2VaXUDoBPKc2n5KOHqEfBz9QjF0ZYdJASCnaDMe61DSIuCf4tGYbQCqMIDKgKz1O0n+8XCrVZhs7j9Np5WtblUR/8P7VWmtQ32EMRBnKhA+A5ZnhcqJXbRx0M0o+h50u5k6RT64s5pmhg/0cDp1uDpzQOvldsNgX47sCeG2e5bCTWnuDpLxztUsfrvZm1K5qi935DlNCDbh75Vuyr6ad+TKXUHtVvtmiDQZ97QJ8b66LcuHhr/4eoeJvqyKNU+wMwohNKyunM4mxKP7KP+h3cROdkraOUQ9vBHteTUXEE3r8j5af1o+WnDKYQl3pNkIxGlJK+4yzEbodz9bx9paT/qIEBf4EYVpry+42cWg6gnnug/1baOZHsxWe7vKRbJ2vtnEARKvXPtLo8CKs1+mSQvSAnw687iJGYFl1xk7FrFRV3vZp6D1tAWSntkiiPZiW5zafzXAYvAeBJkD9z8BSNEadSaIm6XxN8oGfZBvF42S1iaWnrrhh9oCefDlO8lQYV7KERO9ZS++KD9G7Pi2huah+L1YYCeHj57+HlXxE+T1Qzc3qDlzRkC6XMMcqmRninWwSg6mTTE5IIqPKzjh8lbXq70k5uz3CHc5/W2snXbQxzm6LChXFG8/E+WH6CDG9zsb9dPEWGX0BXRgRrU7CLNvWdQG1GL6Os9u0oNcd21AD7ZAA4QwKfwYEM+wbTdQTSMWCY8RjMjULbPld26ETXnzmKLr5kEs3t3sdqaWJe2NKUavrueqq9NoblXEnheoTv/HAjOjLm6urs6W8kGA1EHhQq5BFOq56tncPloY2Qbk0J07XsH62lABuEc3GUzp52nlU2zPXWMGYaa8Xau1cD2Xc4XLuct5N29Lhgeq9hs96nOIM655mUq1QDbz1E0lq/h/4Mj/4z2Yuf/BbP4g+Ds6AcYhXZGXSjiGfQiI6EYW0ovPwhjbdzK55XSJZL+lEVXsSW28ij992aR+dnCGTJsVM7Zyk5O5eUDe0eOWF6frWevgGkR3XppeznuoTvvQyAXinc7T7xBlzuZ6W11O9DA1nGW3PeESovHJydkPYAuukyo5jm7o4yLEri8HC8fmWVBIRvh5baMimmYb5Rf0GyLx4ZIOlHKzEA7aNRjDlNQFd5cklNYSQLIAORF+X51bjNs659tJZu3SJ0NJzUTI0Trgois3alkmJl+ckl9ONFST1t9Ntj+y88U9uTomJXtqw4auXxYTt3Ut0PAlS+limdeQ2oDiiXwbnrcyIl8IGXL6e6C6yelGH/cYdAt7KJHnWaRku4308K4PoKL+28juouPZgk54dL9CB7npUJ9B/sp1Dd7xhWq4P8ViCxN3RemB54t/DYa4jXq+u+1zQXSwN+8HI9Z0BewyjwLJSzQfxxAq+SPC5CQL9CRkePnAB9S+OMq6hpZ40PSSZNDeBmBwG8D5Qyp1nfpNrp1g8CzAL5IwzWg9oI9bUYXHo9QE+HPiXnJiuHeD3+fC1Lwxlv1+1CJf5INTnnQIQ5/0wrK2GY5T7O3SwBFVOE8V741z/Fm7B3ukiG6jUwgtvId065oWWipO+ivXjHiRFgm9y3YxXPzjONV1Bg8wH3SubGqZ0NlYbkmGecMAQP+W0FvV+UY7ytAHehHEsQltLFkduiLjipPG9h3FrJzFwN8C7zM/2YKTSlJ3DIQVx5AI3jQPUWWU9PNVtTHZr5k72fBPi8RmSHBItRTYUkdOBG8r6ac47GQ5tKKqhu/j/QFZ/1xSFzxHE1hLwnxuqEpa5ivENFB3oBO68dGot39TciX3l40+Ap5uXYdoO37m95CdM4Hvucdy3B/h7sb7O9rnu7lfQJnusvgtfmL+wXYNvfztzUimo5fcqfp30kwdEKyyDt3PbnuIaNYn8TAIrTjSM0qpUbYhpypzJs7wvDM64WynG5EgQG006eb0jS2vlokM90mGrW+dSXMF4oo/x0CVz9zdaYYjBTAfZtKqfzR7JEVRIeQqbIq2yQjAd37kNezrlQdLlQL+bJZ0jjmPO9So34bzrkpT+icWM9hx2ojBQg7dE4eCjCk4UdRe8P4vp8aZeaiQkl3cqU9DkBpq8PYf4jzi1dtmcIRUtVjOawODwejf7FGADQd9bNvfDisep/TSdLI9X/BaNnabyeq5T1Y1b4tJm+7Tea+mc8aifM3d7/XZ/9r/x4fsCYTM7/xkKVz4TuGNIBvPaDFzPtRT2rY8j4DN6/0kOVyi8PL9rl/9IwreJPAjkN9o48cxX9/wm3k1dODhGncmNTt9PX4rFfDOBjhNIApKcBsKPJzm/H+PC0r+N8Hr7a4ho+9xDK+dhn69+M/d0AfCU1yzEr0b+AZ/wSBvAljOMJAPYygPdSyTLo4GdueY9MZlUJ72Owt8J1/PnhpgrDnAcr/LL5tTcD/pcgnNefD/DOB3g5gOXZTF6P3l2CsBOEn3LqioNq/kiDp6d34PxPo03zK4wYe5tf+bEtRvP/h2+WY0n+J8AAEgauGneaeqgAAAAASUVORK5CYII="

/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 58 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 59 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon_Android@2x.69f41e8.png";

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon_Linux@2x.995a00d.png";

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon_MIVR@2x.fe6ac47.png";

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon_Pico@2x.9b02498.png";

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon_cardborad@2x.812bc67.png";

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon_oculus@2x.1a7cdc4.png";

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon_vive@2x.0a9be6c.png";

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon_xiao@2x.10dc06a.png";

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/mini_program.843a39f.jpg";

/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 70 */,
/* 71 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(50)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(18),
  /* template */
  __webpack_require__(99),
  /* scopeId */
  "data-v-8ca07096",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(36)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(19),
  /* template */
  __webpack_require__(85),
  /* scopeId */
  "data-v-0e43b73b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(43)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(20),
  /* template */
  __webpack_require__(92),
  /* scopeId */
  "data-v-573285e0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(42)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(23),
  /* template */
  __webpack_require__(91),
  /* scopeId */
  "data-v-4d30bb0c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(52)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(24),
  /* template */
  __webpack_require__(101),
  /* scopeId */
  "data-v-b721ae9c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(51)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(25),
  /* template */
  __webpack_require__(100),
  /* scopeId */
  "data-v-97fda7d2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(47)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(26),
  /* template */
  __webpack_require__(96),
  /* scopeId */
  "data-v-67a42eac",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(46)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(27),
  /* template */
  __webpack_require__(95),
  /* scopeId */
  "data-v-6787ffaa",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(45)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(28),
  /* template */
  __webpack_require__(94),
  /* scopeId */
  "data-v-676bd0a8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(41)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(29),
  /* template */
  __webpack_require__(90),
  /* scopeId */
  "data-v-37afaeaf",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(38)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(30),
  /* template */
  __webpack_require__(87),
  /* scopeId */
  "data-v-1ec93cfe",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(39)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(31),
  /* template */
  __webpack_require__(88),
  /* scopeId */
  "data-v-22da6080",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(40)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(32),
  /* template */
  __webpack_require__(89),
  /* scopeId */
  "data-v-22e87801",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(37)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(33),
  /* template */
  __webpack_require__(86),
  /* scopeId */
  "data-v-119fdb94",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 85 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main_content",
    class: {
      english: _vm.$i18n.locale == 'en'
    }
  }, [_c('HeaderLine', {
    ref: "dialog",
    attrs: {
      "index": "13",
      "showbar": "true"
    },
    on: {
      "on-locale-change": _vm.onLocaleChange
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$t('devolop.name')) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "banner"
  }, [_c('img', {
    attrs: {
      "src": _vm.imglist[0],
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: " center "
  }, [_c('ul', {
    staticClass: "download_list main_wrap"
  }, [_c('li', {
    staticClass: "download_list_item"
  }, [_c('h3', {
    staticClass: "download_item_title"
  }, [_vm._v(_vm._s(_vm.$t('devolop.title2')))]), _vm._v(" "), _c('h4', {
    staticClass: "download_item_title2"
  }, [_vm._v(_vm._s(_vm.$t('devolop.title3')))]), _vm._v(" "), _c('ul', {
    staticClass: "download_platforms clearfix",
    staticStyle: {
      "padding-bottom": "0.7rem"
    }
  }, [_c('li', [_c('h3', {
    staticClass: "platform_name"
  }, [_vm._v(_vm._s(_vm.$t('devolop.title4')))]), _vm._v(" "), _c('p', {
    staticClass: "platform_info"
  }, [_vm._v(_vm._s(_vm.$t('devolop.version1')))]), _vm._v(" "), _c('p', {
    staticClass: "platform_info",
    staticStyle: {
      "margin-bottom": "0.4rem"
    }
  }, [_vm._v(_vm._s(_vm.$t('devolop.date1')))]), _vm._v(" "), _c('div', [_c('a', {
    staticClass: "download_button1",
    attrs: {
      "href": "https://github.com/vrviu-sdk/BitPlayer-SDK-Unity/blob/master/README.md",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('devolop.button1')))])]), _vm._v(" "), _c('div', [_c('a', {
    staticClass: "download_button2",
    attrs: {
      "href": "https://github.com/vrviu-sdk/BitPlayer-SDK-Unity",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('devolop.button2')))])])]), _vm._v(" "), _c('li', [_c('h3', {
    staticClass: "platform_name"
  }, [_vm._v(_vm._s(_vm.$t('devolop.title55')))]), _vm._v(" "), _c('p', {
    staticClass: "platform_info"
  }, [_vm._v(_vm._s(_vm.$t('devolop.version2')))]), _vm._v(" "), _c('p', {
    staticClass: "platform_info",
    staticStyle: {
      "margin-bottom": "0.4rem"
    }
  }, [_vm._v(_vm._s(_vm.$t('devolop.date2')))]), _vm._v(" "), _c('div', [_c('a', {
    staticClass: "download_button1",
    attrs: {
      "href": "https://github.com/vrviu-sdk/BitPlayer-SDK-Web/blob/master/README.md",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('devolop.button1')))])]), _vm._v(" "), _c('div', [_c('a', {
    staticClass: "download_button2",
    attrs: {
      "href": "https://github.com/vrviu-sdk/BitPlayer-SDK-Web",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('devolop.button2')))])])])])])]), _vm._v(" "), _c('ul', {
    staticClass: "download_list main_wrap"
  }, [_c('li', {
    staticClass: "download_list_item"
  }, [_c('h3', {
    staticClass: "download_item_title"
  }, [_vm._v(_vm._s(_vm.$t('devolop.title5')))]), _vm._v(" "), _c('h4', {
    staticClass: "download_item_title2"
  }, [_vm._v(_vm._s(_vm.$t('devolop.title6')))]), _vm._v(" "), _c('ul', {
    staticClass: "download_platforms clearfix",
    staticStyle: {
      "padding-bottom": "1rem"
    }
  }, [_c('li', [_c('h3', {
    staticClass: "platform_name"
  }, [_vm._v(_vm._s(_vm.$t('devolop.title7')))]), _vm._v(" "), _c('p', {
    staticClass: "platform_info"
  }, [_vm._v(_vm._s(_vm.$t('devolop.version3')))]), _vm._v(" "), _c('p', {
    staticClass: "platform_info",
    staticStyle: {
      "margin-bottom": "0.4rem"
    }
  }, [_vm._v(_vm._s(_vm.$t('devolop.date3')))]), _vm._v(" "), _c('div', [_c('a', {
    staticClass: "download_button1",
    attrs: {
      "href": "https://github.com/vrviu-sdk/AltPlayer-SDK-iOS/blob/master/README.md",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('devolop.button1')))])]), _vm._v(" "), _c('div', [_c('a', {
    staticClass: "download_button2",
    attrs: {
      "href": "https://github.com/vrviu-sdk/AltPlayer-SDK-iOS",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('devolop.button2')))])])]), _vm._v(" "), _c('li', [_c('h3', {
    staticClass: "platform_name"
  }, [_vm._v(_vm._s(_vm.$t('devolop.title8')))]), _vm._v(" "), _c('p', {
    staticClass: "platform_info"
  }, [_vm._v(_vm._s(_vm.$t('devolop.Version4')))]), _vm._v(" "), _c('p', {
    staticClass: "platform_info",
    staticStyle: {
      "margin-bottom": "0.4rem"
    }
  }, [_vm._v(_vm._s(_vm.$t('devolop.date4')))]), _vm._v(" "), _c('div', [_c('a', {
    staticClass: "download_button1",
    attrs: {
      "href": "https://github.com/vrviu-sdk/AltPlayer-SDK-Android/blob/master/README.md",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('devolop.button1')))])]), _vm._v(" "), _c('div', [_c('a', {
    staticClass: "download_button2",
    attrs: {
      "href": "https://github.com/vrviu-sdk/AltPlayer-SDK-Android",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('devolop.button2')))])])]), _vm._v(" "), _c('li', [_c('h3', {
    staticClass: "platform_name"
  }, [_vm._v(_vm._s(_vm.$t('devolop.title9')))]), _vm._v(" "), _c('p', {
    staticClass: "platform_info"
  }, [_vm._v(_vm._s(_vm.$t('devolop.version5')))]), _vm._v(" "), _c('p', {
    staticClass: "platform_info",
    staticStyle: {
      "margin-bottom": "0.4rem"
    }
  }, [_vm._v(_vm._s(_vm.$t('devolop.date5')))]), _vm._v(" "), _c('div', [_c('a', {
    staticClass: "download_button1",
    attrs: {
      "href": "https://github.com/vrviu-sdk/AltPlayer-SDK-Web/blob/master/README.md",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('devolop.button1')))])]), _vm._v(" "), _c('div', [_c('a', {
    staticClass: "download_button2",
    attrs: {
      "href": "https://github.com/vrviu-sdk/AltPlayer-SDK-Web",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('devolop.button2')))])])])])])])]), _vm._v(" "), _c('Footerline')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 86 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      english: _vm.$i18n.locale == 'en'
    }
  }, [_c('headerLine', {
    ref: "dialog",
    attrs: {
      "showbar": "true",
      "index": "9"
    },
    on: {
      "on-locale-change": _vm.onLocaleChange
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('technology.name')) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "banner"
  }, [_c('img', {
    attrs: {
      "src": _vm.imglist[0],
      "alt": ""
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "banner_title"
  }, [_vm._v("\n            THE HIGHWAY TO ULTRA HD\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "content center"
  }, [_c('div', {
    staticClass: "content_item"
  }, [_c('h3', {
    staticClass: "content_item_title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('technology.text2'))
    }
  }, [_vm._v("\n            挑战高清极限：4K，6K，8K\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "content_item_text content_item_text1",
    staticStyle: {
      "width": "90%",
      "margin-left": "auto",
      "margin-right": "auto",
      "text-align": "justify"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('technology.text3'))
    }
  }, [_vm._v("\n            威尔直播自研VR高清直播／点播编解码算法，\n          ")]), _vm._v(" "), (_vm.$i18n.locale == 'ch') ? _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[1]),
      expression: "imglist[1]"
    }],
    staticStyle: {
      "width": "6.85rem",
      "height": "3.2rem",
      "margin-right": "auto",
      "margin-left": "auto"
    },
    attrs: {
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'en') ? _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[9]),
      expression: "imglist[9]"
    }],
    staticStyle: {
      "width": "6.85rem",
      "height": "3.2rem",
      "margin-right": "auto",
      "margin-left": "auto"
    },
    attrs: {
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "compareWords clearfix",
    staticStyle: {
      "margin-top": "0.4rem"
    }
  }, [_c('div', {
    staticClass: "fl"
  }, [_c('div', {
    staticClass: "center",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('technology.text30'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fr"
  }, [_c('div', {
    staticClass: "center",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('technology.text31'))
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "compareWords",
    staticStyle: {
      "margin-top": "0.4rem"
    }
  }, [_c('div', {
    staticClass: "center",
    staticStyle: {
      "margin-bottom": "0.7rem"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('technology.text32'))
    }
  })])]), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "content_item clearfix",
    staticStyle: {
      "background": "#f3faff",
      "padding-bottom": "0.7rem"
    }
  }, [_c('div', {
    staticClass: "fr",
    staticStyle: {
      "margin-right": "0.5rem"
    }
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[3]),
      expression: "imglist[3]"
    }],
    staticStyle: {
      "width": "3.3rem",
      "height": "2.31rem",
      "margin-top": "0.1rem"
    },
    attrs: {
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fr content_item_title2",
    staticStyle: {
      "margin-top": "0.8rem",
      "text-align": "left"
    }
  }, [_c('h3', {
    staticClass: "content_item_title content_item_title1",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('technology.text4'))
    }
  }, [_vm._v("\n                    上行带宽节省70%\n                  ")]), _vm._v(" "), _c('h3', {
    staticClass: "content_item_title ",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('technology.text5'))
    }
  }, [_vm._v("\n                    开启全民VR直播时代\n                  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "content_item clearfix",
    staticStyle: {
      "padding-bottom": "0.7rem",
      "padding-top": "0.5rem"
    }
  }, [_c('div', {
    staticClass: "fl"
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[2]),
      expression: "imglist[2]"
    }],
    staticStyle: {
      "width": "3.4rem",
      "height": "2.2rem",
      "margin-top": "0.3rem"
    },
    attrs: {
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fl content_item_title3",
    staticStyle: {
      "margin-top": "0.9rem",
      "margin-left": "0.5rem",
      "text-align": "left"
    }
  }, [_c('h3', {
    staticClass: "content_item_title content_item_title1",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('technology.text8'))
    }
  }, [_vm._v("\n                    下行带宽节省70%\n                  ")]), _vm._v(" "), _c('h3', {
    staticClass: "content_item_title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('technology.text9'))
    }
  }, [_vm._v("\n                    4K高清不在话下\n                  ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "content_item",
    staticStyle: {
      "background": "#f3faff"
    }
  }, [_c('div', {
    staticClass: "content_item_title content_item_title1",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('technology.text23'))
    }
  }, [_vm._v("\n            专利音频编解码\n          ")]), _vm._v(" "), _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[7]),
      expression: "imglist[7]"
    }],
    staticStyle: {
      "width": "5.68rem",
      "height": "2.91rem",
      "margin": "0.4rem auto 0 auto"
    },
    attrs: {
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content_item item_bg4"
  }, [_c('div', {
    staticClass: "content_item_title content_item_title1 white",
    staticStyle: {
      "margin-top": "2.64rem"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('technology.text25'))
    }
  }, [_vm._v("\n              下载体验Demo App\n            ")]), _vm._v(" "), (_vm.$i18n.locale == 'en') ? _c('div', {
    staticClass: "content_item_text ",
    staticStyle: {
      "color": "#fff",
      "margin": "0.3rem 0",
      "font-size": "0.22rem",
      "margin-bottom": "0"
    }
  }, [_vm._v("\n              Experience our quality 4K streaming in sporting"), _c('br'), _vm._v("\n              events, concerts, and eSports through our demo. \n            ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "center",
    staticStyle: {
      "margin-bottom": "0.3rem"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/download"
    }
  }, [_c('a', {
    staticClass: "button_default",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('technology.text27'))
    }
  }, [_vm._v("下载Demo")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('router-link', {
    staticClass: "button_default",
    attrs: {
      "to": "/solution"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('technology.text28'))
    }
  }, [_vm._v("应用场景")])], 1)])]), _vm._v(" "), _c('footerLine')], 1)
},staticRenderFns: []}

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "touch",
      rawName: "v-touch:swipe.top",
      value: (_vm.swipeup),
      expression: "swipeup",
      arg: "swipe",
      modifiers: {
        "top": true
      }
    }, {
      name: "touch",
      rawName: "v-touch:swipe.bottom",
      value: (_vm.swipedown),
      expression: "swipedown",
      arg: "swipe",
      modifiers: {
        "bottom": true
      }
    }],
    class: {
      english: _vm.$i18n.locale == 'en'
    }
  }, [_c('headLine', {
    ref: "dialog",
    attrs: {
      "showbar": "true",
      "index": "6"
    },
    on: {
      "on-locale-change": _vm.onLocaleChange
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('solution.name')) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "banner"
  }, [_c('img', {
    attrs: {
      "src": _vm.imglist[0],
      "alt": ""
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "banner_title",
    staticStyle: {
      "top": "2.77rem"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('solution.banner_text'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "center",
    staticStyle: {
      "position": "absolute",
      "top": "4.4rem",
      "width": "100%"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/download"
    }
  }, [_c('a', {
    staticClass: "button_default",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('solution.banner_botton'))
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content center"
  }, [_c('div', {
    staticClass: "content_item",
    staticStyle: {
      "margin-bottom": "0.7rem"
    }
  }, [_c('h3', {
    staticClass: "content_item_title",
    staticStyle: {
      "width": "90%",
      "margin": "0 auto"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('solution.title1'))
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "content_item_text content_item_text1",
    staticStyle: {
      "width": "90%",
      "margin-left": "auto",
      "margin-right": "auto",
      "text-align": "justify"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('solution.text1'))
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "content_item_text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('solution.text2'))
    }
  }), _vm._v(" "), (_vm.$i18n.locale == 'ch') ? _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[1]),
      expression: "imglist[1]"
    }],
    staticStyle: {
      "width": "6.86rem",
      "height": "3.98rem",
      "margin": "0.7rem auto 0 auto"
    },
    attrs: {
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'en') ? _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[10]),
      expression: "imglist[10]"
    }],
    staticStyle: {
      "width": "6.86rem",
      "height": "3.98rem",
      "margin": "0.7rem auto 0 auto"
    },
    attrs: {
      "alt": ""
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "content_item",
    staticStyle: {
      "background": "#f3f9ff",
      "padding-bottom": "0.7rem"
    }
  }, [_c('div', [_c('div', {
    staticClass: "picture_list clearfix"
  }, [_c('div', {
    staticClass: "fl left_pic "
  }, [_c('div', {
    staticClass: "pic_box"
  }, [_c('div', {
    staticClass: "middle pic_box_text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('solution.text4'))
    }
  }, [_vm._v("\n                      秀场VR直播\n                    ")]), _vm._v(" "), _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[2]),
      expression: "imglist[2]"
    }],
    staticStyle: {
      "margin-top": "0"
    },
    attrs: {
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "fr right_pics"
  }, [_c('div', {
    staticClass: "pic_box"
  }, [_c('div', {
    staticClass: "middle pic_box_text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('solution.text6'))
    }
  }, [_vm._v("\n                      体育VR直播\n                    ")]), _vm._v(" "), _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[3]),
      expression: "imglist[3]"
    }],
    staticStyle: {
      "margin-top": "0"
    },
    attrs: {
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pic_box"
  }, [_c('div', {
    staticClass: "middle pic_box_text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('solution.text8'))
    }
  }, [_vm._v("\n                      演出VR直播\n                    ")]), _vm._v(" "), _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[4]),
      expression: "imglist[4]"
    }],
    staticStyle: {
      "margin-top": "0"
    },
    attrs: {
      "alt": ""
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content_item",
    staticStyle: {
      "padding-bottom": "0.7rem"
    }
  }, [_c('h3', {
    staticClass: "content_item_title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('solution.text19'))
    }
  }, [_vm._v(" \n              威尔云 6 大特性 \n            ")]), _vm._v(" "), _c('div', {
    staticClass: "feature clearfix"
  }, [_c('div', {
    staticClass: "fl"
  }, [_c('ul', [_c('li', [_c('span', {
    staticClass: "feature_pic feature_pic1"
  }), _vm._v(" "), _c('h3', {
    staticClass: "content_item_title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('solution.text20'))
    }
  }, [_vm._v(" \n                      低宽带\n                    ")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "feature_pic feature_pic2"
  }), _vm._v(" "), _c('h3', {
    staticClass: "content_item_title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('solution.text24'))
    }
  }, [_vm._v(" \n                      低功耗\n                    ")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "feature_pic feature_pic3"
  }), _vm._v(" "), _c('h3', {
    staticClass: "content_item_title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('solution.text28'))
    }
  }, [_vm._v(" \n                      服务稳定可靠\n                    ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "fr"
  }, [_c('ul', [_c('li', [_c('span', {
    staticClass: "feature_pic feature_pic4"
  }), _vm._v(" "), _c('h3', {
    staticClass: "content_item_title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('solution.text22'))
    }
  }, [_vm._v(" \n                      低延迟\n                    ")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "feature_pic feature_pic5"
  }), _vm._v(" "), _c('h3', {
    staticClass: "content_item_title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('solution.text26'))
    }
  }, [_vm._v(" \n                      标准协议\n                    ")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "feature_pic feature_pic6"
  }), _vm._v(" "), _c('h3', {
    staticClass: "content_item_title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('solution.text30'))
    }
  }, [_vm._v(" \n                      多终端适配\n                    ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('router-link', {
    staticClass: "button_default2",
    staticStyle: {
      "margin-top": "0.2rem"
    },
    attrs: {
      "to": "/technology"
    }
  }, [_vm._v(_vm._s(_vm.$t('solution.text32')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content_item ",
    staticStyle: {
      "background": "#f3f9ff",
      "padding-bottom": "0.7rem"
    }
  }, [_c('div', {
    attrs: {
      "clas": "multi-platform"
    }
  }, [_c('h3', {
    staticClass: "content_item_title"
  }, [_vm._v("\n                      " + _vm._s(_vm.$t('solution.text33')) + "\n                    ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "multi-platform_button"
  }, [_c('a', {
    staticClass: "button_default2",
    staticStyle: {
      "margin-top": "2.48rem"
    },
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.showDialog()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('solution.text34')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "requestion_wrap"
  }, [_c('div', {
    staticClass: "requestion"
  }, [_c('h3', {
    staticClass: "requestion_title"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('solution.text35')) + "\n              ")]), _vm._v(" "), _c('dl', [_c('dt', {
    on: {
      "click": function($event) {
        _vm.show1 = !_vm.show1
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('solution.text36'))), _c('span', {
    staticClass: "fold_button",
    class: {
      fold_button2: _vm.show1
    }
  })]), _vm._v(" "), _c('dd', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show1),
      expression: "show1"
    }]
  }, [_vm._v(_vm._s(_vm.$t('solution.text37')))])]), _vm._v(" "), _c('dl', [_c('dt', {
    on: {
      "click": function($event) {
        _vm.show2 = !_vm.show2
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('solution.text38'))), _c('span', {
    staticClass: "fold_button",
    class: {
      fold_button2: _vm.show2
    }
  })]), _vm._v(" "), _c('dd', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show2),
      expression: "show2"
    }]
  }, [_vm._v(_vm._s(_vm.$t('solution.text39')))])]), _vm._v(" "), _c('dl', [_c('dt', {
    on: {
      "click": function($event) {
        _vm.show3 = !_vm.show3
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('solution.text40'))), _c('span', {
    staticClass: "fold_button",
    class: {
      fold_button2: _vm.show3
    }
  })]), _vm._v(" "), _c('dd', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show3),
      expression: "show3"
    }]
  }, [_vm._v(_vm._s(_vm.$t('solution.text41')))])]), _vm._v(" "), _c('dl', [_c('dt', {
    on: {
      "click": function($event) {
        _vm.show4 = !_vm.show4
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('solution.text42'))), _c('span', {
    staticClass: "fold_button",
    class: {
      fold_button2: _vm.show4
    }
  })]), _vm._v(" "), _c('dd', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show4),
      expression: "show4"
    }]
  }, [_vm._v(_vm._s(_vm.$t('solution.text43')))])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.imglist[7]),
      expression: "imglist[7]",
      arg: "background-image"
    }],
    staticClass: "content_item content_bg"
  }, [_c('div', {
    staticClass: "center"
  }, [_c('a', {
    staticClass: "button_default2",
    staticStyle: {
      "margin-bottom": "2.26rem"
    },
    on: {
      "click": function($event) {
        _vm.showDialog2()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('solution.text45')))])])])]), _vm._v(" "), _c('footerLine')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', {
    staticClass: "platform_pic clearfix"
  }, [_c('li', [_c('img', {
    attrs: {
      "src": __webpack_require__(6),
      "alt": ""
    }
  })]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": __webpack_require__(8),
      "alt": ""
    }
  })]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": __webpack_require__(12),
      "alt": ""
    }
  })]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": __webpack_require__(7),
      "alt": ""
    }
  })])])])
}]}

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "touch",
      rawName: "v-touch:swipe.top",
      value: (_vm.swipeup),
      expression: "swipeup",
      arg: "swipe",
      modifiers: {
        "top": true
      }
    }, {
      name: "touch",
      rawName: "v-touch:swipe.bottom",
      value: (_vm.swipedown),
      expression: "swipedown",
      arg: "swipe",
      modifiers: {
        "bottom": true
      }
    }],
    class: {
      english: _vm.$i18n.locale == 'en'
    }
  }, [_c('headLine', {
    ref: "dialog",
    attrs: {
      "showbar": "true",
      "index": "7"
    },
    on: {
      "on-locale-change": _vm.onLocaleChange
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('solution2.name')) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "banner"
  }, [_c('img', {
    attrs: {
      "src": _vm.imglist[0],
      "alt": ""
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "banner_title",
    staticStyle: {
      "top": "2.77rem"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('solution2.banner_text'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "center",
    staticStyle: {
      "position": "absolute",
      "top": "4.4rem",
      "width": "100%"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/download"
    }
  }, [_c('a', {
    staticClass: "button_default",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('solution2.banner_botton'))
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content center"
  }, [_c('div', {
    staticClass: "content_item",
    staticStyle: {
      "padding-bottom": "0.7rem"
    }
  }, [_c('h3', {
    staticClass: "content_item_title",
    staticStyle: {
      "width": "90%",
      "margin": "0 auto"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('solution2.title1'))
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "content_item_text content_item_text1",
    staticStyle: {
      "width": "90%",
      "margin-left": "auto",
      "margin-right": "auto",
      "text-align": "justify"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('solution2.text1'))
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "content_item_text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('solution2.text2'))
    }
  }), _vm._v(" "), (_vm.$i18n.locale == 'ch') ? _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[1]),
      expression: "imglist[1]"
    }],
    staticStyle: {
      "width": "6.87rem",
      "height": "3.37rem",
      "margin": "0.7rem auto 0 auto"
    },
    attrs: {
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'en') ? _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[10]),
      expression: "imglist[10]"
    }],
    staticStyle: {
      "width": "6.87rem",
      "height": "3.37rem",
      "margin": "0.7rem auto 0 auto"
    },
    attrs: {
      "alt": ""
    }
  }) : _vm._e()]), _vm._v(" "), _c('div'), _vm._v(" "), _c('div', {
    staticClass: "content_item",
    staticStyle: {
      "padding-bottom": "0.7rem"
    }
  }, [_c('h3', {
    staticClass: "content_item_title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('solution2.text19'))
    }
  }, [_vm._v(" \n              威尔云 6 大特性 \n            ")]), _vm._v(" "), _c('div', {
    staticClass: "feature clearfix"
  }, [_c('div', {
    staticClass: "fl"
  }, [_c('ul', [_c('li', [_c('span', {
    staticClass: "feature_pic feature_pic1"
  }), _vm._v(" "), _c('h3', {
    staticClass: "content_item_title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('solution2.text20'))
    }
  }, [_vm._v(" \n                      低宽带\n                    ")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "feature_pic feature_pic2"
  }), _vm._v(" "), _c('h3', {
    staticClass: "content_item_title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('solution2.text24'))
    }
  }, [_vm._v(" \n                      低功耗\n                    ")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "feature_pic feature_pic3"
  }), _vm._v(" "), _c('h3', {
    staticClass: "content_item_title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('solution2.text28'))
    }
  }, [_vm._v(" \n                      服务稳定可靠\n                    ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "fr"
  }, [_c('ul', [_c('li', [_c('span', {
    staticClass: "feature_pic feature_pic4"
  }), _vm._v(" "), _c('h3', {
    staticClass: "content_item_title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('solution2.text22'))
    }
  }, [_vm._v(" \n                      低延迟\n                    ")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "feature_pic feature_pic5"
  }), _vm._v(" "), _c('h3', {
    staticClass: "content_item_title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('solution2.text26'))
    }
  }, [_vm._v(" \n                      标准协议\n                    ")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "feature_pic feature_pic6"
  }), _vm._v(" "), _c('h3', {
    staticClass: "content_item_title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('solution2.text30'))
    }
  }, [_vm._v(" \n                      多终端适配\n                    ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('router-link', {
    staticClass: "button_default2",
    staticStyle: {
      "margin-top": "0.2rem"
    },
    attrs: {
      "to": "/technology"
    }
  }, [_vm._v(_vm._s(_vm.$t('solution2.text32')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content_item ",
    staticStyle: {
      "background": "#f3f9ff",
      "padding-bottom": "0.7rem"
    }
  }, [_c('div', {
    attrs: {
      "clas": "multi-platform"
    }
  }, [_c('h3', {
    staticClass: "content_item_title"
  }, [_vm._v("\n                      " + _vm._s(_vm.$t('solution2.text33')) + "\n                    ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "multi-platform_button"
  }, [_c('a', {
    staticClass: "button_default2",
    staticStyle: {
      "margin-top": "2.48rem"
    },
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.showDialog()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('solution2.text34')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "requestion_wrap"
  }, [_c('div', {
    staticClass: "requestion"
  }, [_c('h3', {
    staticClass: "requestion_title"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('solution2.text35')) + "\n              ")]), _vm._v(" "), _c('dl', [_c('dt', {
    on: {
      "click": function($event) {
        _vm.show1 = !_vm.show1
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('solution2.text36'))), _c('span', {
    staticClass: "fold_button",
    class: {
      fold_button2: _vm.show1
    }
  })]), _vm._v(" "), _c('dd', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show1),
      expression: "show1"
    }]
  }, [_vm._v(_vm._s(_vm.$t('solution2.text37')))])]), _vm._v(" "), _c('dl', [_c('dt', {
    on: {
      "click": function($event) {
        _vm.show2 = !_vm.show2
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('solution2.text38'))), _c('span', {
    staticClass: "fold_button",
    class: {
      fold_button2: _vm.show2
    }
  })]), _vm._v(" "), _c('dd', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show2),
      expression: "show2"
    }]
  }, [_vm._v(_vm._s(_vm.$t('solution2.text39')))])]), _vm._v(" "), _c('dl', [_c('dt', {
    on: {
      "click": function($event) {
        _vm.show3 = !_vm.show3
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('solution2.text40'))), _c('span', {
    staticClass: "fold_button",
    class: {
      fold_button2: _vm.show3
    }
  })]), _vm._v(" "), _c('dd', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show3),
      expression: "show3"
    }]
  }, [_vm._v(_vm._s(_vm.$t('solution2.text41')))])]), _vm._v(" "), _c('dl', [_c('dt', {
    on: {
      "click": function($event) {
        _vm.show4 = !_vm.show4
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('solution2.text42'))), _c('span', {
    staticClass: "fold_button",
    class: {
      fold_button2: _vm.show4
    }
  })]), _vm._v(" "), _c('dd', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show4),
      expression: "show4"
    }],
    domProps: {
      "innerHTML": _vm._s(_vm.$t('solution2.text43'))
    }
  })])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.imglist[7]),
      expression: "imglist[7]",
      arg: "background-image"
    }],
    staticClass: "content_item content_bg"
  }, [_c('div', {
    staticClass: "center"
  }, [_c('a', {
    staticClass: "button_default2",
    staticStyle: {
      "margin-bottom": "2.26rem"
    },
    on: {
      "click": function($event) {
        _vm.showDialog2()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('solution2.text45')))])])])]), _vm._v(" "), _c('footerLine')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', {
    staticClass: "platform_pic clearfix"
  }, [_c('li', [_c('img', {
    attrs: {
      "src": __webpack_require__(6),
      "alt": ""
    }
  })]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": __webpack_require__(8),
      "alt": ""
    }
  })]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": __webpack_require__(12),
      "alt": ""
    }
  })]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": __webpack_require__(7),
      "alt": ""
    }
  })])])])
}]}

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "touch",
      rawName: "v-touch:swipe.top",
      value: (_vm.swipeup),
      expression: "swipeup",
      arg: "swipe",
      modifiers: {
        "top": true
      }
    }, {
      name: "touch",
      rawName: "v-touch:swipe.bottom",
      value: (_vm.swipedown),
      expression: "swipedown",
      arg: "swipe",
      modifiers: {
        "bottom": true
      }
    }],
    class: {
      english: _vm.$i18n.locale == 'en'
    }
  }, [_c('headLine', {
    ref: "dialog",
    attrs: {
      "showbar": "true",
      "index": "8"
    },
    on: {
      "on-locale-change": _vm.onLocaleChange
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('solution3.name')) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "banner"
  }, [_c('img', {
    attrs: {
      "src": _vm.imglist[0],
      "alt": ""
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "banner_title",
    staticStyle: {
      "top": "2.77rem"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('solution3.banner_text'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "center",
    staticStyle: {
      "position": "absolute",
      "top": "4.4rem",
      "width": "100%"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/download"
    }
  }, [_c('a', {
    staticClass: "button_default",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('solution3.banner_botton'))
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content center"
  }, [_c('div', {
    staticClass: "content_item",
    staticStyle: {
      "padding-bottom": "0.7rem"
    }
  }, [_c('h3', {
    staticClass: "content_item_title",
    staticStyle: {
      "width": "90%",
      "margin": "0 auto"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('solution3.title1'))
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "content_item_text content_item_text1",
    staticStyle: {
      "width": "90%",
      "margin-left": "auto",
      "margin-right": "auto",
      "text-align": "justify"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('solution3.text1'))
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "content_item_text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('solution3.text2'))
    }
  }), _vm._v(" "), (_vm.$i18n.locale == 'ch') ? _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[1]),
      expression: "imglist[1]"
    }],
    staticStyle: {
      "width": "6.86rem",
      "height": "3.37rem",
      "margin": "0.7rem auto 0 auto"
    },
    attrs: {
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'en') ? _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[10]),
      expression: "imglist[10]"
    }],
    staticStyle: {
      "width": "6.86rem",
      "height": "3.37rem",
      "margin": "0.7rem auto 0 auto"
    },
    attrs: {
      "alt": ""
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "content_item",
    staticStyle: {
      "background": "#f3f9ff",
      "padding-bottom": "0.7rem"
    }
  }, [_c('div', [_c('div', {
    staticClass: "picture_list clearfix"
  }, [_c('div', {
    staticClass: "fl left_pic "
  }, [_c('div', {
    staticClass: "pic_box"
  }, [_c('div', {
    staticClass: "middle pic_box_text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('solution3.text4'))
    }
  }, [_vm._v("\n                      秀场VR直播\n                    ")]), _vm._v(" "), _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[2]),
      expression: "imglist[2]"
    }],
    staticStyle: {
      "margin-top": "0"
    },
    attrs: {
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "fr right_pics"
  }, [_c('div', {
    staticClass: "pic_box"
  }, [_c('div', {
    staticClass: "middle pic_box_text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('solution3.text6'))
    }
  }, [_vm._v("\n                      体育VR直播\n                    ")]), _vm._v(" "), _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[3]),
      expression: "imglist[3]"
    }],
    staticStyle: {
      "margin-top": "0"
    },
    attrs: {
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pic_box"
  }, [_c('div', {
    staticClass: "middle pic_box_text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('solution3.text8'))
    }
  }, [_vm._v("\n                      演出VR直播\n                    ")]), _vm._v(" "), _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[4]),
      expression: "imglist[4]"
    }],
    staticStyle: {
      "margin-top": "0"
    },
    attrs: {
      "alt": ""
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content_item",
    staticStyle: {
      "padding-bottom": "0.7rem"
    }
  }, [_c('h3', {
    staticClass: "content_item_title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('solution3.text19'))
    }
  }, [_vm._v(" \n              威尔云 6 大特性 \n            ")]), _vm._v(" "), _c('div', {
    staticClass: "feature clearfix"
  }, [_c('div', {
    staticClass: "fl"
  }, [_c('ul', [_c('li', [_c('span', {
    staticClass: "feature_pic feature_pic1"
  }), _vm._v(" "), _c('h3', {
    staticClass: "content_item_title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('solution3.text20'))
    }
  }, [_vm._v(" \n                      低宽带\n                    ")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "feature_pic feature_pic5"
  }), _vm._v(" "), _c('h3', {
    staticClass: "content_item_title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('solution3.text24'))
    }
  }, [_vm._v(" \n                      低功耗\n                    ")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "feature_pic feature_pic7"
  }), _vm._v(" "), _c('h3', {
    staticClass: "content_item_title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('solution3.text28'))
    }
  }, [_vm._v(" \n                      服务稳定可靠\n                    ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "fr"
  }, [_c('ul', [_c('li', [_c('span', {
    staticClass: "feature_pic feature_pic2"
  }), _vm._v(" "), _c('h3', {
    staticClass: "content_item_title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('solution3.text22'))
    }
  }, [_vm._v(" \n                      低延迟\n                    ")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "feature_pic feature_pic3"
  }), _vm._v(" "), _c('h3', {
    staticClass: "content_item_title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('solution3.text26'))
    }
  }, [_vm._v(" \n                      标准协议\n                    ")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "feature_pic feature_pic6"
  }), _vm._v(" "), _c('h3', {
    staticClass: "content_item_title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('solution3.text30'))
    }
  }, [_vm._v(" \n                      多终端适配\n                    ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('router-link', {
    staticClass: "button_default2",
    staticStyle: {
      "margin-top": "0.2rem"
    },
    attrs: {
      "to": "/technology"
    }
  }, [_vm._v(_vm._s(_vm.$t('solution3.text32')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content_item ",
    staticStyle: {
      "background": "#f3f9ff",
      "padding-bottom": "0.7rem"
    }
  }, [_c('div', {
    attrs: {
      "clas": "multi-platform"
    }
  }, [_c('h3', {
    staticClass: "content_item_title"
  }, [_vm._v("\n                      " + _vm._s(_vm.$t('solution3.text33')) + "\n                    ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "multi-platform_button"
  }, [_c('a', {
    staticClass: "button_default2",
    staticStyle: {
      "margin-top": "2.48rem"
    },
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.showDialog()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('solution3.text34')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "requestion_wrap"
  }, [_c('div', {
    staticClass: "requestion"
  }, [_c('h3', {
    staticClass: "requestion_title"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('solution3.text35')) + "\n              ")]), _vm._v(" "), _c('dl', [_c('dt', {
    on: {
      "click": function($event) {
        _vm.show1 = !_vm.show1
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('solution3.text36'))), _c('span', {
    staticClass: "fold_button",
    class: {
      fold_button2: _vm.show1
    }
  })]), _vm._v(" "), _c('dd', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show1),
      expression: "show1"
    }]
  }, [_vm._v(_vm._s(_vm.$t('solution3.text37')))])]), _vm._v(" "), _c('dl', [_c('dt', {
    on: {
      "click": function($event) {
        _vm.show2 = !_vm.show2
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('solution3.text38'))), _c('span', {
    staticClass: "fold_button",
    class: {
      fold_button2: _vm.show2
    }
  })]), _vm._v(" "), _c('dd', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show2),
      expression: "show2"
    }]
  }, [_vm._v(_vm._s(_vm.$t('solution3.text39')))])]), _vm._v(" "), _c('dl', [_c('dt', {
    on: {
      "click": function($event) {
        _vm.show3 = !_vm.show3
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('solution3.text40'))), _c('span', {
    staticClass: "fold_button",
    class: {
      fold_button2: _vm.show3
    }
  })]), _vm._v(" "), _c('dd', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show3),
      expression: "show3"
    }]
  }, [_vm._v(_vm._s(_vm.$t('solution3.text41')))])]), _vm._v(" "), _c('dl', [_c('dt', {
    on: {
      "click": function($event) {
        _vm.show4 = !_vm.show4
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('solution3.text42'))), _c('span', {
    staticClass: "fold_button",
    class: {
      fold_button2: _vm.show4
    }
  })]), _vm._v(" "), _c('dd', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show4),
      expression: "show4"
    }]
  }, [_vm._v(_vm._s(_vm.$t('solution3.text43')))])]), _vm._v(" "), _c('dl', [_c('dt', {
    on: {
      "click": function($event) {
        _vm.show5 = !_vm.show5
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('solution3.text47'))), _c('span', {
    staticClass: "fold_button",
    class: {
      fold_button2: _vm.show5
    }
  })]), _vm._v(" "), _c('dd', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show5),
      expression: "show5"
    }]
  }, [_vm._v(_vm._s(_vm.$t('solution3.text48')))])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.imglist[7]),
      expression: "imglist[7]",
      arg: "background-image"
    }],
    staticClass: "content_item content_bg"
  }, [_c('div', {
    staticClass: "center"
  }, [_c('a', {
    staticClass: "button_default2",
    staticStyle: {
      "margin-bottom": "2.26rem"
    },
    on: {
      "click": function($event) {
        _vm.showDialog2()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('solution3.text45')))])])])]), _vm._v(" "), _c('footerLine')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', {
    staticClass: "platform_pic clearfix"
  }, [_c('li', [_c('img', {
    attrs: {
      "src": __webpack_require__(6),
      "alt": ""
    }
  })]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": __webpack_require__(8),
      "alt": ""
    }
  })]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": __webpack_require__(7),
      "alt": ""
    }
  })])])])
}]}

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      english: _vm.$i18n.locale == 'en'
    }
  }, [_c('HeaderLine', {
    ref: "dialog",
    attrs: {
      "index": "12",
      "showbar": "true"
    },
    on: {
      "on-locale-change": _vm.onLocaleChange
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('software.name')) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "banner",
    staticStyle: {
      "height": "5rem"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imglist[0],
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "introduction center"
  }, [_c('ul', {
    staticClass: "download_list main_wrap"
  }, [_c('li', {
    staticClass: "download_list_item"
  }, [_c('h3', {
    staticClass: "download_item_title",
    attrs: {
      "id": "anchor1"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('software.introduction_title'))
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "download_item_title2",
    staticStyle: {
      "line-height": "1.6em"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('software.introduction_title2'))
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "download_platforms clearfix platform_pic"
  }, [_c('li', [_c('div', {
    staticClass: "pic_box"
  }, [_c('div', {
    staticClass: "pic_mask2"
  }, [_c('a', {
    staticClass: "button3",
    attrs: {
      "href": "https://a.app.qq.com/o/simple.jsp?pkgname=com.vrviu.lightvr",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('software.download')))])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(64),
      "alt": ""
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "platform_name",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('software.product_title1'))
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "platform_info"
  }, [_vm._v(_vm._s(_vm.$t('software.product_vison1')))]), _vm._v(" "), _c('p', {
    staticClass: "platform_info",
    staticStyle: {
      "margin-bottom": "0.35rem"
    }
  }, [_vm._v(_vm._s(_vm.$t('software.product_date1')))])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "pic_box"
  }, [_c('div', {
    staticClass: "pic_mask2"
  }, [_c('a', {
    staticClass: "button3",
    attrs: {
      "href": "https://www.vrviu.com/static/download/sdk/LightVR_V2.5_forPico.zip"
    }
  }, [_vm._v(_vm._s(_vm.$t('software.download')))])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(63),
      "alt": ""
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "platform_name",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('software.product_title2'))
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "platform_info"
  }, [_vm._v(_vm._s(_vm.$t('software.product_vison2')))]), _vm._v(" "), _c('p', {
    staticClass: "platform_info",
    staticStyle: {
      "margin-bottom": "0.35rem"
    }
  }, [_vm._v(_vm._s(_vm.$t('software.product_date2')))])]), _vm._v(" "), _c('li', [_vm._m(0), _vm._v(" "), _c('h3', {
    staticClass: "platform_name",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('software.product_title3'))
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "platform_info"
  }, [_vm._v(_vm._s(_vm.$t('software.product_vison3')))]), _vm._v(" "), _c('p', {
    staticClass: "platform_info",
    staticStyle: {
      "margin-bottom": "0.35rem"
    }
  }, [_vm._v(_vm._s(_vm.$t('software.product_date3')))])]), _vm._v(" "), _c('li', [_vm._m(1), _vm._v(" "), _c('h3', {
    staticClass: "platform_name",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('software.product_title4'))
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "platform_info"
  }, [_vm._v(_vm._s(_vm.$t('software.product_vison4')))]), _vm._v(" "), _c('p', {
    staticClass: "platform_info",
    staticStyle: {
      "margin-bottom": "0.35rem"
    }
  }, [_vm._v(_vm._s(_vm.$t('software.product_date4')))])]), _vm._v(" "), _c('li', [_vm._m(2), _vm._v(" "), _c('h3', {
    staticClass: "platform_name",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('software.product_title5'))
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "platform_info"
  }, [_vm._v(_vm._s(_vm.$t('software.product_vison5')))]), _vm._v(" "), _c('p', {
    staticClass: "platform_info",
    staticStyle: {
      "margin-bottom": "0.35rem"
    }
  }, [_vm._v(_vm._s(_vm.$t('software.product_date5')))])]), _vm._v(" "), _c('li', [_vm._m(3), _vm._v(" "), _c('h3', {
    staticClass: "platform_name",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('software.product_title6'))
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "platform_info"
  }, [_vm._v(_vm._s(_vm.$t('software.product_vison6')))]), _vm._v(" "), _c('p', {
    staticClass: "platform_info",
    staticStyle: {
      "margin-bottom": "0.35rem"
    }
  }, [_vm._v(_vm._s(_vm.$t('software.product_date6')))])])]), _vm._v(" "), _c('h3', {
    staticClass: "download_item_title",
    attrs: {
      "id": "anchor2"
    }
  }, [_vm._v(_vm._s(_vm.$t('software.introduction_title3')))]), _vm._v(" "), _c('h4', {
    staticClass: "download_item_title2"
  }, [_vm._v(_vm._s(_vm.$t('software.introduction_title4')))]), _vm._v(" "), _c('ul', {
    staticClass: "download_platforms clearfix platform_pic",
    staticStyle: {
      "border-bottom": "none"
    }
  }, [_c('li', [_c('div', {
    staticClass: "pic_box"
  }, [_c('div', {
    staticClass: "pic_mask2"
  }, [_c('a', {
    staticClass: "button3",
    attrs: {
      "href": "https://www.vrviu.com/static/download/sdk/LightEncoder_V1.1.zip"
    }
  }, [_vm._v(_vm._s(_vm.$t('software.download')))])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(11),
      "alt": ""
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "platform_name",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('software.product_title7'))
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "platform_info"
  }, [_vm._v(_vm._s(_vm.$t('software.product_vison7')))]), _vm._v(" "), _c('p', {
    staticClass: "platform_info",
    staticStyle: {
      "margin-bottom": "0.35rem"
    }
  }, [_vm._v(_vm._s(_vm.$t('software.product_date7')))])]), _vm._v(" "), _c('li', [_vm._m(4), _vm._v(" "), _c('h3', {
    staticClass: "platform_name",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('software.product_title8'))
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "platform_info"
  }, [_vm._v(_vm._s(_vm.$t('software.product_vison8')))]), _vm._v(" "), _c('p', {
    staticClass: "platform_info",
    staticStyle: {
      "margin-bottom": "0.35rem"
    }
  }, [_vm._v(_vm._s(_vm.$t('software.product_date8')))])])]), _vm._v(" "), _c('div', {
    staticClass: "center",
    staticStyle: {
      "border-bottom": "1px solid #eee",
      "padding-bottom": "0.7rem"
    }
  }, [_c('p', {
    staticClass: "platform_info",
    staticStyle: {
      "line-height": "1.6em"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('software.introduction_text'))
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "button_default button_default2",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.showDialog()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('product.text45')))])]), _vm._v(" "), _c('h3', {
    staticClass: "download_item_title",
    attrs: {
      "id": "anchor3"
    }
  }, [_vm._v(_vm._s(_vm.$t('software.introduction_title5')))]), _vm._v(" "), _c('h4', {
    staticClass: "download_item_title2"
  }, [_vm._v(_vm._s(_vm.$t('software.introduction_title6')))]), _vm._v(" "), _c('ul', {
    staticClass: "download_platforms clearfix platform_pic"
  }, [_c('li', [_c('div', {
    staticClass: "pic_box"
  }, [_c('div', {
    staticClass: "pic_mask2"
  }, [_c('a', {
    staticClass: "button3",
    attrs: {
      "href": "https://github.com/vrviu-sdk/VBS",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('software.download')))])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(11),
      "alt": ""
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "platform_name",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('software.product_title9'))
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "platform_info"
  }, [_vm._v(_vm._s(_vm.$t('software.product_vison9')))]), _vm._v(" "), _c('p', {
    staticClass: "platform_info",
    staticStyle: {
      "margin-bottom": "0.35rem"
    }
  }, [_vm._v(_vm._s(_vm.$t('software.product_date9')))])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "pic_box"
  }, [_c('div', {
    staticClass: "pic_mask2"
  }, [_c('a', {
    staticClass: "button3",
    attrs: {
      "href": "https://github.com/vrviu-sdk/VBS/blob/master/VBSDemoPlayer.apk",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('software.download')))])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(60),
      "alt": ""
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "platform_name",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('software.product_title10'))
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "platform_info"
  }, [_vm._v(_vm._s(_vm.$t('software.product_vison10')))]), _vm._v(" "), _c('p', {
    staticClass: "platform_info",
    staticStyle: {
      "margin-bottom": "0.35rem"
    }
  }, [_vm._v(_vm._s(_vm.$t('software.product_date10')))])])])])])]), _vm._v(" "), _c('Footerline')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pic_box"
  }, [_c('div', {
    staticClass: "pic_mask2"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(68),
      "alt": ""
    }
  })]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(67),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pic_box"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(66),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pic_box"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(65),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pic_box"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(62),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pic_box"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(61),
      "alt": ""
    }
  })])
}]}

/***/ }),
/* 91 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    class: {
      english: _vm.$i18n.locale == 'en'
    }
  }, [_c('headLine', {
    ref: "dialog",
    attrs: {
      "index": "1",
      "showbar": "true"
    },
    on: {
      "on-locale-change": _vm.onLocaleChange
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show_game_dialog),
      expression: "show_game_dialog"
    }],
    staticClass: "dialog_masker",
    staticStyle: {
      "height": "100%",
      "z-index": "214748364778!important"
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.show_game_dialog = false;
      },
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "middle game_dailog",
    staticStyle: {
      "width": "6.5rem",
      "height": "10.5rem",
      "position": "relative"
    }
  }, [_c('span', {
    staticClass: "close_game_dialog",
    on: {
      "click": function($event) {
        _vm.show_game_dialog = false
      }
    }
  }), _vm._v(" "), (_vm.$i18n.locale == 'ch') ? _c('img', {
    staticStyle: {
      "width": "6.5rem",
      "height": "10.5rem",
      "position": "absolute",
      "left": "0",
      "top": "0",
      "border-radius": "5px"
    },
    attrs: {
      "src": _vm.imglist[21]
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'en') ? _c('img', {
    staticStyle: {
      "width": "6.5rem",
      "height": "10.5rem",
      "position": "absolute",
      "left": "0",
      "top": "0",
      "border-radius": "5px"
    },
    attrs: {
      "src": _vm.imglist[22]
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "banner banner1"
  }, [_c('img', {
    attrs: {
      "src": _vm.imglist[0],
      "alt": ""
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "banner_title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('home.index.banner_title'))
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "banner_title banner_title1",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('home.index.banner_text'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "center button_banner",
    staticStyle: {
      "position": "absolute",
      "top": "48%",
      "width": "100%"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/product"
    }
  }, [_c('a', {
    staticClass: "button_default",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('home.download'))
    }
  })]), _vm._v(" "), _c('h2', {
    staticStyle: {
      "font-size": "0.28rem",
      "color": "#fff",
      "margin-top": "30%"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('home.index.vrviu'))
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "guaid_arrow"
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content center"
  }, [_c('div', {
    staticClass: "content_item"
  }, [_c('h3', {
    staticClass: "content_item_title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('home.index.title1'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [(_vm.$i18n.locale == 'ch') ? _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[1]),
      expression: "imglist[1]"
    }],
    staticStyle: {
      "width": "5.18rem",
      "height": "9.45rem",
      "margin": "0.4rem auto 0 auto"
    },
    attrs: {
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'en') ? _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[10]),
      expression: "imglist[10]"
    }],
    staticStyle: {
      "width": "5.18rem",
      "height": "9.45rem",
      "margin": "0.4rem auto 0 auto"
    },
    attrs: {
      "alt": ""
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "center",
    staticStyle: {
      "background": "#f4f9ff",
      "margin-top": "0.7rem"
    }
  }, [_c('ul', {
    staticClass: "bar_list clearfix"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/technology"
    }
  }, [_c('span', {
    staticClass: "bar_icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "bar_tex",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('home.index.item_title1'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bar_item"
  })])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/technology"
    }
  }, [_c('span', {
    staticClass: "bar_icon bar_icon1"
  }), _vm._v(" "), _c('div', {
    staticClass: "bar_tex",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('home.index.item_title2'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bar_item bar_item2"
  })])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/technology"
    }
  }, [_c('span', {
    staticClass: "bar_icon bar_icon2"
  }), _vm._v(" "), _c('div', {
    staticClass: "bar_tex",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('home.index.item_title3'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bar_item bar_item1"
  })])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/technology"
    }
  }, [_c('span', {
    staticClass: "bar_icon bar_icon3"
  }), _vm._v(" "), _c('div', {
    staticClass: "bar_tex",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('home.index.item_title4'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bar_item bar_item2 bar_item1"
  })])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "content_item"
  }, [_c('h3', {
    staticClass: "content_item_title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('home.index.title2'))
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "center support_model"
  }, [_c('span', {
    class: {
      "active_tab": _vm.showTab == 1
    },
    staticStyle: {
      "margin-right": "30px"
    },
    on: {
      "mouseover": function($event) {
        _vm.showTab = 1
      }
    }
  }, [_vm._v("VR")]), _c('span', {
    class: {
      "active_tab": _vm.showTab == 2
    },
    on: {
      "mouseover": function($event) {
        _vm.showTab = 2
      }
    }
  }, [_vm._v("2D")])]), _vm._v(" "), _c('p'), _vm._v(" "), _c('div', {
    staticClass: "pictures"
  }, [(_vm.showTab == 1) ? _c('ul', [_c('li', {
    staticClass: "pic_content"
  }, [_c('div', {
    staticClass: "pic_item"
  }, [_c('router-link', {
    attrs: {
      "to": "/solution1"
    }
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[2]),
      expression: "imglist[2]"
    }],
    attrs: {
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "middle",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('home.index.pic_text1'))
    }
  })])], 1)]), _vm._v(" "), _c('li', {
    staticClass: "pic_content pic_content1 clearfix"
  }, [_c('div', {
    staticClass: "fl"
  }, [_c('div', {
    staticClass: "pic_item"
  }, [_c('router-link', {
    attrs: {
      "to": "/solution"
    }
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[3]),
      expression: "imglist[3]"
    }],
    attrs: {
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "middle",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('home.index.pic_text2'))
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "fr"
  }, [_c('div', {
    staticClass: "pic_item pic_item2"
  }, [_c('router-link', {
    attrs: {
      "to": "/solution"
    }
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[4]),
      expression: "imglist[4]"
    }],
    attrs: {
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "middle",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('home.index.pic_text3'))
    }
  })])], 1)])]), _vm._v(" "), _c('li', {
    staticClass: "pic_content pic_content1 clearfix"
  }, [_c('div', {
    staticClass: "fl"
  }, [_c('div', {
    staticClass: "pic_item"
  }, [_c('router-link', {
    attrs: {
      "to": "/solution"
    }
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[5]),
      expression: "imglist[5]"
    }],
    attrs: {
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "middle",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('home.index.pic_text4'))
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "fr"
  }, [_c('div', {
    staticClass: "pic_item pic_item2"
  }, [_c('router-link', {
    attrs: {
      "to": "/solution"
    }
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[6]),
      expression: "imglist[6]"
    }],
    attrs: {
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "middle",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('home.index.pic_text5'))
    }
  })])], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.showTab == 2) ? _c('ul', [_c('li', {
    staticClass: "pic_content"
  }, [_c('div', {
    staticClass: "pic_item"
  }, [_c('router-link', {
    attrs: {
      "to": "/solution2"
    }
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[11]),
      expression: "imglist[11]"
    }],
    attrs: {
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "middle",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('home.text4'))
    }
  })])], 1)]), _vm._v(" "), _c('li', {
    staticClass: "pic_content"
  }, [_c('div', {
    staticClass: "pic_item"
  }, [_c('router-link', {
    attrs: {
      "to": "/solution2"
    }
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[12]),
      expression: "imglist[12]"
    }],
    attrs: {
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "middle",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('home.text5'))
    }
  })])], 1)]), _vm._v(" "), _c('li', {
    staticClass: "pic_content"
  }, [_c('div', {
    staticClass: "pic_item"
  }, [_c('router-link', {
    attrs: {
      "to": "/solution2"
    }
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[13]),
      expression: "imglist[13]"
    }],
    attrs: {
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "middle",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('home.text6'))
    }
  })])], 1)])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "content_item",
    staticStyle: {
      "background": "#f4f9ff",
      "height": "5.5rem",
      "position": "relative"
    }
  }, [_c('h3', {
    staticClass: "content_item_title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('home.index.title3'))
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "0.4rem",
      "margin": "0.4rem 0.32rem 0 0.32rem"
    }
  }, [_c('my-video', {
    ref: "video",
    attrs: {
      "sources": _vm.video.sources,
      "options": _vm.video.options
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show_play_btn),
      expression: "show_play_btn"
    }],
    staticClass: "playBtn",
    on: {
      "click": function($event) {
        _vm.play_video()
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content_item",
    staticStyle: {
      "margin-bottom": "-0.36rem"
    }
  }, [_c('h3', {
    staticClass: "content_item_title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('home.index.try_download'))
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[7]),
      expression: "imglist[7]"
    }],
    staticStyle: {
      "width": "4.05rem",
      "height": "3.69rem",
      "margin": "0.4rem auto 0.1rem auto"
    },
    attrs: {
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('router-link', {
    attrs: {
      "to": "/software"
    }
  }, [_c('a', {
    staticClass: "button_default button_default2",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('home.index.try_download_btn'))
    }
  })])], 1), _vm._v(" "), _c('h3', {
    staticClass: "content_item_title",
    staticStyle: {
      "margin-top": "1.4rem"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('home.index.friends'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "center friendsList clearfix"
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[14]),
      expression: "imglist[14]"
    }],
    staticStyle: {
      "width": "2.7rem",
      "height": "1rem"
    },
    attrs: {
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[15]),
      expression: "imglist[15]"
    }],
    staticStyle: {
      "width": "2.7rem",
      "height": "1rem"
    },
    attrs: {
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[16]),
      expression: "imglist[16]"
    }],
    staticStyle: {
      "width": "2.7rem",
      "height": "1rem"
    },
    attrs: {
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[17]),
      expression: "imglist[17]"
    }],
    staticStyle: {
      "width": "2.7rem",
      "height": "1rem"
    },
    attrs: {
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[18]),
      expression: "imglist[18]"
    }],
    staticStyle: {
      "width": "2.7rem",
      "height": "1rem"
    },
    attrs: {
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[19]),
      expression: "imglist[19]"
    }],
    staticStyle: {
      "width": "2.7rem",
      "height": "1rem"
    },
    attrs: {
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[20]),
      expression: "imglist[20]"
    }],
    staticStyle: {
      "width": "2.7rem",
      "height": "1rem"
    },
    attrs: {
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.imglist[8]),
      expression: "imglist[8]",
      arg: "background-image"
    }],
    staticClass: "content_bg"
  }, [_c('div', {
    staticClass: "content_footer"
  }, [_c('h3', {
    staticClass: "content_item_title white",
    staticStyle: {
      "magin-bottom": "0.4rem"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('home.index.try_free'))
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "content_item_text content_item_text1 white",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('home.index.try_free_text'))
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "content_item_text white",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('home.index.try_free_text2'))
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "button_default",
    staticStyle: {
      "margin-top": "0.7rem"
    },
    attrs: {
      "to": "/product"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('home.index.try_free_btn'))
    }
  })], 1)])])])]), _vm._v(" "), _c('footerLine')], 1)
},staticRenderFns: []}

/***/ }),
/* 92 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      english: _vm.$i18n.locale == 'en'
    }
  }, [_c('headLine', {
    ref: "dialog",
    attrs: {
      "showbar": _vm.showmenu_bar,
      "index": "5"
    },
    on: {
      "on-locale-change": _vm.onLocaleChange
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$t('title')) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "banner"
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[0]),
      expression: "imglist[0]"
    }],
    attrs: {
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content center"
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[1]),
      expression: "imglist[1]"
    }],
    staticClass: "download_img",
    attrs: {
      "alt": ""
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "download_title"
  }, [_vm._v(_vm._s(_vm.$t('title2')))]), _vm._v(" "), _c('div', {
    staticClass: "content_item_text content_item_text1",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('text'))
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "button2 button2_Andorid",
    attrs: {
      "href": "http://a.app.qq.com/o/simple.jsp?pkgname=com.VRVIU.VrPlayer",
      "target": "_blank"
    }
  }, [_vm._v("Andorid")]), _vm._v(" "), _c('a', {
    staticClass: "button2 button2_iOS gray",
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("iOS")]), _vm._v(" "), _c('a', {
    staticClass: "button2 button2_geer gray",
    attrs: {
      "href": "javascript:void(0)"
    }
  })]), _vm._v(" "), _c('footerLine')], 1)
},staticRenderFns: []}

/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main_content",
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 94 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    class: {
      english: _vm.$i18n.locale == 'en'
    }
  }, [_c('headLine', {
    ref: "dialog",
    attrs: {
      "index": "5",
      "showbar": "true"
    },
    on: {
      "on-locale-change": _vm.onLocaleChange
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$t('features.name')) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "banner banner1"
  }, [_c('img', {
    attrs: {
      "src": _vm.imglist[0],
      "alt": ""
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "banner_title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('features.banner_text'))
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "banner_title banner_title1",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('features.banner_text1'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "center button_banner",
    staticStyle: {
      "position": "absolute",
      "top": "4.02rem",
      "width": "100%"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/devolop"
    }
  }, [_c('a', {
    staticClass: "button_default",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('features.banner_button'))
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "content1"
  }, [_c('div', {
    staticClass: "main_wrap center"
  }, [_c('ul', {
    staticClass: "bar_list clearfix",
    staticStyle: {
      "background": "#e8f4ff"
    }
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/technology"
    }
  }, [_c('span', {
    staticClass: "bar_icon bar_icon4"
  }), _vm._v(" "), _c('div', {
    staticClass: "bar_tex",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('features.text2'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bar_item"
  })])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/technology"
    }
  }, [_c('span', {
    staticClass: "bar_icon bar_icon5"
  }), _vm._v(" "), _c('div', {
    staticClass: "bar_tex",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('features.text3'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bar_item bar_item2"
  })])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/technology"
    }
  }, [_c('span', {
    staticClass: "bar_icon bar_icon6"
  }), _vm._v(" "), _c('div', {
    staticClass: "bar_tex",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('features.text4'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bar_item bar_item1"
  })])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/technology"
    }
  }, [_c('span', {
    staticClass: "bar_icon bar_icon7"
  }), _vm._v(" "), _c('div', {
    staticClass: "bar_tex",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('features.text5'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bar_item bar_item2 bar_item1"
  })])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "content2 center"
  }, [_c('div', {
    staticClass: "push_SDK_title"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('features.table1.title')) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "push_SDK_text"
  }, [_c('table', {
    staticClass: "features_table"
  }, [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('features.table1.label1')))]), _vm._v(" "), _c('td', [_c('div', {
    staticStyle: {
      "margin-bottom": "0.4rem"
    }
  }, [_vm._v(_vm._s(_vm.$t('features.table1.text1')))]), _c('div', {
    staticStyle: {
      "margin-bottom": "0.2rem"
    }
  }, [_vm._v(_vm._s(_vm.$t('features.table1.text102')))]), _c('div', [_vm._v(_vm._s(_vm.$t('features.table1.text103')))])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('features.table1.label11')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('features.table1.text2')))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('features.table1.label12')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('features.table1.text3')))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('features.table1.label13')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('features.table1.text4')))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('features.table1.label14')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('features.table1.text5')))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('features.table1.label15')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('features.table1.text6')))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('features.table1.label16')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('features.table1.text7')))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('features.table1.label17')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('features.table1.text8')))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('features.table1.label18')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('features.table1.text9')))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('features.table1.label19')))]), _vm._v(" "), _c('td', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('features.table1.text10'))
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('features.table1.label10')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('features.table1.text11')))])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "line-height": "0.22rem",
      "margin-top": "0.7rem",
      "padding-bottom": "0.7rem"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/devolop"
    }
  }, [_c('a', {
    staticClass: "button_default2",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('features.text11'))
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content3 center"
  }, [_c('div', {
    staticClass: "push_SDK_title"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('features.table2.title')) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "push_SDK_text"
  }, [_c('table', {
    staticClass: "features_table"
  }, [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('features.table2.label1')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('features.table2.text1')))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('features.table2.label2')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('features.table2.text2')))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('features.table2.label3')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('features.table2.text3')))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('features.table2.label4')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('features.table2.text4')))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('features.table2.label5')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('features.table2.text5')))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('features.table2.label6')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('features.table2.text6')))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('features.table2.label7')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('features.table2.text7')))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('features.table2.label8')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('features.table2.text8')))])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "line-height": "0.22rem",
      "margin-top": "0.7rem",
      "padding-bottom": "0.7rem",
      "background": "#e8f4ff"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/devolop"
    }
  }, [_c('a', {
    staticClass: "button_default2",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('features.text11'))
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content2 center content4"
  }, [_c('div', {
    staticClass: "push_SDK_title",
    staticStyle: {
      "line-height": "1.5em"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('features.table3.title')) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "push_SDK_text",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('table', {
    staticClass: "features_table"
  }, [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('features.table3.label1')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('features.table3.text1')))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('features.table3.label2')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('features.table3.text2')))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('features.table3.label3')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('features.table3.text3')))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('features.table3.label4')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('features.table3.text4')))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('features.table3.label5')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('features.table3.text5')))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('features.table3.label6')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('features.table3.text6')))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('features.table3.label7')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('features.table3.text7')))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('features.table3.label8')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('features.table3.text8')))])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "line-height": "0.22rem"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "requestion_wrap"
  }, [_c('div', {
    staticClass: "requestion"
  }, [_c('div', {
    staticClass: "center",
    staticStyle: {
      "padding-bottom": "1rem",
      "padding-top": "0.7rem"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/devolop"
    }
  }, [_c('a', {
    staticClass: "button_default2",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('features.text11'))
    }
  })])], 1)])])]), _vm._v(" "), _c('footerLine')], 1)
},staticRenderFns: []}

/***/ }),
/* 95 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    class: {
      english: _vm.$i18n.locale == 'en'
    }
  }, [_c('headLine', {
    ref: "dialog",
    attrs: {
      "index": "4",
      "showbar": "true"
    },
    on: {
      "on-locale-change": _vm.onLocaleChange
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$t('product2.name')) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "banner banner1"
  }, [_c('img', {
    attrs: {
      "src": _vm.imglist[0],
      "alt": ""
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "banner_title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('product2.banner_text'))
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "banner_title banner_title1",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('product2.banner_text1'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "center button_banner",
    staticStyle: {
      "position": "absolute",
      "top": "4.02rem",
      "width": "100%"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/software"
    }
  }, [_c('a', {
    staticClass: "button_default",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('product2.banner_botton'))
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content center"
  }, [_c('div', {
    staticClass: "content center"
  }, [_c('div', {
    staticClass: "content_item"
  }, [_c('h3', {
    staticClass: "content_item_title",
    staticStyle: {
      "margin-bottom": "0.25rem"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('product2.introduction_title'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content_item_text"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('product2.introduction_text1')) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "content_item_text"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('product2.introduction_text2')) + "\n              \n          ")]), _vm._v(" "), _c('div', {
    staticClass: "content_item_text"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('product2.introduction_text3')) + "\n              \n          ")]), _vm._v(" "), _c('div', {
    staticClass: "content_item_text"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('product2.introduction_text44')) + "\n          ")]), _vm._v(" "), _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[1]),
      expression: "imglist[1]"
    }],
    staticStyle: {
      "width": "100%",
      "height": "3.27rem"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "introduction clearfix",
    staticStyle: {
      "background-color": "rgb(243,250,255)",
      "margin-bottom": "-0.9rem"
    }
  }, [_c('div', {
    staticClass: "introduction_title"
  }, [_vm._v(_vm._s(_vm.$t('product2.introduction_title2')))]), _vm._v(" "), _c('div', {
    staticClass: "configure_list",
    staticStyle: {
      "text-align": "left",
      "position": "relative",
      "z-index": "1"
    }
  }, [_c('div', {
    staticClass: "introduction_text"
  }, [_vm._v(_vm._s(_vm.$t('product2.introduction_text4')))]), _vm._v(" "), _c('div', {
    staticClass: "introduction_text"
  }, [_vm._v(_vm._s(_vm.$t('product2.introduction_text5')))]), _vm._v(" "), _c('div', {
    staticClass: "introduction_text"
  }, [_vm._v(_vm._s(_vm.$t('product2.introduction_text6')))]), _vm._v(" "), _c('div', {
    staticClass: "introduction_text"
  }, [_vm._v(_vm._s(_vm.$t('product2.introduction_text7')))])])]), _vm._v(" "), _c('div', {
    staticClass: "content_item",
    staticStyle: {
      "margin-bottom": "-0.36rem",
      "padding-top": "0.33rem"
    }
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.imglist[8]),
      expression: "imglist[8]",
      arg: "background-image"
    }],
    staticClass: "content_bg",
    staticStyle: {
      "margin-bottom": "-0.04rem",
      "top": "-0.32rem",
      "background-color": "rgba(244, 249, 255)"
    }
  }, [_c('div', {
    staticClass: "content_footer"
  }, [_c('h3', {
    staticClass: "content_item_title white",
    staticStyle: {
      "margin-bottom": "0.4rem"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('product2.text25'))
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "content_item_text white",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('product2.text26'))
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "content_item_text white",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('product2.text28'))
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "content_item_text white",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('product2.text29'))
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "button_default",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('product2.text27'))
    },
    on: {
      "click": function($event) {
        _vm.showDialog()
      }
    }
  })])])])])]), _vm._v(" "), _c('footerLine')], 1)
},staticRenderFns: []}

/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    class: {
      english: _vm.$i18n.locale == 'en'
    }
  }, [_c('headLine', {
    ref: "dialog",
    attrs: {
      "index": "3",
      "showbar": "true"
    },
    on: {
      "on-locale-change": _vm.onLocaleChange
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('product.name')) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "banner banner1"
  }, [_c('img', {
    attrs: {
      "src": _vm.imglist[0],
      "alt": ""
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "banner_title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('product.banner_text'))
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "banner_title banner_title1",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('product.banner_text2'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "center button_banner",
    staticStyle: {
      "position": "absolute",
      "top": "4.02rem",
      "width": "100%"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/software"
    }
  }, [_c('a', {
    staticClass: "button_default",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('product.banner_botton'))
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content center"
  }, [_c('div', {
    staticClass: "content_item content_item2"
  }, [_c('h3', {
    staticClass: "content_item_title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('product.introduction_title'))
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[2]),
      expression: "imglist[2]"
    }],
    staticStyle: {
      "width": "100%",
      "height": "3.38rem"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content_item_text"
  }, [_vm._v(_vm._s(_vm.$t('product.introduction_text13')) + "\n")]), _vm._v(" "), _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[3]),
      expression: "imglist[3]"
    }],
    staticStyle: {
      "width": "100%",
      "height": "3.38rem"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content_item_text"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('product.introduction_text11')) + "\n        ")]), _vm._v(" "), _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[4]),
      expression: "imglist[4]"
    }],
    staticStyle: {
      "width": "100%",
      "height": "3.38rem"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content_item_text",
    staticStyle: {
      "margin-bottom": "0.7rem"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('product.introduction_text12')) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "content center",
    staticStyle: {
      "background-color": "rgba(238,245,254,1)"
    }
  }, [_c('div', {
    staticClass: "content_item"
  }, [_c('h3', {
    staticClass: "content_item_title",
    staticStyle: {
      "margin-bottom": "0.25rem"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('product.introduction_title2'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content_item_text"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('product.introduction_text2')) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "content_item_text"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('product.introduction_text21')) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "content_item_text"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('product.introduction_text22')) + "\n          ")]), _vm._v(" "), _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[5]),
      expression: "imglist[5]"
    }],
    staticStyle: {
      "width": "7.25rem",
      "height": "6.56rem",
      "margin": "0 auto",
      "margin-top": "-0.2rem",
      "padding-bottom": "0.4rem"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "content center"
  }, [_c('div', {
    staticClass: "content_item"
  }, [_c('h3', {
    staticClass: "content_item_title",
    staticStyle: {
      "margin-bottom": "0.25rem"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('product.introduction_title4'))
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h5', {
    staticClass: "content_item_text2"
  }, [_vm._v(_vm._s(_vm.$t('product.introduction_title5')))]), _vm._v(" "), _c('a', {
    staticClass: "button_default button_default2",
    staticStyle: {
      "margin-bottom": "0.7rem"
    },
    on: {
      "click": function($event) {
        _vm.showDialog()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('product.text45')))])])])]), _vm._v(" "), _c('footerLine')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "platformList clearfix"
  }, [_c('li', [_c('span', {
    staticClass: "mult_platform"
  })]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "mult_platform1"
  })]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "mult_platform2"
  })]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "mult_platform3"
  })]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "mult_platform4"
  })]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "mult_platform5"
  })])])
}]}

/***/ }),
/* 97 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "__cov-video-container",
    on: {
      "mouseenter": _vm.mouseEnterVideo,
      "mouseleave": _vm.mouseLeaveVideo
    }
  }, [_c('video', {
    staticClass: "__cov-video",
    class: {
      'hide-cursor': !_vm.state.contrlShow
    },
    attrs: {
      "poster": _vm.options.poster
    }
  }, _vm._l((_vm.sources), function(source) {
    return _c('source', {
      attrs: {
        "src": source.src,
        "type": source.type
      }
    })
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.state.contrlShow),
      expression: "state.contrlShow"
    }],
    staticClass: "__cov-contrl-content",
    attrs: {
      "transition": "fade"
    }
  }, [_c('button', {
    staticClass: "__cov-contrl-play-btn",
    on: {
      "click": _vm.play
    }
  }, [_c('svg', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.state.playing),
      expression: "!state.playing"
    }],
    staticClass: "__cov-contrl-play-btn-icon",
    attrs: {
      "viewBox": "0 0 47 57",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('title', [_vm._v("Triangle 1")]), _vm._v(" "), _c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Page-1",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('polygon', {
    attrs: {
      "id": "Triangle-1",
      "stroke": "#FFFFFF",
      "fill": "#FFFFFF",
      "points": "1 56 1 1 47 28.5"
    }
  })])]), _vm._v(" "), _c('svg', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.state.playing),
      expression: "state.playing"
    }],
    staticClass: "__cov-contrl-play-btn-icon",
    attrs: {
      "viewBox": "0 0 15 22",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('title', [_vm._v("Combined Shape")]), _vm._v(" "), _c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('defs', [_c('path', {
    attrs: {
      "d": "M0,0.979149244 L5,0.979149244 L5,22 L0,22 L0,0.979149244 Z M10,0.979149244 L15,0.979149244 L15,22 L10,22 L10,0.979149244 Z",
      "id": "path-1"
    }
  }), _vm._v(" "), _c('mask', {
    attrs: {
      "id": "mask-2",
      "maskContentUnits": "userSpaceOnUse",
      "maskUnits": "objectBoundingBox",
      "x": "0",
      "y": "0",
      "width": "15",
      "height": "21.0208508",
      "fill": "white"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#path-1"
    }
  })])]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Page-1",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('use', {
    attrs: {
      "id": "Combined-Shape",
      "stroke": "#FFFFFF",
      "mask": "url(#mask-2)",
      "stroke-width": "2",
      "fill": "#FFFFFF",
      "xlink:href": "#path-1"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "__cov-contrl-video-slider",
    on: {
      "click": _vm.slideClick,
      "mousedown": _vm.videoMove
    }
  }, [_c('div', {
    staticClass: "__cov-contrl-video-inner",
    style: ({
      'transform': ("translate3d(" + (_vm.video.pos.current) + "px, 0, 0)")
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "__cov-contrl-video-rail"
  }, [_c('div', {
    staticClass: "__cov-contrl-video-rail-inner",
    style: ({
      'transform': 'translate3d(' + _vm.video.loaded + '%, 0, 0)'
    })
  })])]), _vm._v(" "), _c('div', {
    staticClass: "__cov-contrl-video-time"
  }, [_c('span', {
    staticClass: "__cov-contrl-video-time-text"
  }, [_vm._v(_vm._s(_vm.video.displayTime))])]), _vm._v(" "), _c('div', {
    staticClass: "__cov-contrl-vol-box"
  }, [_c('button', {
    staticClass: "__cov-contrl-play-btn",
    on: {
      "click": _vm.volMuted
    }
  }, [_c('svg', {
    staticClass: "__cov-contrl-vol-btn-icon",
    attrs: {
      "viewBox": "0 0 41 44",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("vol")]), _vm._v(" "), _c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('defs', [_c('path', {
    attrs: {
      "d": "M8.61522369,12 L20,0.615223689 L20,37.3847763 L8.61522369,26 L1.99201702,26 C0.891856397,26 0,25.1029399 0,23.9941413 L0,14.0058587 C0,12.8980535 0.900176167,12 1.99201702,12 L8.61522369,12 L8.61522369,12 Z",
      "id": "cov-vol"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Page-1",
      "stroke": "none",
      "stroke-width": "2",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "vol",
      "transform": "translate(2.000000, 3.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "cov-vol-icon"
    }
  }, [_c('g', {
    attrs: {
      "id": "Combined-Shape-Clipped"
    }
  }, [_c('path', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.volume.percent > 1 && !_vm.volume.muted),
      expression: "volume.percent > 1 && !volume.muted"
    }],
    attrs: {
      "d": "M25,29.5538997 C28.4589093,27.6757536 31.2629093,23.2984641 31.2629093,19.7769499 C31.2629093,16.2554357 28.4589093,11.8781461 25,10",
      "id": "vol-range-2",
      "stroke": "#FFFFFF"
    }
  }), _vm._v(" "), _c('path', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.volume.percent > 70 && !_vm.volume.muted),
      expression: "volume.percent > 70 && !volume.muted"
    }],
    attrs: {
      "d": "M28,35.5538997 C33.5816016,32.5231573 38.1063837,25.4595762 38.1063837,19.7769499 C38.1063837,14.0943235 33.5816016,7.03074247 28,4",
      "id": "vol-range-2",
      "stroke": "#FFFFFF"
    }
  }), _vm._v(" "), _c('mask', {
    attrs: {
      "id": "mask-2",
      "fill": "white"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#cov-vol"
    }
  })]), _vm._v(" "), _c('use', {
    attrs: {
      "id": "vol-path",
      "stroke": "#FFFFFF",
      "stroke-width": "3",
      "xlink:href": "#cov-vol"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Combined-Shape",
      "mask": "url(#mask-2)",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "fill": "#FFFFFF"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8.61522369,12 L20,0.615223689 L20,37.3847763 L8.61522369,26 L1.99201702,26 C0.891856397,26 0,25.1029399 0,23.9941413 L0,14.0058587 C0,12.8980535 0.900176167,12 1.99201702,12 L8.61522369,12 L8.61522369,12 Z",
      "id": "cov-vol"
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "__cov-contrl-vol-slider",
    on: {
      "click": _vm.volSlideClick,
      "mousedown": _vm.volMove
    }
  }, [_c('div', {
    staticClass: "__cov-contrl-vol-inner",
    style: ({
      'transform': ("translate3d(" + (_vm.volume.pos.current) + "px, 0, 0)")
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "__cov-contrl-vol-rail"
  })])]), _vm._v(" "), _c('button', {
    staticClass: "__cov-contrl-play-btn",
    on: {
      "click": _vm.fullScreen
    }
  }, [_c('svg', {
    staticClass: "__cov-contrl-vol-btn-icon",
    attrs: {
      "viewBox": "0 0 33 33",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Page-1",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('path', {
    attrs: {
      "d": "M31.1682064,22 L31.1682064,31.0073537 L22,31.0073537 M22,1 L31.0073537,1 L31.0073537,10.1682064 M1,10.0073537 L1,1 L10.1682064,1 M10.0073537,31.1682064 L1,31.1682064 L1,22",
      "id": "Combined-Shape",
      "stroke": "#FFFFFF",
      "stroke-width": "2"
    }
  })])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "footer"
  }, [_c('ul', [_c('li', {
    staticStyle: {
      "margin-bottom": "0.68rem"
    }
  }, [(_vm.$i18n.locale == 'ch') ? _c('img', {
    staticStyle: {
      "width": "2.07rem",
      "padding-top": "0.67rem"
    },
    attrs: {
      "src": __webpack_require__(55),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'en') ? _c('img', {
    staticStyle: {
      "width": "1.88rem",
      "padding-top": "0.67rem"
    },
    attrs: {
      "src": __webpack_require__(56),
      "alt": ""
    }
  }) : _vm._e()]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-bottom": "0.58rem"
    }
  }, [_c('span', {
    staticClass: "footer_item"
  }, [_vm._v(_vm._s(_vm.$t("footer.text1")))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "tel:86 755 8695 6559"
    }
  }, [_vm._v(_vm._s(_vm.$t("footer.text2")))])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-bottom": "0.57rem"
    }
  }, [_c('span', {
    staticClass: "footer_item"
  }, [_vm._v(_vm._s(_vm.$t("footer.text3")))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "tel:86 755 8696 0615"
    }
  }, [_vm._v(_vm._s(_vm.$t("footer.text4")))])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-bottom": "0.53rem"
    }
  }, [_c('span', {
    staticClass: "footer_item"
  }, [_vm._v(_vm._s(_vm.$t("footer.text5")))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "Mailto:business@vrviu.com"
    }
  }, [_vm._v(_vm._s(_vm.$t("footer.text6")))])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-bottom": "0rem"
    }
  }, [_c('span', {
    staticClass: "footer_item",
    staticStyle: {
      "line-height": "1.5em"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('footer.text7'))
    }
  })])]), _vm._v(" "), (_vm.$i18n.locale == 'ch') ? _c('img', {
    staticClass: "sqcore_pic",
    attrs: {
      "src": __webpack_require__(69)
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "copyright center",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('footer.text8'))
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      english: _vm.$i18n.locale == 'en'
    }
  }, [_c('headLine', {
    ref: "dialog",
    attrs: {
      "showbar": _vm.showmenu_bar,
      "index": "10"
    },
    on: {
      "on-locale-change": _vm.onLocaleChange
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('about.name')) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "banner"
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[0]),
      expression: "imglist[0]"
    }],
    attrs: {
      "alt": ""
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "banner_title"
  })]), _vm._v(" "), _c('div', {
    staticClass: "content center"
  }, [_c('div', {
    staticClass: "content_item"
  }, [_c('h3', {
    staticClass: "content_item_title"
  }, [_vm._v("\n           " + _vm._s(_vm.$t('about.text4')) + "\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "content_item_text"
  }, [_vm._v("\n           " + _vm._s(_vm.$t('about.text5')) + "\n         ")])]), _vm._v(" "), _c('div', {
    staticClass: "content_item"
  }, [_c('ul', {
    staticClass: "img_list clearfix"
  }, [_c('li', [_c('div', {
    staticClass: "img_item"
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[1]),
      expression: "imglist[1]"
    }],
    attrs: {
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_detail"
  }, [_c('div', {
    staticClass: "img_detail_title"
  }, [_vm._v("Crusoe Mao")]), _vm._v(" "), _c('div', {
    staticClass: "img_detail_text"
  }, [_vm._v(_vm._s(_vm.$t('about.text6')))])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "img_item"
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[2]),
      expression: "imglist[2]"
    }],
    attrs: {
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_detail"
  }, [_c('div', {
    staticClass: "img_detail_title"
  }, [_vm._v("Frederick Umminger")]), _vm._v(" "), _c('div', {
    staticClass: "img_detail_text"
  }, [_vm._v(_vm._s(_vm.$t('about.text7')))])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "img_item"
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[3]),
      expression: "imglist[3]"
    }],
    attrs: {
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_detail"
  }, [_c('div', {
    staticClass: "img_detail_title"
  }, [_vm._v("Brian Watson")]), _vm._v(" "), _c('div', {
    staticClass: "img_detail_text"
  }, [_vm._v(_vm._s(_vm.$t('about.text7')))])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "img_item"
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[4]),
      expression: "imglist[4]"
    }],
    attrs: {
      "alt": ""
    }
  }), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "img_item"
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[5]),
      expression: "imglist[5]"
    }],
    attrs: {
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_detail"
  }, [_c('div', {
    staticClass: "img_detail_title"
  }, [_vm._v("Joyce Yang")]), _vm._v(" "), _c('div', {
    staticClass: "img_detail_text"
  }, [_vm._v(_vm._s(_vm.$t('about.text8')))])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.imglist[7]),
      expression: "imglist[7]",
      arg: "background-image"
    }],
    staticClass: "content_item content_bg"
  }, [_c('div', {
    staticClass: "center"
  }, [_c('router-link', {
    staticClass: "button_default2",
    staticStyle: {
      "margin-bottom": "2.26rem"
    },
    attrs: {
      "to": "/join"
    }
  }, [_vm._v(_vm._s(_vm.$t('about.text10')))])], 1)])]), _vm._v(" "), _c('footerLine')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img_detail"
  }, [_c('div', {
    staticClass: "img_detail_title"
  }, [_vm._v("Tim Liang")]), _vm._v(" "), _c('div', {
    staticClass: "img_detail_text"
  }, [_vm._v("CTO")])])
}]}

/***/ }),
/* 100 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    class: {
      english: _vm.$i18n.locale == 'en'
    }
  }, [_c('headLine', {
    ref: "dialog",
    attrs: {
      "index": "2",
      "showbar": "true"
    },
    on: {
      "on-locale-change": _vm.onLocaleChange
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$t('product3.name')) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "banner banner1"
  }, [_c('img', {
    attrs: {
      "src": _vm.imglist[0],
      "alt": ""
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "banner_title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('product3.banner_text'))
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "banner_title banner_title1",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('product3.banner_text1'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "center button_banner",
    staticStyle: {
      "position": "absolute",
      "top": "4.32rem",
      "width": "100%"
    }
  }, [_c('a', {
    staticClass: "button_default",
    attrs: {
      "href": "https://master.vrviu.com/index.html"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('product3.banner_botton'))
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "content center"
  }, [_c('div', {
    staticClass: "content_item"
  }, [_c('h3', {
    staticClass: "content_item_title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('product3.introduction_title'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [(_vm.$i18n.locale == 'ch') ? _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[1]),
      expression: "imglist[1]"
    }],
    staticStyle: {
      "height": "3.86rem",
      "width": "6.85rem",
      "margin": "0 auto",
      "margin-top": "0.41rem"
    },
    attrs: {
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'en') ? _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[10]),
      expression: "imglist[10]"
    }],
    staticStyle: {
      "height": "3.86rem",
      "width": "6.85rem",
      "margin": "0 auto",
      "margin-top": "0.41rem"
    },
    attrs: {
      "alt": ""
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "center clearfix",
    staticStyle: {
      "background": "#f4f9ff",
      "margin-top": "0.7rem",
      "margin-bottom": "-0.9rem"
    }
  }, [_c('h3', {
    staticClass: "content_item_title",
    staticStyle: {
      "padding-top": "0.7rem"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('product3.introduction_title2'))
    }
  }), _vm._v(" "), _c('ul', {
    staticStyle: {
      "position": "relative",
      "z-index": "1"
    }
  }, [_c('li', {
    staticClass: "why_content clearfix"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "fl",
    staticStyle: {
      "margin-left": "0.6rem"
    }
  }, [_c('h4', {
    staticClass: "why_title"
  }, [_vm._v(_vm._s(_vm.$t('product3.platform_pic1')))]), _vm._v(" "), _c('div', {
    staticClass: "why_text"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('product3.platform_pic11'))), _c('br'), _vm._v("\n              " + _vm._s(_vm.$t('product3.platform_pic12')) + "\n            ")])])]), _vm._v(" "), _c('li', {
    staticClass: "why_content clearfix"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "fl",
    staticStyle: {
      "margin-left": "0.6rem"
    }
  }, [_c('h4', {
    staticClass: "why_title"
  }, [_vm._v(_vm._s(_vm.$t('product3.platform_pic2')))]), _vm._v(" "), _c('div', {
    staticClass: "why_text"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('product3.platform_pic21'))), _c('br'), _vm._v("\n              " + _vm._s(_vm.$t('product3.platform_pic22')) + "\n            ")])])]), _vm._v(" "), _c('li', {
    staticClass: "why_content clearfix"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "fl",
    staticStyle: {
      "margin-left": "0.6rem"
    }
  }, [_c('h4', {
    staticClass: "why_title"
  }, [_vm._v(_vm._s(_vm.$t('product3.platform_pic3')))]), _vm._v(" "), _c('div', {
    staticClass: "why_text"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('product3.platform_pic31'))), _c('br'), _vm._v("\n              " + _vm._s(_vm.$t('product3.platform_pic32')) + "\n            ")])])]), _vm._v(" "), _c('li', {
    staticClass: "why_content clearfix"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "fl",
    staticStyle: {
      "margin-left": "0.6rem"
    }
  }, [_c('h4', {
    staticClass: "why_title"
  }, [_vm._v(_vm._s(_vm.$t('product3.platform_pic4')))]), _vm._v(" "), _c('div', {
    staticClass: "why_text"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('product3.platform_pic41'))), _c('br'), _vm._v("\n              " + _vm._s(_vm.$t('product3.platform_pic42')) + "\n            ")])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.imglist[8]),
      expression: "imglist[8]",
      arg: "background-image"
    }],
    staticClass: "content_bg",
    staticStyle: {
      "background-color": "rgba(244, 249, 255,1)"
    }
  }, [_c('div', {
    staticClass: "content_footer"
  }, [_c('h3', {
    staticClass: "content_item_title white",
    staticStyle: {
      "margin-bottom": "0.4rem"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('product3.text25'))
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "content_item_text content_item_text1 white",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('product3.text26'))
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "content_item_text white",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('product3.text29'))
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "button_default",
    staticStyle: {
      "margin-top": "0.7rem"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('product3.text27'))
    },
    on: {
      "click": function($event) {
        _vm.showDialog()
      }
    }
  })])])])]), _vm._v(" "), _c('footerLine')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fl"
  }, [_c('span', {
    staticClass: "why_icon"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fl"
  }, [_c('span', {
    staticClass: "why_icon why_icon1"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fl"
  }, [_c('span', {
    staticClass: "why_icon why_icon2"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fl"
  }, [_c('span', {
    staticClass: "why_icon why_icon3"
  })])
}]}

/***/ }),
/* 101 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      english: _vm.$i18n.locale == 'en'
    }
  }, [_c('headLine', {
    ref: "dialog",
    attrs: {
      "showbar": _vm.showmenu_bar,
      "index": "11"
    },
    on: {
      "on-locale-change": _vm.onLocaleChange
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('join.name')) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "banner"
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[0]),
      expression: "imglist[0]"
    }],
    attrs: {
      "alt": ""
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "banner_title"
  })]), _vm._v(" "), _c('div', {
    staticClass: "content center"
  }, [_c('div', {
    staticClass: "content_item",
    staticStyle: {
      "margin-bottom": "0.7rem"
    }
  }, [_c('ul', {
    staticClass: "about_list clearfix"
  }, [_c('li', {
    staticClass: "about_item"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "about_item_title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('join.text6'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "vr_cloud_box_split"
  }), _vm._v(" "), _c('div', {
    staticClass: "about_item_text",
    staticStyle: {
      "margin-bottom": "0.15rem"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('join.text7'))
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "about_item"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "about_item_title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('join.text10'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "vr_cloud_box_split"
  }), _vm._v(" "), _c('div', {
    staticClass: "about_item_text",
    staticStyle: {
      "margin-bottom": "0.15rem"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('join.text11'))
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "about_item"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "about_item_title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('join.text8'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "vr_cloud_box_split"
  }), _vm._v(" "), _c('div', {
    staticClass: "about_item_text",
    staticStyle: {
      "margin-bottom": "0.15rem"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('join.text9'))
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "content_item",
    staticStyle: {
      "background": "#f4f8fc"
    }
  }, [_c('h3', {
    staticClass: "content_item_title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('join.text12'))
    }
  }), _vm._v(" "), (_vm.$i18n.locale == 'ch') ? _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[1]),
      expression: "imglist[1]"
    }],
    staticStyle: {
      "width": "7.5rem",
      "height": "3.12rem"
    },
    attrs: {
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'en') ? _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[4]),
      expression: "imglist[4]"
    }],
    staticStyle: {
      "width": "7.5rem",
      "height": "3.12rem"
    },
    attrs: {
      "alt": ""
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "content_item"
  }, [_c('h3', {
    staticClass: "content_item_title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('join.text14'))
    }
  }), _vm._v(" "), (_vm.$i18n.locale == 'ch') ? _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[2]),
      expression: "imglist[2]"
    }],
    staticStyle: {
      "width": "7.5rem",
      "height": "5.45rem"
    },
    attrs: {
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'en') ? _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[5]),
      expression: "imglist[5]"
    }],
    staticStyle: {
      "width": "7.5rem",
      "height": "5.45rem"
    },
    attrs: {
      "alt": ""
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.$i18n.locale == 'ch') ? _c('div', {
    staticClass: "content_item"
  }, [_c('h3', {
    staticClass: "content_item_title"
  }, [_vm._v("\n            热招职位\n          ")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.imglist[3]),
      expression: "imglist[3]",
      arg: "background-image"
    }],
    staticClass: "content_item content_bg",
    staticStyle: {
      "padding-top": "0"
    }
  }, [_vm._m(4)])]) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'en') ? _c('div', {
    staticClass: "content_item"
  }, [_c('h3', {
    staticClass: "content_item_title"
  }, [_vm._v("\n            Open Positions\n          ")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.imglist[3]),
      expression: "imglist[3]",
      arg: "background-image"
    }],
    staticClass: "content_item content_bg",
    staticStyle: {
      "padding-top": "0",
      "padding-bottom": "0.5rem"
    }
  }, [_vm._m(6)])]) : _vm._e()]), _vm._v(" "), _c('footerLine')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about_item1"
  }, [_c('span', {
    staticClass: "about_item_icon"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about_item2"
  }, [_c('span', {
    staticClass: "about_item_icon"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about_item3"
  }, [_c('span', {
    staticClass: "about_item_icon"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dl', {
    staticClass: "job_list"
  }, [_c('dt', {
    staticStyle: {
      "margin-top": "0.4rem"
    }
  }, [_vm._v("\n              视频算法工程师\n            ")]), _vm._v(" "), _c('dd', {
    staticClass: "job_text"
  }, [_vm._v("\n              25k-50k / 深圳 / 经验5-10年 / 本科及以上 / 全职\n            ")]), _vm._v(" "), _c('dd', [_c('a', {
    staticClass: "button_default2",
    attrs: {
      "href": "https://www.lagou.com/jobs/3419777.html",
      "target": "_blank"
    }
  }, [_vm._v("查看职位")])]), _vm._v(" "), _c('dt', [_vm._v("\n              Android客户端开发工程师\n            ")]), _vm._v(" "), _c('dd', {
    staticClass: "job_text"
  }, [_vm._v("\n              18k-30k / 深圳 / 经验3-5年 / 本科及以上 / 全职\n            ")]), _vm._v(" "), _c('dd', [_c('a', {
    staticClass: "button_default2",
    attrs: {
      "href": "https://www.lagou.com/jobs/2642148.html",
      "target": "_blank"
    }
  }, [_vm._v("查看职位")])]), _vm._v(" "), _c('dt', [_vm._v("\n              高级产品运营经理（2B方向)\n            ")]), _vm._v(" "), _c('dd', {
    staticClass: "job_text"
  }, [_vm._v("\n              18k-30k / 深圳 / 经验5-10年 / 学历不限 / 全职\n            ")]), _vm._v(" "), _c('dd', [_c('a', {
    staticClass: "button_default2",
    attrs: {
      "href": "https://www.lagou.com/jobs/2949766.html",
      "target": "_blank"
    }
  }, [_vm._v("查看职位")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center",
    staticStyle: {
      "padding-top": "0.2rem"
    }
  }, [_c('a', {
    staticStyle: {
      "font-size": "0.24rem",
      "color": "rgb(35,138,247)",
      "text-decoration": "underline"
    },
    attrs: {
      "href": "https://www.lagou.com/gongsi/j149944.html",
      "target": "_blank"
    }
  }, [_vm._v("查看更多职位")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dl', {
    staticClass: "job_list"
  }, [_c('dt', {
    staticStyle: {
      "margin-top": "0.4rem"
    }
  }, [_vm._v("\n              Sr. Software Engineer (Millbrae, CA)\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center",
    staticStyle: {
      "padding-top": "0.2rem"
    }
  }, [_c('a', {
    staticClass: "button_default2",
    attrs: {
      "href": "mailto:hr@vrviu.com",
      "target": "_blank"
    }
  }, [_vm._v("Apply Now")])])
}]}

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showbar),
      expression: "showbar"
    }],
    staticClass: "header center",
    class: {
      color: _vm.color, showMenu: _vm.showMenu
    }
  }, [(_vm.index == '1' && _vm.$i18n.locale == 'ch') ? _c('img', {
    staticClass: "logo",
    attrs: {
      "src": __webpack_require__(57),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.index == '1' && _vm.$i18n.locale == 'en') ? _c('img', {
    staticClass: "logo logo3",
    attrs: {
      "src": __webpack_require__(58),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.index != '1') ? _c('img', {
    staticClass: "logo logo2",
    attrs: {
      "src": __webpack_require__(59),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showMenu),
      expression: "!showMenu"
    }],
    staticClass: "menu_icon",
    on: {
      "click": function($event) {
        _vm.showMenu = true
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMenu),
      expression: "showMenu"
    }],
    staticClass: "menu_icon1",
    on: {
      "click": function($event) {
        _vm.showMenu = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "middle"
  }, [_vm._t("default")], 2)]), _vm._v(" "), (_vm.showMenu) ? _c('div', {
    staticClass: "menu_down"
  }, [_c('div', {
    staticStyle: {
      "height": "100%",
      "overflow-y": "scroll"
    }
  }, [_c('ul', {
    staticClass: "menu_list"
  }, [_c('li', {
    on: {
      "click": function($event) {
        _vm.showMenu = false
      }
    }
  }, [_c('router-link', {
    staticClass: "menu_link",
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.$t("header.nav1")))])], 1), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.showMenu4 = !_vm.showMenu4
      }
    }
  }, [_c('a', {
    staticClass: "menu_link"
  }, [_vm._v(_vm._s(_vm.$t("header.nav11")))]), _vm._v(" "), _c('span', {
    staticClass: "nav_icon_down",
    class: {
      nav_icon_up: _vm.showMenu4
    }
  })]), _vm._v(" "), (_vm.showMenu4) ? _c('li', {
    on: {
      "click": function($event) {
        _vm.showMenu = false
      }
    }
  }, [_c('router-link', {
    staticClass: "menu_link2",
    attrs: {
      "to": "/product"
    }
  }, [_vm._v(_vm._s(_vm.$t("header.nav12")))])], 1) : _vm._e(), _vm._v(" "), (_vm.showMenu4) ? _c('li', {
    on: {
      "click": function($event) {
        _vm.showMenu = false
      }
    }
  }, [_c('router-link', {
    staticClass: "menu_link2",
    attrs: {
      "to": "/product1"
    }
  }, [_vm._v(_vm._s(_vm.$t("header.nav13")))])], 1) : _vm._e(), _vm._v(" "), (_vm.showMenu4) ? _c('li', {
    on: {
      "click": function($event) {
        _vm.showMenu = false
      }
    }
  }, [_c('router-link', {
    staticClass: "menu_link2",
    attrs: {
      "to": "/product3"
    }
  }, [_vm._v(_vm._s(_vm.$t("header.nav15")))])], 1) : _vm._e(), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.showMenu3 = !_vm.showMenu3
      }
    }
  }, [_c('a', {
    staticClass: "menu_link"
  }, [_vm._v(_vm._s(_vm.$t("header.nav2")))]), _vm._v(" "), _c('span', {
    staticClass: "nav_icon_down",
    class: {
      nav_icon_up: _vm.showMenu2
    }
  })]), _vm._v(" "), (_vm.showMenu3) ? _c('li', {
    on: {
      "click": function($event) {
        _vm.showMenu = false
      }
    }
  }, [_c('router-link', {
    staticClass: "menu_link2",
    attrs: {
      "to": "/solution"
    }
  }, [_vm._v(_vm._s(_vm.$t("header.nav8")))])], 1) : _vm._e(), _vm._v(" "), (_vm.showMenu3) ? _c('li', {
    on: {
      "click": function($event) {
        _vm.showMenu = false
      }
    }
  }, [_c('router-link', {
    staticClass: "menu_link2",
    attrs: {
      "to": "/solution1"
    }
  }, [_vm._v(_vm._s(_vm.$t("header.nav9")))])], 1) : _vm._e(), _vm._v(" "), (_vm.showMenu3) ? _c('li', {
    on: {
      "click": function($event) {
        _vm.showMenu = false
      }
    }
  }, [_c('router-link', {
    staticClass: "menu_link2",
    attrs: {
      "to": "/solution2"
    }
  }, [_vm._v(_vm._s(_vm.$t("header.nav10")))])], 1) : _vm._e(), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.showMenu = false
      }
    }
  }, [_c('router-link', {
    staticClass: "menu_link",
    attrs: {
      "to": "/technology"
    }
  }, [_vm._v(_vm._s(_vm.$t("header.nav3")))])], 1), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.showMenu1 = !_vm.showMenu1
      }
    }
  }, [_c('a', {
    staticClass: "menu_link"
  }, [_vm._v(_vm._s(_vm.$t("header.nav4")))]), _vm._v(" "), _c('span', {
    staticClass: "nav_icon_down",
    class: {
      nav_icon_up: _vm.showMenu1
    }
  })]), _vm._v(" "), (_vm.showMenu1) ? _c('li', {
    on: {
      "click": function($event) {
        _vm.showMenu = false
      }
    }
  }, [_c('router-link', {
    staticClass: "menu_link2",
    attrs: {
      "to": "/devolop"
    }
  }, [_vm._v(_vm._s(_vm.$t("header.nav17")))])], 1) : _vm._e(), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.showMenu2 = !_vm.showMenu2
      }
    }
  }, [_c('a', {
    staticClass: "menu_link"
  }, [_vm._v(_vm._s(_vm.$t("header.nav5")))]), _vm._v(" "), _c('span', {
    staticClass: "nav_icon_down",
    class: {
      nav_icon_up: _vm.showMenu2
    }
  })]), _vm._v(" "), (_vm.showMenu2) ? _c('li', {
    on: {
      "click": function($event) {
        _vm.showMenu = false
      }
    }
  }, [_c('router-link', {
    staticClass: "menu_link2",
    attrs: {
      "to": "/about"
    }
  }, [_vm._v(_vm._s(_vm.$t("header.nav7")))])], 1) : _vm._e(), _vm._v(" "), (_vm.showMenu2) ? _c('li', {
    on: {
      "click": function($event) {
        _vm.showMenu = false
      }
    }
  }, [_c('router-link', {
    staticClass: "menu_link2",
    attrs: {
      "to": "/join"
    }
  }, [_vm._v(_vm._s(_vm.$t("header.nav6")))])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('a', {
    staticClass: "button2",
    staticStyle: {
      "margin": "0.46rem 0 1rem 0"
    },
    on: {
      "click": function($event) {
        _vm.free_use()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("header.navBtn")))]), _vm._v(" "), _c('div', {
    staticClass: "change_btns"
  }, [_c('span', {
    class: {
      gray_btn: _vm.$i18n.locale == 'en'
    },
    staticStyle: {
      "padding-right": "0.44rem"
    },
    on: {
      "click": function($event) {
        _vm.changeLanguage('ch', $event)
      }
    }
  }, [_vm._v("中文")]), _vm._v("/"), _c('span', {
    class: {
      gray_btn: _vm.$i18n.locale == 'ch'
    },
    staticStyle: {
      "padding-left": "0.44rem"
    },
    on: {
      "click": function($event) {
        _vm.changeLanguage('en', $event)
      }
    }
  }, [_vm._v("English")])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDialog == true),
      expression: "showDialog==true"
    }]
  }, [_c('div', {
    staticClass: "dialog"
  }, [_c('div', [_c('span', {
    staticClass: "closeBtn",
    on: {
      "click": function($event) {
        _vm.showDialog = false;
        _vm.showMenu = false
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showNext),
      expression: "!showNext"
    }]
  }, [_c('div', [_c('div', {
    staticClass: "dialog_title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('text1'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog_text",
    staticStyle: {
      "margin-bottom": "0.15rem"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('text2'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog_text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('text3'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('div', {}, [_c('ul', {
    staticClass: "form_list"
  }, [_c('li', [_c('span', {
    staticClass: "input_item input_item1"
  }, [_c('span', {
    staticClass: "star"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', {
    staticClass: "input_icon"
  }), _vm._v(" "), (_vm.$i18n.locale == 'ch') ? _c('multiselect', {
    attrs: {
      "options": _vm.options,
      "placeholder": "",
      "searchable": false,
      "allow-empty": false
    },
    model: {
      value: (_vm.content_type2),
      callback: function($$v) {
        _vm.content_type2 = $$v
      },
      expression: "content_type2"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'en') ? _c('multiselect', {
    attrs: {
      "options": _vm.options1,
      "placeholder": "",
      "searchable": false,
      "allow-empty": false
    },
    model: {
      value: (_vm.content_type2),
      callback: function($$v) {
        _vm.content_type2 = $$v
      },
      expression: "content_type2"
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "arrow_icon"
  })], 1)]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "input_item input_item2"
  }, [_c('span', {
    staticClass: "input_icon"
  }), _vm._v(" "), (_vm.$i18n.locale == 'ch') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company),
      expression: "company"
    }],
    attrs: {
      "type": "text",
      "placeholder": "公司名称"
    },
    domProps: {
      "value": (_vm.company)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.company = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'en') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company),
      expression: "company"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Company"
    },
    domProps: {
      "value": (_vm.company)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.company = $event.target.value
      }
    }
  }) : _vm._e()])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "input_item input_item3"
  }, [_c('span', {
    staticClass: "star"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.check_ok2 == 'true'),
      expression: "check_ok2=='true'"
    }],
    staticClass: "check_success"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.check_ok2 == 'false'),
      expression: "check_ok2=='false'"
    }],
    staticClass: "check_fail"
  }), _vm._v(" "), _c('span', {
    staticClass: "input_icon"
  }), _vm._v(" "), (_vm.$i18n.locale == 'ch') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    attrs: {
      "type": "text",
      "placeholder": "姓名"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "change": function($event) {
        _vm.check_success($event, "required")
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'en') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Name"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "change": function($event) {
        _vm.check_success($event, "required")
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }) : _vm._e()])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "input_item input_item4"
  }, [(_vm.$i18n.locale == 'ch') ? _c('span', {
    staticClass: "star"
  }, [_vm._v("*")]) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'en') ? _c('span', {
    staticClass: "star"
  }) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.check_ok3 == 'true'),
      expression: "check_ok3=='true'"
    }],
    staticClass: "check_success"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.check_ok3 == 'false'),
      expression: "check_ok3=='false'"
    }],
    staticClass: "check_fail"
  }), _vm._v(" "), _c('span', {
    staticClass: "input_icon"
  }), _vm._v(" "), (_vm.$i18n.locale == 'ch') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telephone),
      expression: "telephone"
    }],
    attrs: {
      "type": "text",
      "placeholder": "电话"
    },
    domProps: {
      "value": (_vm.telephone)
    },
    on: {
      "change": function($event) {
        _vm.check_success($event, "phone")
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.telephone = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'en') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telephone),
      expression: "telephone"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Phone"
    },
    domProps: {
      "value": (_vm.telephone)
    },
    on: {
      "change": function($event) {
        _vm.check_success($event, "phone")
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.telephone = $event.target.value
      }
    }
  }) : _vm._e()])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "input_item input_item5"
  }, [_c('span', {
    staticClass: "star"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.check_ok4 == 'true'),
      expression: "check_ok4=='true'"
    }],
    staticClass: "check_success"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.check_ok4 == 'false'),
      expression: "check_ok4=='false'"
    }],
    staticClass: "check_fail"
  }), _vm._v(" "), _c('span', {
    staticClass: "input_icon"
  }), _vm._v(" "), (_vm.$i18n.locale == 'ch') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "email",
      "placeholder": "电子邮箱"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "change": function($event) {
        _vm.check_success($event, "email")
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'en') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "change": function($event) {
        _vm.check_success($event, "email")
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "line-height": "0"
    }
  }, [(_vm.showError) ? _c('span', {
    staticStyle: {
      "font-size": "0.28rem",
      "color": "rgb(255,89,89)"
    }
  }, [_vm._v(_vm._s(_vm.errorText))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "button2",
    staticStyle: {
      "width": "6.7rem",
      "position": "relative",
      "top": "0.1rem"
    },
    attrs: {
      "href": "javascript:void(0)"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('send'))
    },
    on: {
      "click": function($event) {
        _vm.send_email()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNext),
      expression: "showNext"
    }],
    staticClass: "center"
  }, [_c('img', {
    staticStyle: {
      "width": "1.6rem",
      "height": "1.6rem",
      "padding-top": "3.66rem",
      "margin": "0 auto"
    },
    attrs: {
      "src": __webpack_require__(54),
      "alt": ""
    }
  }), _vm._v(" "), _c('h3', {
    staticStyle: {
      "font-size": "0.36rem",
      "color": "rgb(40,40,40)",
      "margin": "0.4rem 0 0 0rem"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('text8'))
    }
  }), _vm._v(" "), _c('h4', {
    staticStyle: {
      "font-size": "0.28rem",
      "color": "rgb(80,80,80)",
      "margin": "0.3rem 0 0 0rem"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('text9'))
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "button_default2",
    staticStyle: {
      "margin-top": "0.7rem"
    },
    attrs: {
      "href": "javascript:void(0)"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('text10'))
    },
    on: {
      "click": function($event) {
        _vm.showDialog = false
      }
    }
  })])])])])
},staticRenderFns: []}

/***/ }),
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */
/***/ (function(module, exports) {



module.exports =  {
          header:{
            nav1:"首页",
            nav2:"解决方案",
            nav3:"核心技术",
            nav4:"下载中心",
            nav5:"关于我们",
            nav6:"加入我们",
            nav8:"VR直播／点播",
            nav9:"VR秀场直播",
            nav10:"2D高清视频",
            nav11:"产品",
            nav12:"威尔云平台",
            nav13:"LightVR",
            nav14:"LightEncoder",
            nav15:"播放端SDK",
            nav16:"软件下载",
            nav17:"SDK下载",
            navBtn:"了解更多",
            nav7:"创始团队"

          },
          text1:"联系我们",
          text2:'您好，我是威尔直播的客服小V，请留下您的联系方式',
          text3:'我们将会在1个工作日内与您联系。<span style="color:#ff5959;vertical-align:middle">*</span>为必填项',
          text4:"公司名称",
          text5:'姓名',
          text6:"电话",
          text7:"电子邮箱",
          error:"非常抱歉，系统正在维护",
          error503:"操作过于频繁，请您稍后再试",
          error409:"您已提交，请勿重复操作",
          send:"发送",
          text8:"发送成功",
          text9:"威尔直播小V将尽快主动与您取得联系",
          text10:"好的",

        
  footer:{
    text1:"总机：",
    text2:'86 755 8695 6559',
    text3:'商务合作：',
    text4:"86 755 8696 0615",
    text5:'邮箱：',
    text6:"business@vrviu.com",
    text7:'地址：深圳市南山区科技园琼宇路特发信息科技大厦1-2楼',
    text8:'<a href="http://www.vrviu.com/sdk/document/威尔云使用条款与法律声明.pdf" style="text-decoration: underline;color:#454545;line-height:5em" download="威尔云使用条款与法律声明.pdf">使用条款 & 法律声明</a><br>深圳威尔视觉传媒有限公司<br>© 2016-2018 vrviu.com 版权所有 粤ICP备17011655号'
  },
        index: {
          header: {
            navBtn: "登录",
            navBtn2: "注册",
            nav13: "管理后台",
            nav14: "退出登录",
            nav15: "产品",
          },
          text1: "联系我们",
          text2: '您好，我是威尔直播的客服小V，请留下您的联系方式',
          text3: '我们将会在1个工作日内与您联系。<span style="color:#ff5959;vertical-align:middle">*</span>为必填项',
          text4: "公司名称",
          text5: '姓名',
          text6: "电话",
          text7: "电子邮箱",
          error: "非常抱歉，系统正在维护",
          error503: "操作过于频繁，请您稍后再试",
          error409: "您已提交，请勿重复操作",
          send: "发送",
          text8: "发送成功",
          text9: "我们已经收到您的申请，会尽快与您与的联系。",
          text10: "好的"
        },
        about: {
      name:"关于我们",
      text1:"让每个人都能享受VR直播的乐趣",
      text2:"我们致力于“VR高速公路”的建设，让用户在现有的带宽和技术条件下,",
      text3:"享受到身临其境的VR体验。",
      text4:"创始团队",
      text5:'我们总部位于深圳南山科技园，并在美国硅谷设有研究院 VRVIU，核心技术团队来自SIE、腾讯、Harmonic等世界顶级公司，拥有领先业界的音视频编解码专利算法技术、3D游戏和数字场景重构技术。',
      text6:'创始人 & CEO',
      text7:"联合创始人",
      text8:"CPO",
      text9:"人力资源副总裁",
      text10:"加入我们"
    },
        product: {
          name:"LightVR",
          banner_text: " 8K VR 直播/点播",
          banner_text2: " 一站式解决方案",
          banner_text1: '－ LightVR －',
          banner_botton: "免费下载 ",
          introduction_title: "LightVR 8K 播放器",
          introduction_text11: "在线播放或.vr1文件离线播放均可享受威尔云8K VR体验",
          introduction_text12: "iMAX级巨幕影院体验，畅享4K高清视频",
          introduction_text13: "多个播放列表间方便切换，适应多种演示和业务场景",
          introduction_title2: "LightVR 小程序",
          introduction_title3: "主要功能",
          introduction_text2: "使用微信即可体验VR视频",
          introduction_text21: "在手机上体验 4K 品质",
          introduction_text22: "支持点播视频或者视频列表 ",
          introduction_text23: "全屏和VR模式之间切换",
          introduction_text24: "将视频分享给朋友们",
          introduction_title4: "多终端适配",
          platform_pic1: "Cardboard",
          platform_pic2: "Pico",
          platform_pic3: "小米VR",
          platform_pic4: "HTC Vive",
          platform_pic5: "Oculus",
          platform_pic6: "微信小程序",
          introduction_title5: '需要更多平台适配或播放器定制？',
          text45: "联系我们"
        },
        product2: {
          name:"LightEncoder",
          banner_text: "8K VR 直播/点播",
          banner_text1: '一站式解决方案',
          banner_botton: '立即下载',
          introduction_title: "LightEncoder 主要功能",
          introduction_text1: "本地使用laptop或者PC即可转码",
          introduction_text2: "避免大体积视频的上传和下载",
          introduction_text3: "自定义转码时长，快速体验转码结果",
          introduction_text44: "支持转码队列，节约操作成本",
          introduction_title2: "转码设备推荐配置",
          introduction_text4: "处理器：Intel Core i5 4核@3.0GHz或更高配置 ",
          introduction_text5: "内存：16G 或者更高 RAM",
          introduction_text6: "硬盘：100G 以上可用空间",
          introduction_text7: "操作系统： Windows 7 64-bit 或 Windows 10 64-bit",
          text25: "获取LightEncoder",
          text26: "LightEncoder 尚处于 Beta 测试阶段",
          text28: "采用授权码激活可用时长",
          text29: "请联系我们获取授权码",
          text27: "联系我们"
        },
        product3: {
          name:"威尔云平台",
          banner_text: "8K VR 直播/点播",
          banner_text1: "一站式解决方案",
          banner_botton: "立即体验",
          introduction_title: "威尔云平台主要功能",
          text20: "全面的VR视频转码支持",
          text21: "支持 180°/360° , 2D/3D VR视频",
          text22: "支持 3K ～ 8K 的视频源输入",
          text23: "支持 H264,H265,VP9 等主流编码格式",
          text24: "支持最大 10GB 的单视频上传",
          text30: "多种转码规格可供选择",
          text31: "视焦点 FE 6K/8K 提供极致的高清体验",
          text32: "视焦点 FE 3K/4K 适用于网络流畅播放",
          text33: "普通 2.5K/3K/4K  适用于Web播放",
          text40: "便捷的视频管理服务",
          text41: "视频编辑、发布、在线播放",
          text42: "根据业务需要定制网络播单",
          text43: "FE 6K/8K 大文件可提供下载",
          introduction_title2: "为什么选择威尔云",
          platform_pic1: "威尔云专利视焦点算法",
          platform_pic11: "视角切换零延迟，带宽节约70%",
          platform_pic12: "带来绝佳的8K VR 视频享受",
          platform_pic2: "全面的VR视频转码支持",
          platform_pic21: "支持180°/360° , 2D/3D 的VR格式",
          platform_pic22: "支持H264,H265,VP9 等主流编码格式",
          platform_pic3: "多种转码规格可供选择",
          platform_pic31: "视焦点编码提供极致高清体验",
          platform_pic32: "普通编码适用于常规播放器",
          platform_pic4: "便捷的一站式解决方案",
          platform_pic41: "视频编辑、发布、在线播放",
          platform_pic42: "根据业务需要定制网络播单",

          text25: "免费试用威尔云",
          text26: "注册威尔云账号，免费体验威尔云在智能编码、稳定",
          text29: "传输和流畅播放等方面的强大技术优势。",
          text27: "立即体验",
          text28: '查看<a target="_blank" href="https://master.vrviu.com/static/document/Master%E6%93%8D%E4%BD%9C%E6%8C%87%E5%8D%97.pdf" style="text-decoration: underline;  display: inline-block;vertical-align: middle;color:#fff;margin-bottom:4px;margin-left:5px;">帮助文档</a>，更多问题请<a   style="margin-left:5px;text-decoration: underline; margin-bottom:4px; display: inline-block;vertical-align: middle;color:#fff;cursor:pointer" id="contract">联系我们</a>'

        },
        features: {
          name:"播放端SDK",
          banner_text:"8K VR 直播/点播的",
          banner_text1:"一站式解决方案",
          banner_button:"免费下载",
          text1: "播放端SDK",
          text2: "7x24小时稳定直播",
          text3: "高性能，低消耗",
          text4: "秒开，流畅切换",
          text5: "多开发环境",
          text6: "VR视频播放端SDK",
          text7: "WebVR视频播放器SDK",
          text8: "普通视频“窄带高清”播放端SDK",
          text9: "支持多种美颜滤镜",
          text10: '2017.09.30 发布推流端SDK V0.6版',
          text11: '下载',
          text12: 'VR视频Web播放SDK',
          text13: "高度定制化的播放器UI",
          text14: "支持360度全景、180度3D等多种格式的视频文件",
          text15: "支持手势拖拽和陀螺仪旋转等播放操作<br>支持微信、QQ、Chrome、Safari等平台播放",
          text16: "2018.03.08 发布 WebVR Player 版本V1.0",
          text17: "常见问答",
          text18: "是否可以不接入播放端SDK使用VRVIU的算法？",
          text19: "我们的FE算法基于H.264/H.265在编码上做了极为有效的优化，相应的，在播放端需要做相应的解码计算。基于上面的原理，播放端需要使用威尔云提供的SDK。",
          text20: "接入播放端SDK包后App大小会增加多少？",
          text21: '我们的核心SDK约为1M，但具体大小与您选择的我们的产品，以及您当前的App采用的技术有关。',
          text22: "联系我们",
          text23: 'Android',
          text111: "SDK下载",
          text112: "文档下载",
          text113: "Demo体验",
         table1: {
                     title: "VR视频播放端SDK",
                     label1: "支持最大分辨率",
                     label11: "音视频编码",
                     label12: "支持传输协议",
                     label13: "视频格式",
                     label14: "投影方式",
                     label15: "播放模式",
                     label16: "解码方式",
                     label17: "支持平台",
                     label18: "支持芯片",
                     label19: "支持设备",
                     label10: "支持FE专利算法",
                     text1: "VR 视频 8192*8192@60fps",
                     text102: "普通视频 3840*3840@60fps",
                     text103: "",
                     text2: "H.264 | H.265 | AAC",
                     text3: "RTMP | HTTP MP4 | HTTP FLV | HLS",
                     text4: "180° 3D | 360° 2D | 360° 3D",
                     text5: "等距圆柱 | 鱼眼",
                     text6: "直播 | 点播",
                     text7: "硬解 | 软解",
                     text8: "ARMV7 | ARM64 | X86",
                     text9: "高通 820+ | 全志VR9 | Samgsung8890+",
                     text10: "GearVR | Oculus Go | XIAOMI | Pico | HTC VIVE | DPVR | 3Glasses | Cardboard",
                     text11: "带宽节省高达75%，8K视频播放只需20Mbps"
                   },
                   table2: {
                     title: "WebVR视频播放器SDK",
                     label1: "支持最大分辨率",
                     label2: "音视频编码",
                     label3: "视频格式",
                     label4: "播放模式",
                     label5: "播放操作",
                     label6: "播放支持",
                     label7: "UI",
                     label8: "FE专利算法",
                     text1: "3840*1920@30fps",
                     text2: "H.264 | H.265 | AAC",
                     text3: "180° 3D | 360° 2D | 360° 3D",
                     text4: "直播 | 点播",
                     text5: "支持手势拖拽和陀螺仪旋转等播放操作",
                     text6: "支持主流的Web浏览器播放",
                     text7: "可定制化",
                     text8: "支持"
                   },
                   table3: {
                     title: "普通视频“窄带高清”播放端SDK",
                     label1: "支持最大分辨率",
                     label2: "音视频编码",
                     label3: "播放模式",
                     label4: "解码方式",
                     label5: "支持传输协议",
                     label6: "秒开",
                     label7: "支持系统",
                     label8: "支持FE专利算法",
                     text1: "3840*2160",
                     text2: "H.264 | H.265 | AAC",
                     text3: "直播 | 点播 ",
                     text4: "硬解 | 软解",
                     text5: "RTMP | HTTP MP4 | HTTP FLV | HLS ",
                     text6: "支持首屏秒开",
                     text7: "Android | iOS | HTML5",
                     text8: "带宽节省高达40%, 720p@H.265仅需600Kbps"
                   }
        },
        devolop: {
          name:"SDK下载",
          title1: "SDK下载",
          title2: "威尔VR视频播放端SDK",
          title3: "(VRVIU BitPlayer SDK)",
          title4: "Unity",
          version1: "版本号：V2.8",
          date1: "发布日期：2018.11.08",
          button1: "开发文档",
          button2: "SDK下载",
          title55: "HTML5",
          version2: "版本号：V1.0",
          date2: "发布日期：2018.05.17",
          title5: "普通视频“窄带高清”播放SDK",
          title6: "（VRVIU AltPlayer SDK）",
          title7: "iOS",
          version3: "版本号：V1.3",
          date3: "发布日期：2018.04.19",
          title8: "Android",
          Version4: "版本号：V1.3",
          date4: "发布日期：2018.04.28",
          title9: "HTML5",
          version5: "版本号：V1.0",
          date5: "发布日期：2018.05.07",
          title10: "VR秀场推流软件",
          title11: "（VBS）",
          title12: "PC侧安装",
          version6: "版本号：V1.0",
          date6: "发布日期：2018.05.11",
          title13: "手机端观看效果",
          version7: "版本号：Android V1.0",
          date7: "发布日期：2018.05.04",
          button3: "立即体验",
          button4: "软件下载",
          button5: "即将上线",
          title14: "LightVR App",
          title15: "（下载体验威尔专利算法的优质体验）",
          title16: "Cardboard for Android",
          Version8: "版本号：V1.2",
          date8: "发布日期：2018.05.02",
          title17: "Cardboard for iOS",
          version9: "",
          date9: ""
        },
        solution: {
        name:"VR直播／点播",
        name1:"VR秀场直播",
        name2:"2D高清视频",
        banner_text:"告别卡顿渣画质<br>重新定义VR直播</div>",
        banner_botton:"下载Demo",
        title1:"180° 3D / 360°全景：视角切换零延迟",
        text1:'180° 3D 适合小型近距离的表演和运动，360° 全景VR适合大场面、全方位的游戏、赛事和演唱会。威尔云通过对视频内容的多视角智能编解码，可在普通家庭网络带宽下，让高清流畅与沉浸感成为可能。',
        text2:'',
        text3:"威尔直播云服务",
        text4:'VR演出',
        text5:'秀场VR直播，支持实时美颜和滤镜，<br>与主播近距离互动。',
        text6:'VR体育',
        text7:'体育VR直播，以全新视角零距离观<br>看体育明星的表演',
        text8:'游戏VR',
        text9:'演出VR直播，独享演唱会的VIP坐席',
        text10:'360°全景：视角切换延迟零延迟',
        text11:"360° VR直播适合大场面、全方位的游戏、赛事、",
        text12:"旅行及演唱会，带来身临其境的体验",
        text13:'游戏VR直播',
        text14:'游戏VR直播，让观众可以身临虚拟世界，近距离观摩高手之间的较量，感受惊心动魄的一刻。',
        text15:'新闻VR直播',
        text16:'新闻VR直播，带你去现场，不错过任何精彩',
        text17:'旅行VR直播',
        text18:'旅行VR直播，与主播一同攀登珠峰，深潜海底，环游世界。',
        text19:'威尔云 6 大特性',
        text20:'低带宽',
        text21:'带宽节省高达70%，让高清与流畅并存',
        text22:'低延迟',
        text23:'优于业界金字塔、八面体等算法，切换延迟低至毫秒级',
        text24:'低功耗',
        text25:'智能视频编解码，支持中低端手机上的4K播放',
        text26:'标准协议',
        text27:'使用标准RTMP流，支持DASH、HLS等多种传输协议',
        text28:"服务稳定可靠",
        text29:'高并发，7x24稳定直播',
        text30:'多终端适配',
        text31:"支持Android/iOS/H5/Gear VR等多平台播放",
        text32:'核心技术',
        text33:'多平台适配',
        text34:'免费试用',
        text35:'常见问答',
         text36:'威尔播放器SDK相比其他播放器SDK有哪些优势？',
        text37:"威尔播放器SDK分为免费版和付费版，免费版支持标准的VR高清视频的流畅播放，付费版拥有在现有带宽下，体验真正的4K VR视频，高清、低切换延时等算法功能。您可以先下载体验免费版SDK，再与我们联系了解付费版详情。",
        text38:"现在已经在用公有云或私有云的直播服务，能接入威尔云服务吗？",
        text39:"威尔云支持现有多家CDN，公有云和私有云的部署。并且客户可以根据自己的需要，对指定内容开启威尔云服务。高效利用现有带宽，体验真正的4K VR视频。",
        text40:'对接威尔云服务是时间成本有多少？',
        text41:'在已有支持协议的基础上，对接体验只需要2分钟。',
        text42:"接入威尔云后的延时大概是多少秒？",
        text43:"威尔云在系统内部和视角切换上的延迟小于等于1秒，并且在切换时，带宽完全平滑，没有现陡现象。直播传输延迟由视频流的编码参数以及所在网络环境决定。",
        text44:'更多问题？',
        text45:'联系我们',
        text46:"",
      },
        solution2: {
        name:"VR秀场直播",
        name1:"VR直播／点播",
        name2:"2D高清视频",
        banner_text:"上行带宽减少70%<br>迎接全民VR直播时代",
        banner_botton:"下载Demo",
        title1:"VR秀场直播：零距离与主播实时互动",
        text1:'180° 3D 的VR秀场直播，主播可以在家庭带宽条件下实现高清推流，用户可以以低于4Mbps的带宽体验4K秀场直播内容。支持实时互动、美颜和滤镜，打破主播与观众“一屏之隔”的距离。',
        text2:'',
        text3:"威尔直播云服务",
        text4:'VR演出',
        text5:'秀场VR直播，支持实时美颜和滤镜，<br>与主播近距离互动。',
        text6:'VR体育',
        text7:'体育VR直播，以全新视角零距离观<br>看体育明星的表演',
        text8:'游戏VR',
        text9:'演出VR直播，独享演唱会的VIP坐席',
        text10:'360°全景：视角切换延迟零延迟',
        text11:"360° VR直播适合大场面、全方位的游戏、赛事、",
        text12:"旅行及演唱会，带来身临其境的体验",
        text13:'游戏VR直播',
        text14:'游戏VR直播，让观众可以身临虚拟世界，近距离观摩高手之间的较量，感受惊心动魄的一刻。',
        text15:'新闻VR直播',
        text16:'新闻VR直播，带你去现场，不错过任何精彩',
        text17:'旅行VR直播',
        text18:'旅行VR直播，与主播一同攀登珠峰，深潜海底，环游世界。',
        text19:'威尔云 6 大特性',
        text20:'低带宽',
        text21:'带宽节省高达70%，让高清与流畅并存',
        text22:'低延迟',
        text23:'优于业界金字塔、八面体等算法，切换延迟低至毫秒级',
        text24:'低功耗',
        text25:'智能视频编解码，支持中低端手机上的4K播放',
        text26:'标准协议',
        text27:'使用标准RTMP流，支持DASH、HLS等多种传输协议',
        text28:"服务稳定可靠",
        text29:'高并发，7x24稳定直播',
        text30:'多终端适配',
        text31:"支持Android/iOS/H5/Gear VR等多平台播放",
        text32:'核心技术',
        text33:'多平台适配',
        text34:'免费试用',
        text35:'常见问答',
      text36:'VR秀场直播中，对于主播的上行带宽有什么要求和限制吗？',
        text37:"通过使用威尔推流和播放SDK，主播的上行带宽只需要2Mbps - 4Mbps即可。",
        text38:"主播端使用什么推流软件，是否可以使用我们私有的直播软件进行VR秀场的直播推流？",
        text39:"威尔云在开源直播推流软件OBS的基础上，进行了改造优化，推出了专为VR且拥有威尔算法的推流软件VBS，供主播使用。若想要在私有直播推流软件上加入威尔算法，需要联系我们进行沟通技术细节。",
        text40:'是否支持Web/H5网页内的播放？',
        text41:'威尔针对H5的性能，开发了易于分享和传播的威尔WebVR播放器，高清流畅，可以在“开发者”页中下载SDK体验。',
        text42:"有推荐使用的180度3D相机吗？",
        text43:'目前我们支持 <a style="color:#0078e7" href="http://www.z-cam.com/180-vr-camera-k1-pro/" target="_blank">ZCAM K1 Pro</a>。另外，Google也官方推荐了多款VR 180相机，譬如<a href="http://www.yitechnology.com/180-vr-camera" target="_blank" style="color:#0078e7">YI Horizon VR180</a>。',
        text44:'更多问题？',
        text45:'联系我们',
        text46:"",
      },
        home: {
          index:{
                 banner_title:'8K VR视频播放',
                 banner_text:'真正沉浸体验',
                 notice:'2018.12.10 威尔云本地转码工具LightEncoder V1.1发布',
                 title1:'威尔云：视频的高清低带宽一站式解决方案',
                 vrviu:'认识威尔云',
                 item_title1:'挑战高清极限',
                 item_title2:'节省70%带宽',
                 item_title3:'适用多种场景',
                 item_title4:'服务稳定可靠',
                 item_text1:'支持 4K／6K／8K 视频流<br>尽享极致沉浸体验',
                 item_text2:'主流手机流畅播放4K+<br>内容，流量节省70%',
                 item_text3:'180º3D，360全景<br>可以根据不同场景选择',
                 item_text4:'高并发，低延迟<br>7x24稳定直播，多平台',
                 pic_text1:'VR秀场',
                 pic_text2:'游戏VR',
                 pic_text3:'VR体育',
                 pic_text4:'VR演出',
                 pic_text5:'VR新闻',
                 title2:"多种应用场景",
                 title3:"眼见为实",
                 download_title2:'视频来源：<a href="https://www.amaze.us" class="dance_link" target="_blank">AMAZE VR | Dance with Magga</a>',
                 download_title:'模拟VR眼镜中看到的4Mbps码率的视频，建议全屏观看比较视频细节。',
                 try_download:'下载体验LightVR 8K播放器',
                 try_download_text:'马上体验威尔云服务提供的秀场/电竞/体育等VR视频样片。',
                 try_download_btn:'下载',
                 try_free:'免费试用威尔云',
                 try_free_text:'体验威尔云在智能编码、稳定传输',
                 try_free_text2:"和流畅播放等强大技术优势。",
                 try_free_btn:'了解更多',
                 friends:"合作伙伴"



               },
               download:'了解更多',
               text4:"秀场直播",
               text5:"游戏直播",
               text6:"小视频"
        },
        technology: {
      name:"核心技术",
      text1:'威尔云 · 创建VR高速公路',
      text2:'专利FE (Foveated Encoding) 算法',
      text3:'自研高清视频编解码算法，使用基于视焦点的多层自适应视角方案。相比传统的VR自适应视角方案，能够做到更高的压缩效率，更快的视角切换，更少的带宽浪费以及更加平稳顺滑的网络状态。',
      text4:'VR视频，',
      text5:"带宽可节约高达70%",
      text6:'上行带宽节省高达70%，解决4K直播上传障碍，',
      text7:"让主播在家就可痛快高清直播",
      text8:"普通视频，",
      text9:"720p仅需600Kbps",
      text10:'下行带宽节省高达70%，解决用户端',
      text11:"流畅看高清的难题，在家即可享受VR直播的乐趣",
      text12:"超低视角切换延迟,",
      text13:"稳定高效传输",
      text14:'威尔云拥有强大稳定的传输能力，',
      text15:'满足高并发、低延迟的极端要求',
      text18:'智能编解码',
      text19:'机器学习大数据',
      text20:'威尔云可以智能判断视频内容来适配最优算法，',
      text21:'更多数据，更大编解码优化空间。',
      text23:"专利音频编解码，动态还原3D音效<br>（Coming soon）",
      text24:"威尔云可将3D空间音效，以极低码率同时又高保真的独特编码，并动态还原在VR世界中",
      text25:"下载体验Demo App",
      text26:"马上体验威尔云服务提供的秀场、电竞和体育等VR视频样片。",
      text27:"下载Demo",
      text28:'应用场景',
      text30:"每个像素都被等同对待<br>和大脑的视觉观看主观特性无关",
      text31:"根据视焦点来动态分配像素<br>更符合人的主观观感质量",
      text32:'了解算法原理详情：<br><a href="https://www.vrviu.com/sdk/document/Improving Network Bandwidth Usage with Foveated encoding(1).pdf" target="_blank" style="color:#0084ff">Improving Network Bandwidth Usage with Foveated encoding.pdf</a>'


    },
        solution3: {
        name:"2D高清视频",
        name1:"VR直播／点播",
        name2:"VR秀场直播",
        banner_text:"更低带宽消耗<br>高清流畅体验",
        banner_botton:"下载Demo",
        title1:"2D高清视频：720P仅需600Kbps",
        text1:'针对高清2D视频内容，例如秀场直播、第一人称射击游戏直播等，威尔云通过对视频内容的智能编解码，大幅度降低带宽消耗，带来前所未有的高清流畅播放体验。',
        text2:'',
        text3:"威尔直播云服务",
        text4:'秀场直播',
        text5:'秀场VR直播，支持实时美颜和滤镜，<br>与主播近距离互动。',
        text6:'小视频点播',
        text7:'体育VR直播，以全新视角零距离观<br>看体育明星的表演',
        text8:'游戏直播',
        text9:'演出VR直播，独享演唱会的VIP坐席',
        text10:'360°全景：视角切换延迟零延迟',
        text11:"360° VR直播适合大场面、全方位的游戏、赛事、",
        text12:"旅行及演唱会，带来身临其境的体验",
        text13:'游戏VR直播',
        text14:'游戏VR直播，让观众可以身临虚拟世界，近距离观摩高手之间的较量，感受惊心动魄的一刻。',
        text15:'新闻VR直播',
        text16:'新闻VR直播，带你去现场，不错过任何精彩',
        text17:'旅行VR直播',
        text18:'旅行VR直播，与主播一同攀登珠峰，深潜海底，环游世界。',
        text19:'威尔云 6 大特性',
        text20:'低带宽',
        text21:'带宽节省高达70%，让高清与流畅并存',
        text22:'标准协议',
        text23:'优于业界金字塔、八面体等算法，切换延迟低至毫秒级',
        text24:'低成本',
        text25:'智能视频编解码，支持中低端手机上的4K播放',
        text26:'秒开',
        text27:'使用标准RTMP流，支持DASH、HLS等多种传输协议',
        text28:"低功耗",
        text29:'高并发，7x24稳定直播',
        text30:'多终端适配',
        text31:"支持Android/iOS/H5/Gear VR等多平台播放",
        text32:'核心技术',
        text33:'多平台适配',
        text34:'免费试用',
        text35:'常见问答',
     text36:'威尔云的高清2D视频解决方案适合怎样的应用场景？',
        text37:"我们的2D解决方案推荐应用在有视焦点的视频内容上。我们的算法可以动态识别图像内容，发挥最优的效果。例如，秀场直播，第一人称射击游戏直播等内容。",
        text38:"是否支持推流软件端的压缩传输？",
        text39:"威尔云目前只支持在服务器端的压缩传输。",
        text40:'威尔云转码服务是如何工作的？',
        text41:'针对转码场景，可以有多码率，多种分辨率；针对不转码场景，有单一码率，单一分辨率。同时我们支持算法开关，可以根据内容需要选择开启威尔云服务或关闭，最大程度节省带宽并利用服务器资源。',
        text42:"是否支持H.265视频编码？",
        text43:"威尔云同时支持H.264和H.265视频压缩编码。",
        text44:'更多问题？',
        text45:'联系我们',
        text46:"",
        text47:"是否支持Web/H5网页内的播放？",
        text48:"威尔云支持H5的高清播放，便于分享和传播。"
      },
        download: {
          title: "LightVR App",
          text: "下载即可体验威尔云技术处理后，多种VR场景下(包括秀场、游戏、体育、）适用的视频。"
        },
        join: {
      name:"加入我们",
      text1:"让每个人都能享受VR直播的乐趣",
      text2:"我们致力于“VR高速公路”的建设，让用户在现有的带宽和技术条件下,",
      text3:"享受到身临其境的VR体验。",
      text4:"创始团队",
      text5:'我们总部位于深圳南山科技园，并在美国硅谷设有研究院 VRVIU，核心技术团队来自SIE、腾讯、Harmonic等世界顶级公司，拥有领先业界的音视频编解码专利算法技术、3D游戏和数字场景重构技术。',
      text6:"效率",
      text7:"扁平化管理<br>弹性工作时间",
      text8:"成长",
      text9:"导师培养机制<br>赴美交流机会",
      text10:"欢乐",
      text11:"灵活办公，定期团建<br>带薪休假10-15天",
      text12:'与威尔直播一起创造',
      text13:"在威尔直播，每个人都是创造者。扁平化的管理让所有人的想法都能发声，共同实现属于我们的VR梦想。",
      text14:"学习成长",
      text15:'VRVIU关注每个员工的成长，全公司采用导师培养机制，更有机会赴美交流，与硅谷技术大神一起工作学习。',
      text16:"创始团队"
    },
        software: {
          name:"软件下载",
          download: "立即下载",
          banner_text: "软件下载",
          introduction_title: "LightVR App",
          introduction_title2: "（享受威尔云带来的高清VR体验）",
          product_title1: "Cardboard<span class='platform_info2'>（Android）</span>",
          product_vison1: "版本号：2.5",
          product_date1: "更新日期：2018-10-19",
          product_title2: "LightVR for Pico",
          product_vison2: "版本号：2.5",
          product_date2: "更新日期：2018-11-05",
          product_title3: "LightVR 小程序",
          product_vison3: "版本号：2.1",
          product_date3: "更新日期：2018-11-26",
          product_title4: "LightVR for Vive",
          product_vison4: "敬请期待",
          product_date4: "",
          product_title5: "LightVR for Oculus",
          product_vison5: "敬请期待",
          product_date5: "",
          product_title6: "LightVR for MiVR",
          product_vison6: "敬请期待",
          product_date6: "",
          introduction_title3: "LightEncoder",
          introduction_title4: "（8K VR视频本地转码工具)",
          product_title7: "LightEncoder<span class='platform_info2'>（Windows）</span>",
          product_vison7: "版本号：1.1",
          product_date7: "更新日期：2018-12-10",
          product_title8: "LightEncoder<span class='platform_info2'>（Linux）</span>",
          product_vison8: "敬请期待",
          product_date8: "",
          introduction_title5: "VBS直播套件 ",
          introduction_title6: "（180°2D/3D VR 直播推流解决方案）",
          product_title9: "推流端软件<span class='platform_info2'>（Windows）</span>",
          product_vison9: "版本号：1.0",
          product_date9: "更新日期：2018-05-11",
          product_title10: "播放端软件<span class='platform_info2'>（Android）</span>",
          product_vison10: "版本号：1.0",
          product_date10: "更新日期：2018-05-11",
          introduction_text: "LightEncoder 尚处于 Beta 测试阶段，采用授权码激活可用时长，<br>请联系我们获取授权码"

        }


}



/***/ }),
/* 110 */
/***/ (function(module, exports) {

module.exports =  {
    header:{
            nav1:"Home",
            nav2:"Solutions",
            nav3:"Technology",
            nav4:"Downloads",
            nav5:"About Us",
            nav7:"Team",
            nav6:"Join Us",
            nav8:"VR Live/VOD",
            nav9:"VR Personal Webcasts",
            nav10:"High-Definition 2D Video",
            nav11:"Products",
            nav12:"VRVIU Cloud Service",
            nav13:"LightVR",
            nav14:"LightEncoder",
            nav15:"Player SDK",
            nav16:"Software Download",
            nav17:"SDK Download",
            navBtn:"More information"
          },
          text1:"Contact Us",
          text2:'Please leave your contact information,',
          text3:'we will contact you within 1 business day.<span style="color:#ff5959;vertical-align:middle">*</span>Required',
          text4:"Company Name",
          text5:'Full Name',
          text6:"Phone",
          text7:"Email Address",
          error:"Oops! Error occured, please try again later.",
          error503:"Oops! Error occured, please try again later.",
          error409:"Your submission has been received.",
          send:"Submit",
          text8:"Success",
          text9:"We've received your request, and will get in touch with you soon.",
          text10:"OK",
    join: {
      name:"Join Us",
      text1:"Everyone Can Enjoy<br>the Excitement of VR Live",
      text2:"Our revolutionary video compression and streaming technology will bring bandwidth-hungry video",
      text3:"to the global mass market while overcoming current internet infrastructure constraints.",
      text4:"Founding Team",
      text5:"Headquartered in Shenzhen, China, with a cutting-edge research lab in Silicon Valley, our core R&D members come from SIE, Tencent, Microsoft, and Harmonic. Applying our vast experience in VR, we have built a revolutionary VR live streaming technology that has truly advanced the well-established video streaming industry beyond imagination.",
      text6:"Finance",
      text7:"Stock options<br>401K match",
      text8:"Balance",
      text9:"Flexible work hours<br>Paid time off",
      text10:"Health",
      text11:"Sick & personal leave<br>Medical insurance",
      text12:'Create with VRVIU',
      text13:"At VRVIU, everyone is a creator. The flat management allows everyone’s voice to be heard while creating our VR dream together.",
      text14:"Learn and Grow",
      text15:'VRVIU cares about your personal growth. We offer a mentoring program, as well as the opportunity to work with industry leading experts in Silicon Valley.',
      text16:"Team"
    },
    footer:{
      text1:"Phone (General):  ",
      text2:'86 755 8695 6559',
      text3:'Phone (Business):',
      text4:"86 755 8696 0615",
      text5:'Email: ',
      text6:"business@vrviu.com",
      text7:'Address: 130 El Camino Real, Millbrae, CA 94030, USA<br>1-2 F, Tefa Info Tech Bldg, Qiongyu Rd, Nanshan, Shenzhen',
      text8:'<a href="http://www.vrviu.com/sdk/document/威尔云使用条款与法律声明.pdf" style="text-decoration: underline;color:#454545" download="威尔云使用条款与法律声明.pdf">Terms & Policies</a><br>© 2016-2018 VRVIU All Rights Reserved.'
    },
    features: {
      name:'Player SDK',
      banner_text:"Turn-key Solution for 8K",
      banner_text1:"VR Video Streaming",
      banner_button:"Free Download",
      text1: "Player SDK",
      text2: "Smooth streaming available 24/7",
      text3: "High performance, low power",
      text4: "Instant start-up, smooth playback",
      text5: "Cross-platform SDK",
      text6: "VR Video Player SDK",
      text7: "WebVR Video Player SDK",
      text8: "2D Video “High Resolution in Low Bandwidth” Player SDK",
      text9: "Support multiple face beautifying filters",
      text10: "2017.09.30: Push Stream Client SDK V0.6 officially released",
      text11: "Download",
      text12: 'VR Video Web Playback SDK',
      text13: 'Highly customized player UI',
      text14: "Support 360° 2D/3D, 180° 3D multi formats",
      text15: "Support drag&drop gestures and gyroscope <br>Support WeChat, QQ, Chrome, Safari and <br>main platforms",
      text16: "2018.03.08: Web VR Player SDK V1.0 officially released",
      text17: "FAQs",
      text18: "Is there a way to use VRVIU algorithm without the player SDK?",
      text19: "Our FE algorithm is highly efficient on the encoding side with the H.264/H.265 optimization. Accordingly, the player side also needs corresponding decoding. For these above reasons, the player side needs to use the VRVIU SDK.",
      text20: "How big is the app size increase after player SDK integration?",
      text21: "Our core SDK is approximately 1M. The final app size increase depends on both your choice of our product and your current app technology adoption.",
      text22: "Contact Us",
      text23: "Android",
      text111: "SDK Download",
      text112: "Documentation",
      text113: "Web Demo",
                table1: {
                        title: "VR Video Player SDK",
                        label1: "Maximum Resolutioin",
                        label11: "Audio/Video Codec",
                        label12: "Transmission Protocol",
                        label13: "Video Format",
                        label14: "Projection Format",
                        label15: "Playback Mode",
                        label16: "Decoding Mode",
                        label17: "Platform",
                        label18: "Chipset",
                        label19: "Devices",
                        label10: "Patented FE Algorithm",
                        text1: "VR video 8192*8192@60fps",
                        text102: "2D video 3840*3840@60fps",
                        text103: "",
                        text2: "H.264 | H.265 | AAC",
                        text3: "RTMP | HTTP MP4 | HTTP FLV | HLS",
                        text4: "180° 3D | 360° 2D | 360° 3D",
                        text5: "Equirectangular | Fisheye",
                        text6: "Live streaming | Video-on-Demand",
                        text7: "Hardware | Software",
                        text8: "ARMV7 | ARM64 | X86",
                        text9: "Qualcomm 820+ | Allwinner VR9 | Samgsung8890+",
                        text10: "GearVR | Oculus Go | XIAOMI | Pico | HTC VIVE | DPVR | 3Glasses | Cardboard",
                        text11: "Bandwidth save up to 75%，only need 20Mbps for 8K video"
                      },
                      table2: {
                        title: "WebVR Video Player SDK",
                        label1: "Maximum Resolutioin",
                        label2: "Audio/Video Codec",
                        label3: "Video Format",
                        label4: "Playback Mode",
                        label5: "Playback Operation",
                        label6: "Playback Platform",
                        label7: "UI",
                        label8: "Patented FE Algorithm",
                        text1: "3840*1920@30fps",
                        text2: "H.264 | H.265 | AAC",
                        text3: "180° 3D | 360° 2D | 360° 3D",
                        text4: "Live streaming | Video-on-Demand",
                        text5: "drag&drop gestures and gyroscope",
                        text6: "Support for mainstream web browser",
                        text7: "Customized based on needs",
                        text8: "Yes"
                      },
                      table3: {
                        title: "2D Video “High Resolution in Low Bandwidth” Player SDK",
                        label1: "Maximum Resolutioin",
                        label2: "Audio/Video Codec",
                        label3: "Playback Mode",
                        label4: "Decoding Mode",
                        label5: "Transmission Protocol",
                        label6: "Instant start-up",
                        label7: "Platform",
                        label8: "Patented FE Algorithm",
                        text1: "3840*2160",
                        text2: "H.264 | H.265 | AAC",
                        text3: "Live streaming | Video-on-Demand",
                        text4: "Hardware | Software",
                        text5: "RTMP | HTTP MP4 | HTTP FLV | HLS ",
                        text6: "First screen instant start-up",
                        text7: "Android | iOS | HTML5",
                        text8: "Bandwidth save up to 40%, 600Kbps for 720p@H.265"
                      }
    },
    about: {
      name:"About Us",
      text1:"Everyone Can Enjoy<br>the Excitement of VR Live",
      text2:"Our revolutionary video compression and streaming technology will bring bandwidth-hungry video",
      text3:"to the global mass market while overcoming current internet infrastructure constraints.",
      text4:"Team",
      text5:"Headquartered in Shenzhen, China, with a cutting-edge research lab in Silicon Valley, our core R&D members come from SIE, Tencent, Microsoft, and Harmonic. Applying our vast experience in VR, we have built a revolutionary VR live streaming technology that has truly advanced the well-established video streaming industry beyond imagination.",
      text6:"Founder & CEO",
      text7:"Co-Founder",
      text8:"CPO",
      text9:"Director of Human Resources",
      text10:"Join Us"
    },
    download: {
      title: "LightVR App",
      text: "Experience our quality 4K streaming in sporting events, concerts, and eSports through our demo."
    },
    index: {
      header: {
        nav1: "Home",
        nav2: "Solutions",
        nav3: "Technology",
        nav4: "Developer",
        nav5: "About Us",
        nav6: "Join Us",
        nav7: 'Team',
        navBtn: "Sign in",
        navBtn2: "Sign up",
        nav10: "VR Live/VOD",
        nav11: "VR Personal Webcasts",
        nav12: "High-Definition 2D Video",
        nav13: "Console",
        nav14: "Logout"
      },
      text1: "Contact Us",
      text2: 'Please leave your contact information,',
      text3: 'we will contact you within 1 business day.<span style="color:#ff5959;vertical-align:middle">*</span>Required',
      text4: "Company",
      text5: 'Name',
      text6: "Phone",
      text7: "Email",
      error: "Oops! Error occured, please try again later.",
      error503: "Oops! Error occured, please try again later.",
      error409: "Your submission has been received.",
      send: "Submit",
      text8: "Success",
      text9: "We've received your request, and will get in touch with you soon.",
      text10: "OK"
    },
    product: {
      name: "LightVR",
      banner_text: "Turn-key Solution for 8K ",
      banner_text2: 'VR Video Streaming',
      banner_botton: "Free Download ",
      introduction_title: "LightVR 8K Player",
      introduction_text11: "Enjoy quality 8K VR video either streaming online or playing offline",
      introduction_text12: "Bring iMax big screen and Ultra HD video to VR",
      introduction_text13: "Switch between multiple playlists adapted to various scenarios",
      introduction_title2: "LightVR Wechat Mini-Program",
      introduction_title3: "Key Functions",
      introduction_text2: "Experience VR video with Wechat",
      introduction_text21: "Enjoy 4K quality VR on mobile phone",
      introduction_text22: "Play by video id or playlist id",
      introduction_text23: "Support VR mode and Full-screen mode",
      introduction_text24: "Share with friends",
      introduction_title4: "Supported devices",
      platform_pic1: "Cardboard",
      platform_pic2: "Pico",
      platform_pic3: "小米VR",
      platform_pic4: "HTC Vive",
      platform_pic5: "Oculus",
      platform_pic6: "微信小程序",
      introduction_title5: 'Want to customize player?',
      text45: "Contact Us"
    },
    technology: {
      name:"Technology",
      text1:'Patented FE (Foveated Encoding) Algorithms',
      text2:"Patented FE (Foveated Encoding) <br>Algorithms",
      text3:'VRVIU invented a multi-layer based view adaptation scheme based on foveal vision,with more efficient compression, faster view switch, less bandwidth waste and smoother network traffic.',
      text4:"VR Videos，",
      text5:'Bandwidth Saved <br>Up to 70%',
      text6:"Upload Bandwidth savings of 70%",
      text7:"will ease the uploading of 4K VR personal webcasts.",
      text8:"2D Videos,",
      text9:"600Kbps for 720p",
      text10:'Download Bandwidth savings of 70%',
      text11:"will enable smooth 4K+ VR on mobile connections.",
      text12:'Zero-perceived',
      text13:"View Switching Latency",
      text14:"Stable, 24/7, high concurrent streaming",
      text15:"at a large scale, ultra-low network round",
      text16:'trip latency required for interactive',
      text17:"personal webcasts.",
      text18:"Intelligent Codec,",
      text19:'Machine Learning on Cloud',
      text20:"VRVIU Cloud can smartly select the best suitable algorithm based<br>on the video content. The more data input,the more efficient the<br>codec become.",
      text21:'',
      text22:'',
      text23:"Our Patented Audio Streaming<br>Technology Dynamically Reproduces<br>3D Sound in VR",
      text24:'Cloud-based audio encoding scheme uniquely produces low bit rates with high fidelity 3D live sound in VR.',
      text25:"Try Demo",
      text26:"Experience our quality 4K streaming in sporting events, concerts, and eSports through our demo.",
      text27:'Try Demo',
      text28:"Learn More",
      text30:'Every pixel is treated <br>equally',
      text31:"Dynamically distribute pixels<br> based on foveal vision",
      text32:'Learn more about FE algorithms:<br> <a href="https://www.vrviu.com/sdk/document/Improving Network Bandwidth Usage with Foveated encoding(1).pdf" target="_blank" style="color:#0084ff">Improving Network Bandwidth Usage with Foveated encoding.pdf</a>'
    },
    solution3: {
        name:"High-Definition 2D Video",
        name1:"VR Live/VOD",
        name2:"VR Personal Webcasts",
        banner_text:"Lower Bandwidth Cost<br>Better Streaming Experience",
        banner_botton:"Try Demo",
        title1:'High-Definition 2D Video: 600Kbps for 720P, Smoother Playback',
        text1:'Tailored for personal webcasts and FPS games, VRVIU helps you save bandwidth cost up to 40% with our intelligent codec.',
        text2:"",
        text3:"VRVIU Cloud",
        text4:'Personal Webcasts',
        text5:'Our VR personal webcasts offer many popular options such as built-in, real-time beautification filters and digital makeup.',
        text6:"Video Clips",
        text7:'Experience live sports events in ways you never could before!',
        text8:"Live Games",
        text9:'Your front row seat for live concerts in VR',
        text10:'360° VR: Zero-perceived View<br>Switching Latency',
        text11:'For larger events such as concerts, eSports, sporting<br>events, or tourism experiences, 360° VR livestreaming<br>brings the experience of "being there".',
        text12:'',
        text46:"",
        text13:"Personal Webcasts",
        text14:"Viewers will enjoy the panoramic battlefield view by bringing 360° views to traditional 2D eSports.",
        text15:'Video Clips',
        text16:'Experience live news in the field with 360° views.',
        text17:'Live Games',
        text18:'VR Live Travel: Climb mountains, dive into deep waters, and tour the world with your travel host.',
        text19:"VRVIU Cloud Main Features",
        text20:'Low Bandwidth',
        text21:'Bandwidth requirements<br>reduced by 70%',
        text22:'Standard Protocols',
        text23:'Patented “zero-perceived<br>latency” technology',
        text24:'Low Cost',
        text25:'Intelligent video decoding<br>on low-end mobile phones',
        text26:'Instant Startup',
        text27:'Support for RTMP,<br>DASH, and HLS',
        text28:"Low Power",
        text29:'highly concurrent,<br>7x24 stable streaming',
        text30:'Cross-platform',
        text31:"Support Android,<br>iOS, HTML5 and Gear VR",
        text32:"Technology",
        text33:'Cross-platform',
        text34:'Free Trial',
        text35:'FAQs',
        text36:"What are the recommended scenarios for VRVIU high-definition 2D video turn-key solution?",
        text37:"Our 2D solution can maximum its effort for contents having foveal vision, for example, personal webcasts and FPS games.",
        text38:"Does the solution support codec compression within the push stream software?",
        text39:"VRVIU currently only supports codec compression on cloud.",
        text40:"How does codec work?",
        text41:"VRVIU supports multi bitrates formats and resolutions for compressed content, and single bitrates and resolution for non-compressed content. And it allows you to turn on and off for different contents and time slots, saving your bandwidth cost at a maximum level.",
        text42:"Does VRVIU support H.265 Codec?",
        text43:"VRVIU supports both H.264 and H.265 codec.",
        text44:"More questions?",
        text45:"Contact Us",
        text47:"Does it support Web/H5 streaming or live?",
        text48:"VRVIU's WebPlayer supports both VOD and live contents."

      },
    solution2: {
        name:"VR Personal Webcasts",
        name1:"VR Live/VOD",
        name2:"High-Definition 2D Video",
        banner_text:"70% Less Upload Bandwidth, Enable 4K VR Live From Home Internet",
        banner_botton:"Try Demo",
        title1:'Personal VR Webcasts: Fully Immersive Real-time Interaction',
        text1:'180° 3D webcast delivers a stunning immersive and intimate experience. Our unique wide-angle video encoding technology compresses 4K+ 3D  video at less than 720p bitrate for a smooth webcast.',
        text2:"",
        text3:"VRVIU Cloud",
        text4:'VR Live-show',
        text5:'Our VR personal webcasts offer many popular options such as built-in, real-time beautification filters and digital makeup.',
        text6:"VR Sports",
        text7:'Experience live sports events in ways you never could before!',
        text8:"VR eSports",
        text9:'Your front row seat for live concerts in VR',
        text10:'360° VR: Zero-perceived View<br>Switching Latency',
        text11:'For larger events such as concerts, eSports, sporting<br>events, or tourism experiences, 360° VR livestreaming<br>brings the experience of "being there".',
        text12:'',
        text46:"",
        text13:"VR eSports",
        text14:"Viewers will enjoy the panoramic battlefield view by bringing 360° views to traditional 2D eSports.",
        text15:'VR Live News',
        text16:'Experience live news in the field with 360° views.',
        text17:'VR Live Travel',
        text18:'VR Live Travel: Climb mountains, dive into deep waters, and tour the world with your travel host.',
        text19:"VRVIU Cloud Main Features",
        text20:'Low Bandwidth',
        text21:'Bandwidth requirements<br>reduced by 70%',
        text22:'Low Latency',
        text23:'Patented “zero-perceived<br>latency” technology',
        text24:'Low Power',
        text25:'Intelligent video decoding<br>on low-end mobile phones',
        text26:'Standard Protocols',
        text27:'Support for RTMP,<br>DASH, and HLS',
        text28:"Reliable Service",
        text29:'highly concurrent,<br>7x24 stable streaming',
        text30:'Cross-platform',
        text31:"Support Android,<br>iOS, HTML5 and Gear VR",
        text32:"Technology",
        text33:'Cross-platform',
        text34:'Free Trial',
        text35:'FAQs',
 text36:"For VR personal webcasts, is there any requirement for the upload bandwidth?",
        text37:"With VRVIU Push Stream and Player SDKs, the upload bandwidth is down to 2Mbps ~ 4Mbps.",
        text38:"Can we use our private broadcaster software for live streaming?",
        text39:"Based on open source software OBS, VRVIU redesigns and tailors OBS to VBS just for VR webcast streamers. if you want to integrating VRVIU SDK to your software,please contact us for further details.",
        text40:"Does it support Web/H5 streaming/playback?",
        text41:"VRVIU WebVR player has been developed for easy sharing and smooth playback.You can try our web demo and SDK for free.",
        text42:"Do you have any recommended 180° 3D VR camera?",
        text43:'VRVIU supports <a href="http://www.z-cam.com/180-vr-camera-k1-pro/" target="_blank" style="color:#0078e7">ZCAM K1 Pro</a> for our VR webcast solution. Google VR180 project also has some recommendations , such as <a href="http://www.yitechnology.com/180-vr-camera" target="_blank" style="color:#0078e7">YI Horizon VR180</a> ',
        text44:"More questions?",
        text45:"Contact Us"
      },
    product2: {
      name:"LightEncoder",
      banner_text: "Turn-key Solution for 8K ",
      banner_text1: 'VR Video Streaming',
      banner_botton: 'Download',
      introduction_title: "Key Functions",
      introduction_text1: "Offline transcoder using laptop or PC,",
      introduction_text2: "Eliminating the long waits for uploads and downloads",
      introduction_text3: "Customize the start and end time of video for transcoding",
      introduction_text44: "Support transcoding queues to maximize the capacity",
      introduction_title2: "System Requirements",
      introduction_text4: "CPU: Intel Core i5 processors 4 cores 3.0GHz+",
      introduction_text5: "RAM: 16 GB of system memory or above",
      introduction_text6: "Storage：100GB or above ",
      introduction_text7: "OS：Windows 7 64-bit or Windows 10 64-bit",
      text25: "Try LightEncoder",
      text26: "LightEncoder is now in beta stage",
      text28: "Please contact us for licence key to try it immediately",
      text29: "",
      text27: "Contact Us"
    },

    product3: {
      name:"VRVIU Cloud Service",
      banner_text: "Turn-key Solution for 8K ",
      banner_text1: "VR Video Streaming",
      banner_botton: "Try Now",
      introduction_title: "Key Functions",
      text20: "Support Input Video Format",
      text21: "VR 180/360, mono and stereo",
      text22: "Resolution between 3K and 8K",
      text23: "Input Codec of H.264, H.265 and VP9",
      text24: "File Size less than 10GB",
      text30: "Multiple Output Video Quality",
      text31: "FE 6K/8K provide ultimate experience",
      text32: "FE 3K/4K for online streaming",
      text33: "Standard 2.5K/3K/4K for web player",
      text40: "Content Management",
      text41: "Video editing, publishing and streaming",
      text42: "Customize playlists for business needs",
      text43: "Download 6K/8K videos and play offline",
      introduction_title2: "Why Choose Us",
      platform_pic1: "Patented FE Algorithms",
      platform_pic11: "Switching without latency",
      platform_pic12: "provide 8K VR experience",
      platform_pic2: "Support Input Format",
      platform_pic21: "VR 180/360, mono and stereo",
      platform_pic22: "Codec of H.264 | H.265 | VP9",
      platform_pic3: "Multiple Output Quality",
      platform_pic31: "FE for Ultimate experience",
      platform_pic32: "MP4 for standard player",
      platform_pic4: "Turn-key Management",
      platform_pic41: "Video editing & publishing",
      platform_pic42: "Playlists for business needs",
      text25: "Free Trial of VRVIU Cloud",
      text26: "Register and quickly experience the adavantages of",
      text27: "Try Now",
      text29:"VRVIU Cloud in transcoding bandwidth saving and smooth playback",
      text28: 'Check the<a href="" style="text-decoration: underline;  display: inline-block;vertical-align: middle;color:#fff;margin-bottom:4px;margin-left:5px;">help documentation</a>，for more questions<a href="" style="margin-left:5px;text-decoration: underline; margin-bottom:4px; display: inline-block;vertical-align: middle;color:#fff;">contact us</a>'

    },
    home: {
     index:{
            banner_title:'8K VR Video Player',
            banner_text:'New Immersive Experience',
            notice:'2018.12.10: LightEncoder V1.1 released',
            title1:"VRVIU Cloud: The Turn-key Solution for HD Video Streaming in Low Bandwidth",
            vrviu:'Learn More',
            item_title1:'Push HD <br>Boundaries',
            item_title2:'Save 70% <br>Bandwidth',
            item_title3:'Multi Scenes<br> Support',
            item_title4:'Stable Live <br>Service',
            item_text1:'Enjoy the ultimate immersive<br>experience by streaming<br>in 4K to 8K resolution',
            item_text2:'Deliver uncompromised 4K+ VR<br>streaming on mobile<br>while using 70% less data',
            item_text3:'Choose between 180º 3D<br>or 360º panoramic<br>setups to suit your content',
            item_text4:'Highly concurrent 7x24<br>smooth streaming<br>low-latency and cross-platform',
            pic_text1:'VR Personal Webcasts',
            pic_text2:'eSports VR',
            pic_text3:'VR Sports',
            pic_text4:'VR Show',
            pic_text5:'VR News',
            title2:'Various Application Scenarios',
            title3:'Seeing Is Believing',
            download_title:'View the sample 4 Mbps video, we recommend full-screen mode for more detailed comparisons.',
            download_title2:'Video source：<a href="https://www.amaze.us" class="dance_link" target="_blank">AMAZE VR | Dance with Magga</a>',
            try_download:'Try LightVR 8K Player',
            try_download_text:'Enjoy true immersive experience of  our quality 8K contents.',
            try_download_btn:'Download',
            try_free:'Try Free',
            try_free_text:'Try our VRVIU Cloud to fully experience our  ',
            try_free_text2:'superior technologies in intelligent video encoding,smooth streaming, and low power playback.',
            try_free_btn:'More information',
            friends:"Cooperative Partner"
          },
          download:'More information',
          text4:"Personal Webcasts",
          text5:"Live Games",
          text6:"Video Clips"
    },
    solution: {
        name:"VR Live/VOD",
        name1:"VR Personal Webcasts",
        name2:"High-Definition 2D Video",
        banner_text:"Say Goodbye to Blocky Images <div style='font-family: Quicksand Regular'>and Redefine VR Live</div>",
        banner_botton:"Try Demo",
        title1:'180° 3D / 360° VR: Zero-perceived View Switching Latency',
        text1:'180° 3D VR streaming delivers a stunning immersive and intimate experience, while 360° VR brings you the wholeexperience of concerts,sporting events or tourist attractions. VRVIU’s cloud-based intelligent video encoding technology offers unmatched 4K+ quality over a mobile connection with only the data cost of 720p.',
        text2:"",
        text3:"VRVIU Cloud",
        text4:'VR Live-show',
        text5:'Our VR personal webcasts offer many popular options such as built-in, real-time beautification filters and digital makeup.',
        text6:"VR Sports",
        text7:'Experience live sports events in ways you never could before!',
        text8:"VR eSports",
        text9:'Your front row seat for live concerts in VR',
        text10:'360° VR: Zero-perceived View<br>Switching Latency',
        text11:'For larger events such as concerts, eSports, sporting<br>events, or tourism experiences, 360° VR livestreaming<br>brings the experience of "being there".',
        text12:'',
        text46:"",
        text13:"VR eSports",
        text14:"Viewers will enjoy the panoramic battlefield view by bringing 360° views to traditional 2D eSports.",
        text15:'VR Live News',
        text16:'Experience live news in the field with 360° views.',
        text17:'VR Live Travel',
        text18:'VR Live Travel: Climb mountains, dive into deep waters, and tour the world with your travel host.',
        text19:"VRVIU Cloud Main Features",
        text20:'Low Bandwidth',
        text21:'Bandwidth requirements<br>reduced by 70%',
        text22:'Low Latency',
        text23:'Patented “zero-perceived<br>latency” technology',
        text24:'Low Power',
        text25:'Intelligent video decoding<br>on low-end mobile phones',
        text26:'Standard Protocols',
        text27:'Support for RTMP,<br>DASH, and HLS',
        text28:"Reliable Service",
        text29:'highly concurrent,<br>7x24 stable streaming',
        text30:'Cross-platform',
        text31:"Support Android,<br>iOS, HTML5 and Gear VR",
        text32:"Technology",
        text33:'Cross-platform',
        text34:'Free Trial',
        text35:'FAQs',
        text36:"Why do we choose VRVIU SDKs?",
        text37:"There are 2 versions of our SDK: Free version provides smooth playback of high quality VR streaming, while the paid version allows you to experience 4K low-latency VR videos with the data cost of 720p. You can download and try our free SDK, or contact us for more information about the paid version.",
        text38:"We’re already using the public cloud live treaming service. Will this stop us from integrating VRVIU Cloud VR live streaming service?",
        text39:"VRVIU supports multi CDN providers, public and private deployment. And you can decide when or which videos to use our service based on your own needs, so as to experience 4K VR at a 720p bandwidth.",
        text40:"What's the time cost of integrating VRVIU Cloud service?",
        text41:"It takes 2 minutes with supported standard protocols.",
        text42:"Is there any latency after VRVIU Cloud integration?",
        text43:"The latency is equal to or less than 1 second within VRVIU Cloud system, and there's no volatility during the view switching process. The live streaming transmission latency is determined by video stream codec parameters and the network environment.",
        text44:"More questions?",
        text45:"Contact Us"
      },
    devolop: {
      name:"SDK Download",
      title1: "SDK Download",
      title2: "VR Video Player SDK",
      title3: "(VRVIU BitPlayer SDK)",
      title4: "Unity",
      version1: "Version：V2.8",
      date1: "updated：2018.11.08",
      button1: "Documentation",
      button2: "SDK download",
      title55: "HTML5",
      version2: "updated：2018.05.17",
      date2: "2018.07.27",
      title5: "High-Definition 2D Player SDK",
      title6: "（VRVIU AltPlayer SDK）",
      title7: "iOS",
      version3: "Version：V1.3",
      date3: "updated：2018.04.19",
      title8: "Android",
      Version4: "Version：V1.3",
      date4: "updated：2018.04.28",
      title9: "HTML5",
      version5: "Version：V1.0",
      date5: "updated：2018.05.07",
      title10: "4K VR Personal Webcasts Software",
      title11: "（VBS）",
      title12: "Install on PC",
      version6: "Version：V1.0",
      date6: "updated：2018.05.11",
      title13: "View on Android phone",
      version7: "Version：Android V1.0",
      date7: "updated：2018.05.04",
      button3: "Try now",
      button4: "Download",
      button5: "Coming Soon",
      title14: "LightVR App",
      title15: "（Download to experience our quality 4K VR video streaming）",
      title16: "Cardboard for Android",
      Version8: "Version：V1.2",
      date8: "updated：2018.05.02",
      title17: "Cardboard for iOS",
      version9: "",
      date9: ""
    },
    software: {
      name:"Software Download",
      download: "download",
      banner_text: "Software Download",
      introduction_title: "LightVR App",
      introduction_title2: "Experience our quality 8K  VR video <br>streaming of VRVIU Cloud",
      product_title1: "Cardboard<span class='platform_info2'>（Android）</span>",
      product_vison1: "Version：2.5",
      product_date1: "updated：2018-10-19",
      product_title2: "LightVR for Pico",
      product_vison2: "Version：2.5",
      product_date2: "updated：2018-11-05",
      product_title3: "Mini Program",
      product_vison3: "Version：2.1",
      product_date3: "updated：2018-11-26",
      product_title4: "LightVR for Vive",
      product_vison4: "Coming soon",
      product_date4: "",
      product_title5: "LightVR for Oculus",
      product_vison5: "Coming soon",
      product_date5: "",
      product_title6: "LightVR for MiVR",
      product_vison6: "Coming soon",
      product_date6: "",
      introduction_title3: "LightEncoder",
      introduction_title4: "（8K VR-Video Transcoding Tool)",
      product_title7: "LightEncoder<span class='platform_info2'>（Windows）</span>",
      product_vison7: "Version：1.1",
      product_date7: "updated：2018-12-10",
      product_title8: "LightEncoder<span class='platform_info2'>（Linux）</span>",
      product_vison8: "Coming soon",
      product_date8: "",
      introduction_title5: "VBS",
      introduction_title6: "VR Personal Webcast Software",
      product_title9: "VBS for Windows",
      product_vison9: "Version：1.0",
      product_date9: "updated：2018-05-11",
      product_title10: "View on Android Phone",
      product_vison10: "Version：1.0",
      product_date10: "updated：2018-05-11",
      introduction_text: "LightEncoder is now in the beta stage，and can be activated<br> with license key Please contact us to get the key"

    }


}



/***/ }),
/* 111 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[34]);


// WEBPACK FOOTER //
// static/js/app.3ece31c85ca2577174f2.js